/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			modules[moduleId] = moreModules[moduleId];
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "front/js/" + chunkId + "." + "f56a2" + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(2);
	
	__webpack_require__(110);
	
	__webpack_require__(112);
	
	__webpack_require__(117);
	
	__webpack_require__(127);
	
	__webpack_require__(130);
	
	__webpack_require__(135);
	
	__webpack_require__(139);
	
	__webpack_require__(146);
	
	__webpack_require__(180);
	
	__webpack_require__(203);
	
	__webpack_require__(208);
	
	__webpack_require__(211);
	
	__webpack_require__(214);
	
	__webpack_require__(217);
	
	__webpack_require__(221);
	
	__webpack_require__(224);
	
	__webpack_require__(231);
	
	__webpack_require__(239);
	
	__webpack_require__(242);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function () {
	  //
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	__webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function () {
	    setTimeout(function () {
	        _Sloth2.default.init();
	    });
	});
	
	exports.default = _Sloth2.default;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// 获取函数的函数名, 为了兼容IE8
	function functionName(fun) {
	    var ret = fun.toString();
	    ret = ret.substr('function '.length);
	    ret = ret.substr(0, ret.indexOf('('));
	    return ret;
	}
	
	var Sloth = function () {
	    function Sloth() {
	        _classCallCheck(this, Sloth);
	
	        this.selector = 'component';
	        this.components = [];
	    }
	
	    Sloth.prototype.init = function init() {
	        var _this = this;
	
	        (0, _jquery2.default)('[' + this.selector + ']').each(function (index, dom) {
	            var moduleName = (0, _jquery2.default)(dom).attr(_this.selector);
	            var Component = _this.getComponent(moduleName);
	
	            _this.initDom(dom, Component);
	        });
	    };
	
	    Sloth.prototype.initDom = function initDom(dom, Component) {
	        if (_typeof(dom.component) === 'object') {
	            return;
	        } // 防止重复初始化组件
	        if (!Component) {
	            return;
	        } // 未找到对应组件
	
	        var instance = new Component();
	        instance.dom = dom;
	        instance.options = Object.assign({}, Component.defaultOptions, (0, _jquery2.default)(dom).options());
	        instance.onInit();
	        dom.component = instance;
	    };
	
	    // Decorator
	
	
	    Sloth.prototype.component = function component(options) {
	        var _this2 = this;
	
	        return function (component) {
	            component.defaultOptions = options.defaultOptions;
	            _this2.addComponent(component);
	        };
	    };
	
	    Sloth.prototype.addComponent = function addComponent(component) {
	        component.componentName = functionName(component);
	        this.components.push(component);
	    };
	
	    Sloth.prototype.getComponent = function getComponent(componentName) {
	        for (var i = 0; i < this.components.length; i++) {
	            if (this.components[i].componentName === componentName) {
	                return this.components[i];
	            }
	        }
	    };
	
	    Sloth.prototype.removeComponent = function removeComponent(componentName) {
	        for (var i = 0; i < this.components.length; i++) {
	            if (this.components[i].componentName === componentName) {
	                this.components.splice(i, 1);
	            }
	        }
	    };
	
	    Sloth.prototype.isMobile = function isMobile() {
	        return document.body.clientWidth < 960;
	    };
	
	    return Sloth;
	}();
	
	exports.default = new Sloth();

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//获取标签所有属性,返回键值对
	_jquery2.default.fn.options = function () {
	    var dom = this[0];
	    return (0, _jquery2.default)(dom).attrs("opt");
	};
	
	_jquery2.default.fn.attrs = function (attrName) {
	    var dom = this[0];
	    var attributes = dom.attributes,
	        opts = {};
	    for (var i = 0; i < attributes.length; i++) {
	        var attribute = attributes[i];
	        if (_jquery2.default.trim(attribute.name.substr(0, attrName.length + 1)).toLowerCase() === attrName + "-") {
	            opts[attribute.name.substr(attrName.length + 1)] = str2realType(attribute.value);
	        }
	    }
	    return opts;
	};
	
	//将字符串转成最接近的数据类型
	var str2realType = function str2realType(val) {
	    if (typeof val !== 'string') return val;
	
	    val = _jquery2.default.trim(val);
	    if (parseInt(val).toString() === val) return parseInt(val);
	    if (parseFloat(val).toString() === val) return parseFloat(val);
	    if (typeof val === 'string' && val.toLowerCase() === 'true') return true;
	    if (typeof val === 'string' && val.toLowerCase() === 'false') return false;
	    if (typeof val === 'string' && val.substr(0, 1) === "{") return JSON.parse(val);
	
	    return val;
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	
	__webpack_require__(11);
	
	__webpack_require__(21);
	
	__webpack_require__(24);
	
	__webpack_require__(27);
	
	__webpack_require__(29);
	
	__webpack_require__(31);
	
	__webpack_require__(34);
	
	__webpack_require__(36);
	
	__webpack_require__(39);
	
	__webpack_require__(42);
	
	__webpack_require__(44);
	
	__webpack_require__(46);
	
	__webpack_require__(54);
	
	__webpack_require__(59);
	
	__webpack_require__(61);
	
	__webpack_require__(64);
	
	__webpack_require__(66);
	
	__webpack_require__(69);
	
	__webpack_require__(72);
	
	__webpack_require__(76);
	
	__webpack_require__(81);
	
	__webpack_require__(83);
	
	__webpack_require__(87);
	
	__webpack_require__(101);
	
	__webpack_require__(105);
	
	__webpack_require__(106);

/***/ },
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(12);
	
	__webpack_require__(18);
	
	__webpack_require__(19);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Carousel = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        width: null,
	        visible: 1,
	        scroll: null, // 每次滚动的个数, 默认一屏
	        height: 'variable',
	        auto: true,
	        pauseOnHover: true,
	        time: 5000,
	        duration: 500
	    }
	}), _dec(_class = function () {
	    function Carousel() {
	        _classCallCheck(this, Carousel);
	    }
	
	    Carousel.prototype.onInit = function onInit() {
	        var dom = this.dom;
	        var options = this.options;
	        var onCurrentChange = options.visible > 1 ? _jquery2.default.noop : function () {
	            (0, _jquery2.default)('ul', dom).triggerHandler('currentVisible', function (item) {
	                if (!item || item.length === 0) {
	                    return;
	                }
	                var binds = (0, _jquery2.default)(item).attrs('data');
	                for (var key in binds) {
	                    if (_jquery2.default.prototype.hasOwnProperty.call(binds, key)) {
	                        (0, _jquery2.default)('[data-bind=\'' + key + '\']', dom).html(binds[key]);
	                    }
	                }
	                (0, _jquery2.default)('[data-link]', dom).attr('href', (0, _jquery2.default)('a', item).attr('href'));
	            });
	            (0, _jquery2.default)('ul', dom).trigger('currentChange');
	        };
	        this.pluginIntro();
	        this.pluginExif();
	
	        if (options.visible > 1) {
	            (0, _jquery2.default)('.Carousel-pic', dom).css({
	                'margin-left': '-15px',
	                'margin-right': '-15px'
	            });
	            (0, _jquery2.default)('ul li', dom).css({
	                'padding-left': '15px',
	                'padding-right': '15px'
	            });
	        }
	
	        (0, _jquery2.default)('ul', dom).carouFredSel({
	            auto: {
	                play: options.auto,
	                pauseDuration: options.pauseduration,
	                timeoutDuration: options.time
	            },
	            responsive: true,
	            width: '100%',
	            height: 'variable',
	            onCreate: onCurrentChange,
	            scroll: {
	                pauseOnHover: options.pauseOnHover,
	                onAfter: onCurrentChange,
	                duration: options.duration,
	                items: options.scroll || undefined
	            },
	            items: {
	                visible: options.visible,
	                width: options.width,
	                height: options.height
	            },
	            swipe: {
	                onTouch: true
	            },
	            pagination: (0, _jquery2.default)('.Carousel-pager', dom),
	            prev: (0, _jquery2.default)('.Carousel-prev', dom),
	            next: (0, _jquery2.default)('.Carousel-next', dom)
	        });
	
	        this.adjustBtnPosition();
	        (0, _jquery2.default)('ul', dom).trigger('updateSizes'); // 最后调整下
	    };
	
	    Carousel.prototype.adjustBtnPosition = function adjustBtnPosition() {
	        var dom = this.dom;
	        var options = this.options;
	
	        if (options.visible === 1) {
	            return;
	        }
	        var textHeight = parseInt((0, _jquery2.default)('ul', dom).css('height')) - parseInt((0, _jquery2.default)('.Carousel-pic img', dom).eq(0).css('height'));
	        var selfHeight = (0, _jquery2.default)('.Carousel-prev', dom).height();
	        (0, _jquery2.default)('.Carousel-prev, .Carousel-next', dom).css({
	            'margin-top': 0 - selfHeight / 2 - textHeight / 2
	        });
	        (0, _jquery2.default)('.Carousel-pic li', dom).css({
	            'padding-left': 15,
	            'padding-right': 15
	        });
	    };
	
	    Carousel.prototype.pluginExif = function pluginExif() {
	        var _this = this;
	
	        if ((0, _jquery2.default)('.CarouselPluginExif', this.dom).length === 0) {
	            return;
	        }
	        (0, _jquery2.default)('.CarouselPluginExif', this.dom).each(function (index, obj) {
	            (0, _jquery2.default)('.CarouselPluginExif-button', obj).on('click', function () {
	                (0, _jquery2.default)('.CarouselPluginExif', _this.dom).toggleClass('CarouselPluginExif_hide');
	            });
	        });
	    };
	
	    Carousel.prototype.pluginIntro = function pluginIntro() {
	        if ((0, _jquery2.default)('.CarouselPluginIntro', this.dom).length === 0) {
	            return;
	        }
	        var that = this;
	        (0, _jquery2.default)('.CarouselPluginIntro-num .total', this.dom).html((0, _jquery2.default)('.Carousel-pic li', this.dom).length);
	        (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).on('click', function () {
	            var isOpen = !(0, _jquery2.default)(this).hasClass('CarouselPluginIntro-toggle_up');
	            if (isOpen) {
	                that.collapse(this.dom);
	            } else {
	                that.expend(this.dom);
	            }
	        });
	        (0, _jquery2.default)('ul', this.dom).on('currentChange', function () {
	            that.onChange(this.dom);
	        });
	    };
	
	    Carousel.prototype.collapse = function collapse() {
	        (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).addClass('CarouselPluginIntro-toggle_up');
	        (0, _jquery2.default)('.CarouselPluginIntro-summary', this.dom).slideUp();
	        (0, _jquery2.default)('.CarouselPluginIntro-num', this.dom).addClass('CarouselPluginIntro-num_small');
	    };
	
	    Carousel.prototype.expend = function expend() {
	        (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).removeClass('CarouselPluginIntro-toggle_up');
	        (0, _jquery2.default)('.CarouselPluginIntro-summary', this.dom).slideDown();
	        (0, _jquery2.default)('.CarouselPluginIntro-num', this.dom).removeClass('CarouselPluginIntro-num_small');
	    };
	
	    Carousel.prototype.onChange = function onChange() {
	        var currentPosition = (0, _jquery2.default)('ul', this.dom).triggerHandler('currentPosition');
	        (0, _jquery2.default)('.CarouselPluginIntro-num .current', this.dom).html(currentPosition + 1);
	        if ((0, _jquery2.default)('.CarouselPluginIntro-summary', this.dom).html() === '') {
	            (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).hide();
	            (0, _jquery2.default)('.CarouselPluginIntro-num', this.dom).addClass('CarouselPluginIntro-num_small');
	        } else {
	            (0, _jquery2.default)('.CarouselPluginIntro-toggle', this.dom).show();
	            (0, _jquery2.default)('.CarouselPluginIntro-num', this.dom).removeClass('CarouselPluginIntro-num_small');
	        }
	    };
	
	    return Carousel;
	}()) || _class);
	exports.default = Carousel;

/***/ },
/* 12 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ function(module, exports) {

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 *	jQuery carouFredSel 6.2.1
	 *	Demo's and documentation:
	 *	caroufredsel.dev7studios.com
	 *
	 *	Copyright (c) 2013 Fred Heusschen
	 *	www.frebsite.nl
	 *
	 *	Dual licensed under the MIT and GPL licenses.
	 *	http://en.wikipedia.org/wiki/MIT_License
	 *	http://en.wikipedia.org/wiki/GNU_General_Public_License
	 */
	
	(function ($) {
	
		//	LOCAL
	
		if ($.fn.carouFredSel) {
			return;
		}
	
		$.fn.caroufredsel = $.fn.carouFredSel = function (options, configs) {
	
			//	no element
			if (this.length == 0) {
				debug(true, 'No element found for "' + this.selector + '".');
				return this;
			}
	
			//	multiple elements
			if (this.length > 1) {
				return this.each(function () {
					$(this).carouFredSel(options, configs);
				});
			}
	
			var $cfs = this,
			    $tt0 = this[0],
			    starting_position = false;
	
			if ($cfs.data('_cfs_isCarousel')) {
				starting_position = $cfs.triggerHandler('_cfs_triggerEvent', 'currentPosition');
				$cfs.trigger('_cfs_triggerEvent', ['destroy', true]);
			}
	
			var FN = {};
	
			FN._init = function (o, setOrig, start) {
				o = go_getObject($tt0, o);
	
				o.items = go_getItemsObject($tt0, o.items);
				o.scroll = go_getScrollObject($tt0, o.scroll);
				o.auto = go_getAutoObject($tt0, o.auto);
				o.prev = go_getPrevNextObject($tt0, o.prev);
				o.next = go_getPrevNextObject($tt0, o.next);
				o.pagination = go_getPaginationObject($tt0, o.pagination);
				o.swipe = go_getSwipeObject($tt0, o.swipe);
				o.mousewheel = go_getMousewheelObject($tt0, o.mousewheel);
	
				if (setOrig) {
					opts_orig = $.extend(true, {}, $.fn.carouFredSel.defaults, o);
				}
	
				opts = $.extend(true, {}, $.fn.carouFredSel.defaults, o);
				opts.d = cf_getDimensions(opts);
	
				crsl.direction = opts.direction == 'up' || opts.direction == 'left' ? 'next' : 'prev';
	
				var a_itm = $cfs.children(),
				    avail_primary = ms_getParentSize($wrp, opts, 'width');
	
				if (is_true(opts.cookie)) {
					opts.cookie = 'caroufredsel_cookie_' + conf.serialNumber;
				}
	
				opts.maxDimension = ms_getMaxDimension(opts, avail_primary);
	
				//	complement items and sizes
				opts.items = in_complementItems(opts.items, opts, a_itm, start);
				opts[opts.d['width']] = in_complementPrimarySize(opts[opts.d['width']], opts, a_itm);
				opts[opts.d['height']] = in_complementSecondarySize(opts[opts.d['height']], opts, a_itm);
	
				//	primary size not set for a responsive carousel
				if (opts.responsive) {
					if (!is_percentage(opts[opts.d['width']])) {
						opts[opts.d['width']] = '100%';
					}
				}
	
				//	primary size is percentage
				if (is_percentage(opts[opts.d['width']])) {
					crsl.upDateOnWindowResize = true;
					crsl.primarySizePercentage = opts[opts.d['width']];
					opts[opts.d['width']] = ms_getPercentage(avail_primary, crsl.primarySizePercentage);
					if (!opts.items.visible) {
						opts.items.visibleConf.variable = true;
					}
				}
	
				if (opts.responsive) {
					opts.usePadding = false;
					opts.padding = [0, 0, 0, 0];
					opts.align = false;
					opts.items.visibleConf.variable = false;
				} else {
					//	visible-items not set
					if (!opts.items.visible) {
						opts = in_complementVisibleItems(opts, avail_primary);
					}
	
					//	primary size not set -> calculate it or set to "variable"
					if (!opts[opts.d['width']]) {
						if (!opts.items.visibleConf.variable && is_number(opts.items[opts.d['width']]) && opts.items.filter == '*') {
							opts[opts.d['width']] = opts.items.visible * opts.items[opts.d['width']];
							opts.align = false;
						} else {
							opts[opts.d['width']] = 'variable';
						}
					}
					//	align not set -> set to center if primary size is number
					if (is_undefined(opts.align)) {
						opts.align = is_number(opts[opts.d['width']]) ? 'center' : false;
					}
					//	set variabe visible-items
					if (opts.items.visibleConf.variable) {
						opts.items.visible = gn_getVisibleItemsNext(a_itm, opts, 0);
					}
				}
	
				//	set visible items by filter
				if (opts.items.filter != '*' && !opts.items.visibleConf.variable) {
					opts.items.visibleConf.org = opts.items.visible;
					opts.items.visible = gn_getVisibleItemsNextFilter(a_itm, opts, 0);
				}
	
				opts.items.visible = cf_getItemsAdjust(opts.items.visible, opts, opts.items.visibleConf.adjust, $tt0);
				opts.items.visibleConf.old = opts.items.visible;
	
				if (opts.responsive) {
					if (!opts.items.visibleConf.min) {
						opts.items.visibleConf.min = opts.items.visible;
					}
					if (!opts.items.visibleConf.max) {
						opts.items.visibleConf.max = opts.items.visible;
					}
					opts = in_getResponsiveValues(opts, a_itm, avail_primary);
				} else {
					opts.padding = cf_getPadding(opts.padding);
	
					if (opts.align == 'top') {
						opts.align = 'left';
					} else if (opts.align == 'bottom') {
						opts.align = 'right';
					}
	
					switch (opts.align) {
						//	align: center, left or right
						case 'center':
						case 'left':
						case 'right':
							if (opts[opts.d['width']] != 'variable') {
								opts = in_getAlignPadding(opts, a_itm);
								opts.usePadding = true;
							}
							break;
	
						//	padding
						default:
							opts.align = false;
							opts.usePadding = opts.padding[0] == 0 && opts.padding[1] == 0 && opts.padding[2] == 0 && opts.padding[3] == 0 ? false : true;
							break;
					}
				}
	
				if (!is_number(opts.scroll.duration)) {
					opts.scroll.duration = 500;
				}
				if (is_undefined(opts.scroll.items)) {
					opts.scroll.items = opts.responsive || opts.items.visibleConf.variable || opts.items.filter != '*' ? 'visible' : opts.items.visible;
				}
	
				opts.auto = $.extend(true, {}, opts.scroll, opts.auto);
				opts.prev = $.extend(true, {}, opts.scroll, opts.prev);
				opts.next = $.extend(true, {}, opts.scroll, opts.next);
				opts.pagination = $.extend(true, {}, opts.scroll, opts.pagination);
				//	swipe and mousewheel extend later on, per direction
	
				opts.auto = go_complementAutoObject($tt0, opts.auto);
				opts.prev = go_complementPrevNextObject($tt0, opts.prev);
				opts.next = go_complementPrevNextObject($tt0, opts.next);
				opts.pagination = go_complementPaginationObject($tt0, opts.pagination);
				opts.swipe = go_complementSwipeObject($tt0, opts.swipe);
				opts.mousewheel = go_complementMousewheelObject($tt0, opts.mousewheel);
	
				if (opts.synchronise) {
					opts.synchronise = cf_getSynchArr(opts.synchronise);
				}
	
				//	DEPRECATED
				if (opts.auto.onPauseStart) {
					opts.auto.onTimeoutStart = opts.auto.onPauseStart;
					deprecated('auto.onPauseStart', 'auto.onTimeoutStart');
				}
				if (opts.auto.onPausePause) {
					opts.auto.onTimeoutPause = opts.auto.onPausePause;
					deprecated('auto.onPausePause', 'auto.onTimeoutPause');
				}
				if (opts.auto.onPauseEnd) {
					opts.auto.onTimeoutEnd = opts.auto.onPauseEnd;
					deprecated('auto.onPauseEnd', 'auto.onTimeoutEnd');
				}
				if (opts.auto.pauseDuration) {
					opts.auto.timeoutDuration = opts.auto.pauseDuration;
					deprecated('auto.pauseDuration', 'auto.timeoutDuration');
				}
				//	/DEPRECATED
	
			}; //	/init
	
	
			FN._build = function () {
				$cfs.data('_cfs_isCarousel', true);
	
				var a_itm = $cfs.children(),
				    orgCSS = in_mapCss($cfs, ['textAlign', 'float', 'position', 'top', 'right', 'bottom', 'left', 'zIndex', 'width', 'height', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft']),
				    newPosition = 'relative';
	
				switch (orgCSS.position) {
					case 'absolute':
					case 'fixed':
						newPosition = orgCSS.position;
						break;
				}
	
				if (conf.wrapper == 'parent') {
					sz_storeOrigCss($wrp);
				} else {
					$wrp.css(orgCSS);
				}
				$wrp.css({
					'overflow': 'hidden',
					'position': newPosition
				});
	
				sz_storeOrigCss($cfs);
				$cfs.data('_cfs_origCssZindex', orgCSS.zIndex);
				$cfs.css({
					'textAlign': 'left',
					'float': 'none',
					'position': 'absolute',
					'top': 0,
					'right': 'auto',
					'bottom': 'auto',
					'left': 0,
					'marginTop': 0,
					'marginRight': 0,
					'marginBottom': 0,
					'marginLeft': 0
				});
	
				sz_storeMargin(a_itm, opts);
				sz_storeOrigCss(a_itm);
				if (opts.responsive) {
					sz_setResponsiveSizes(opts, a_itm);
				}
			}; //	/build
	
	
			FN._bind_events = function () {
				FN._unbind_events();
	
				//	stop event
				$cfs.bind(cf_e('stop', conf), function (e, imm) {
					e.stopPropagation();
	
					//	button
					if (!crsl.isStopped) {
						if (opts.auto.button) {
							opts.auto.button.addClass(cf_c('stopped', conf));
						}
					}
	
					//	set stopped
					crsl.isStopped = true;
	
					if (opts.auto.play) {
						opts.auto.play = false;
						$cfs.trigger(cf_e('pause', conf), imm);
					}
					return true;
				});
	
				//	finish event
				$cfs.bind(cf_e('finish', conf), function (e) {
					e.stopPropagation();
					if (crsl.isScrolling) {
						sc_stopScroll(scrl);
					}
					return true;
				});
	
				//	pause event
				$cfs.bind(cf_e('pause', conf), function (e, imm, res) {
					e.stopPropagation();
					tmrs = sc_clearTimers(tmrs);
	
					//	immediately pause
					if (imm && crsl.isScrolling) {
						scrl.isStopped = true;
						var nst = getTime() - scrl.startTime;
						scrl.duration -= nst;
						if (scrl.pre) {
							scrl.pre.duration -= nst;
						}
						if (scrl.post) {
							scrl.post.duration -= nst;
						}
						sc_stopScroll(scrl, false);
					}
	
					//	update remaining pause-time
					if (!crsl.isPaused && !crsl.isScrolling) {
						if (res) {
							tmrs.timePassed += getTime() - tmrs.startTime;
						}
					}
	
					//	button
					if (!crsl.isPaused) {
						if (opts.auto.button) {
							opts.auto.button.addClass(cf_c('paused', conf));
						}
					}
	
					//	set paused
					crsl.isPaused = true;
	
					//	pause pause callback
					if (opts.auto.onTimeoutPause) {
						var dur1 = opts.auto.timeoutDuration - tmrs.timePassed,
						    perc = 100 - Math.ceil(dur1 * 100 / opts.auto.timeoutDuration);
	
						opts.auto.onTimeoutPause.call($tt0, perc, dur1);
					}
					return true;
				});
	
				//	play event
				$cfs.bind(cf_e('play', conf), function (e, dir, del, res) {
					e.stopPropagation();
					tmrs = sc_clearTimers(tmrs);
	
					//	sort params
					var v = [dir, del, res],
					    t = ['string', 'number', 'boolean'],
					    a = cf_sortParams(v, t);
	
					dir = a[0];
					del = a[1];
					res = a[2];
	
					if (dir != 'prev' && dir != 'next') {
						dir = crsl.direction;
					}
					if (!is_number(del)) {
						del = 0;
					}
					if (!is_boolean(res)) {
						res = false;
					}
	
					//	stopped?
					if (res) {
						crsl.isStopped = false;
						opts.auto.play = true;
					}
					if (!opts.auto.play) {
						e.stopImmediatePropagation();
						return debug(conf, 'Carousel stopped: Not scrolling.');
					}
	
					//	button
					if (crsl.isPaused) {
						if (opts.auto.button) {
							opts.auto.button.removeClass(cf_c('stopped', conf));
							opts.auto.button.removeClass(cf_c('paused', conf));
						}
					}
	
					//	set playing
					crsl.isPaused = false;
					tmrs.startTime = getTime();
	
					//	timeout the scrolling
					var dur1 = opts.auto.timeoutDuration + del,
					    dur2 = dur1 - tmrs.timePassed,
					    perc = 100 - Math.ceil(dur2 * 100 / dur1);
	
					if (opts.auto.progress) {
						tmrs.progress = setInterval(function () {
							var pasd = getTime() - tmrs.startTime + tmrs.timePassed,
							    perc = Math.ceil(pasd * 100 / dur1);
							opts.auto.progress.updater.call(opts.auto.progress.bar[0], perc);
						}, opts.auto.progress.interval);
					}
	
					tmrs.auto = setTimeout(function () {
						if (opts.auto.progress) {
							opts.auto.progress.updater.call(opts.auto.progress.bar[0], 100);
						}
						if (opts.auto.onTimeoutEnd) {
							opts.auto.onTimeoutEnd.call($tt0, perc, dur2);
						}
						if (crsl.isScrolling) {
							$cfs.trigger(cf_e('play', conf), dir);
						} else {
							$cfs.trigger(cf_e(dir, conf), opts.auto);
						}
					}, dur2);
	
					//	pause start callback
					if (opts.auto.onTimeoutStart) {
						opts.auto.onTimeoutStart.call($tt0, perc, dur2);
					}
	
					return true;
				});
	
				//	resume event
				$cfs.bind(cf_e('resume', conf), function (e) {
					e.stopPropagation();
					if (scrl.isStopped) {
						scrl.isStopped = false;
						crsl.isPaused = false;
						crsl.isScrolling = true;
						scrl.startTime = getTime();
						sc_startScroll(scrl, conf);
					} else {
						$cfs.trigger(cf_e('play', conf));
					}
					return true;
				});
	
				//	prev + next events
				$cfs.bind(cf_e('prev', conf) + ' ' + cf_e('next', conf), function (e, obj, num, clb, que) {
					e.stopPropagation();
	
					//	stopped or hidden carousel, don't scroll, don't queue
					if (crsl.isStopped || $cfs.is(':hidden')) {
						e.stopImmediatePropagation();
						return debug(conf, 'Carousel stopped or hidden: Not scrolling.');
					}
	
					//	not enough items
					var minimum = is_number(opts.items.minimum) ? opts.items.minimum : opts.items.visible + 1;
					if (minimum > itms.total) {
						e.stopImmediatePropagation();
						return debug(conf, 'Not enough items (' + itms.total + ' total, ' + minimum + ' needed): Not scrolling.');
					}
	
					//	get config
					var v = [obj, num, clb, que],
					    t = ['object', 'number/string', 'function', 'boolean'],
					    a = cf_sortParams(v, t);
	
					obj = a[0];
					num = a[1];
					clb = a[2];
					que = a[3];
	
					var eType = e.type.slice(conf.events.prefix.length);
	
					if (!is_object(obj)) {
						obj = {};
					}
					if (is_function(clb)) {
						obj.onAfter = clb;
					}
					if (is_boolean(que)) {
						obj.queue = que;
					}
					obj = $.extend(true, {}, opts[eType], obj);
	
					//	test conditions callback
					if (obj.conditions && !obj.conditions.call($tt0, eType)) {
						e.stopImmediatePropagation();
						return debug(conf, 'Callback "conditions" returned false.');
					}
	
					if (!is_number(num)) {
						if (opts.items.filter != '*') {
							num = 'visible';
						} else {
							var arr = [num, obj.items, opts[eType].items];
							for (var a = 0, l = arr.length; a < l; a++) {
								if (is_number(arr[a]) || arr[a] == 'page' || arr[a] == 'visible') {
									num = arr[a];
									break;
								}
							}
						}
						switch (num) {
							case 'page':
								e.stopImmediatePropagation();
								return $cfs.triggerHandler(cf_e(eType + 'Page', conf), [obj, clb]);
								break;
	
							case 'visible':
								if (!opts.items.visibleConf.variable && opts.items.filter == '*') {
									num = opts.items.visible;
								}
								break;
						}
					}
	
					//	resume animation, add current to queue
					if (scrl.isStopped) {
						$cfs.trigger(cf_e('resume', conf));
						$cfs.trigger(cf_e('queue', conf), [eType, [obj, num, clb]]);
						e.stopImmediatePropagation();
						return debug(conf, 'Carousel resumed scrolling.');
					}
	
					//	queue if scrolling
					if (obj.duration > 0) {
						if (crsl.isScrolling) {
							if (obj.queue) {
								if (obj.queue == 'last') {
									queu = [];
								}
								if (obj.queue != 'first' || queu.length == 0) {
									$cfs.trigger(cf_e('queue', conf), [eType, [obj, num, clb]]);
								}
							}
							e.stopImmediatePropagation();
							return debug(conf, 'Carousel currently scrolling.');
						}
					}
	
					tmrs.timePassed = 0;
					$cfs.trigger(cf_e('slide_' + eType, conf), [obj, num]);
	
					//	synchronise
					if (opts.synchronise) {
						var s = opts.synchronise,
						    c = [obj, num];
	
						for (var j = 0, l = s.length; j < l; j++) {
							var d = eType;
							if (!s[j][2]) {
								d = d == 'prev' ? 'next' : 'prev';
							}
							if (!s[j][1]) {
								c[0] = s[j][0].triggerHandler('_cfs_triggerEvent', ['configuration', d]);
							}
							c[1] = num + s[j][3];
							s[j][0].trigger('_cfs_triggerEvent', ['slide_' + d, c]);
						}
					}
					return true;
				});
	
				//	prev event
				$cfs.bind(cf_e('slide_prev', conf), function (e, sO, nI) {
					e.stopPropagation();
					var a_itm = $cfs.children();
	
					//	non-circular at start, scroll to end
					if (!opts.circular) {
						if (itms.first == 0) {
							if (opts.infinite) {
								$cfs.trigger(cf_e('next', conf), itms.total - 1);
							}
							return e.stopImmediatePropagation();
						}
					}
	
					sz_resetMargin(a_itm, opts);
	
					//	find number of items to scroll
					if (!is_number(nI)) {
						if (opts.items.visibleConf.variable) {
							nI = gn_getVisibleItemsPrev(a_itm, opts, itms.total - 1);
						} else if (opts.items.filter != '*') {
							var xI = is_number(sO.items) ? sO.items : gn_getVisibleOrg($cfs, opts);
							nI = gn_getScrollItemsPrevFilter(a_itm, opts, itms.total - 1, xI);
						} else {
							nI = opts.items.visible;
						}
						nI = cf_getAdjust(nI, opts, sO.items, $tt0);
					}
	
					//	prevent non-circular from scrolling to far
					if (!opts.circular) {
						if (itms.total - nI < itms.first) {
							nI = itms.total - itms.first;
						}
					}
	
					//	set new number of visible items
					opts.items.visibleConf.old = opts.items.visible;
					if (opts.items.visibleConf.variable) {
						var vI = cf_getItemsAdjust(gn_getVisibleItemsNext(a_itm, opts, itms.total - nI), opts, opts.items.visibleConf.adjust, $tt0);
						if (opts.items.visible + nI <= vI && nI < itms.total) {
							nI++;
							vI = cf_getItemsAdjust(gn_getVisibleItemsNext(a_itm, opts, itms.total - nI), opts, opts.items.visibleConf.adjust, $tt0);
						}
						opts.items.visible = vI;
					} else if (opts.items.filter != '*') {
						var vI = gn_getVisibleItemsNextFilter(a_itm, opts, itms.total - nI);
						opts.items.visible = cf_getItemsAdjust(vI, opts, opts.items.visibleConf.adjust, $tt0);
					}
	
					sz_resetMargin(a_itm, opts, true);
	
					//	scroll 0, don't scroll
					if (nI == 0) {
						e.stopImmediatePropagation();
						return debug(conf, '0 items to scroll: Not scrolling.');
					}
					debug(conf, 'Scrolling ' + nI + ' items backward.');
	
					//	save new config
					itms.first += nI;
					while (itms.first >= itms.total) {
						itms.first -= itms.total;
					}
	
					//	non-circular callback
					if (!opts.circular) {
						if (itms.first == 0 && sO.onEnd) {
							sO.onEnd.call($tt0, 'prev');
						}
						if (!opts.infinite) {
							nv_enableNavi(opts, itms.first, conf);
						}
					}
	
					//	rearrange items
					$cfs.children().slice(itms.total - nI, itms.total).prependTo($cfs);
					if (itms.total < opts.items.visible + nI) {
						$cfs.children().slice(0, opts.items.visible + nI - itms.total).clone(true).appendTo($cfs);
					}
	
					//	the needed items
					var a_itm = $cfs.children(),
					    i_old = gi_getOldItemsPrev(a_itm, opts, nI),
					    i_new = gi_getNewItemsPrev(a_itm, opts),
					    i_cur_l = a_itm.eq(nI - 1),
					    i_old_l = i_old.last(),
					    i_new_l = i_new.last();
	
					sz_resetMargin(a_itm, opts);
	
					var pL = 0,
					    pR = 0;
	
					if (opts.align) {
						var p = cf_getAlignPadding(i_new, opts);
						pL = p[0];
						pR = p[1];
					}
					var oL = pL < 0 ? opts.padding[opts.d[3]] : 0;
	
					//	hide items for fx directscroll
					var hiddenitems = false,
					    i_skp = $();
					if (opts.items.visible < nI) {
						i_skp = a_itm.slice(opts.items.visibleConf.old, nI);
						if (sO.fx == 'directscroll') {
							var orgW = opts.items[opts.d['width']];
							hiddenitems = i_skp;
							i_cur_l = i_new_l;
							sc_hideHiddenItems(hiddenitems);
							opts.items[opts.d['width']] = 'variable';
						}
					}
	
					//	save new sizes
					var $cf2 = false,
					    i_siz = ms_getTotalSize(a_itm.slice(0, nI), opts, 'width'),
					    w_siz = cf_mapWrapperSizes(ms_getSizes(i_new, opts, true), opts, !opts.usePadding),
					    i_siz_vis = 0,
					    a_cfs = {},
					    a_wsz = {},
					    a_cur = {},
					    a_old = {},
					    a_new = {},
					    a_lef = {},
					    a_lef_vis = {},
					    a_dur = sc_getDuration(sO, opts, nI, i_siz);
	
					switch (sO.fx) {
						case 'cover':
						case 'cover-fade':
							i_siz_vis = ms_getTotalSize(a_itm.slice(0, opts.items.visible), opts, 'width');
							break;
					}
	
					if (hiddenitems) {
						opts.items[opts.d['width']] = orgW;
					}
	
					sz_resetMargin(a_itm, opts, true);
					if (pR >= 0) {
						sz_resetMargin(i_old_l, opts, opts.padding[opts.d[1]]);
					}
					if (pL >= 0) {
						sz_resetMargin(i_cur_l, opts, opts.padding[opts.d[3]]);
					}
	
					if (opts.align) {
						opts.padding[opts.d[1]] = pR;
						opts.padding[opts.d[3]] = pL;
					}
	
					a_lef[opts.d['left']] = -(i_siz - oL);
					a_lef_vis[opts.d['left']] = -(i_siz_vis - oL);
					a_wsz[opts.d['left']] = w_siz[opts.d['width']];
	
					//	scrolling functions
					var _s_wrapper = function _s_wrapper() {},
					    _a_wrapper = function _a_wrapper() {},
					    _s_paddingold = function _s_paddingold() {},
					    _a_paddingold = function _a_paddingold() {},
					    _s_paddingnew = function _s_paddingnew() {},
					    _a_paddingnew = function _a_paddingnew() {},
					    _s_paddingcur = function _s_paddingcur() {},
					    _a_paddingcur = function _a_paddingcur() {},
					    _onafter = function _onafter() {},
					    _moveitems = function _moveitems() {},
					    _position = function _position() {};
	
					//	clone carousel
					switch (sO.fx) {
						case 'crossfade':
						case 'cover':
						case 'cover-fade':
						case 'uncover':
						case 'uncover-fade':
							$cf2 = $cfs.clone(true).appendTo($wrp);
							break;
					}
					switch (sO.fx) {
						case 'crossfade':
						case 'uncover':
						case 'uncover-fade':
							$cf2.children().slice(0, nI).remove();
							$cf2.children().slice(opts.items.visibleConf.old).remove();
							break;
	
						case 'cover':
						case 'cover-fade':
							$cf2.children().slice(opts.items.visible).remove();
							$cf2.css(a_lef_vis);
							break;
					}
	
					$cfs.css(a_lef);
	
					//	reset all scrolls
					scrl = sc_setScroll(a_dur, sO.easing, conf);
	
					//	animate / set carousel
					a_cfs[opts.d['left']] = opts.usePadding ? opts.padding[opts.d[3]] : 0;
	
					//	animate / set wrapper
					if (opts[opts.d['width']] == 'variable' || opts[opts.d['height']] == 'variable') {
						_s_wrapper = function _s_wrapper() {
							$wrp.css(w_siz);
						};
						_a_wrapper = function _a_wrapper() {
							scrl.anims.push([$wrp, w_siz]);
						};
					}
	
					//	animate / set items
					if (opts.usePadding) {
						if (i_new_l.not(i_cur_l).length) {
							a_cur[opts.d['marginRight']] = i_cur_l.data('_cfs_origCssMargin');
	
							if (pL < 0) {
								i_cur_l.css(a_cur);
							} else {
								_s_paddingcur = function _s_paddingcur() {
									i_cur_l.css(a_cur);
								};
								_a_paddingcur = function _a_paddingcur() {
									scrl.anims.push([i_cur_l, a_cur]);
								};
							}
						}
						switch (sO.fx) {
							case 'cover':
							case 'cover-fade':
								$cf2.children().eq(nI - 1).css(a_cur);
								break;
						}
	
						if (i_new_l.not(i_old_l).length) {
							a_old[opts.d['marginRight']] = i_old_l.data('_cfs_origCssMargin');
							_s_paddingold = function _s_paddingold() {
								i_old_l.css(a_old);
							};
							_a_paddingold = function _a_paddingold() {
								scrl.anims.push([i_old_l, a_old]);
							};
						}
	
						if (pR >= 0) {
							a_new[opts.d['marginRight']] = i_new_l.data('_cfs_origCssMargin') + opts.padding[opts.d[1]];
							_s_paddingnew = function _s_paddingnew() {
								i_new_l.css(a_new);
							};
							_a_paddingnew = function _a_paddingnew() {
								scrl.anims.push([i_new_l, a_new]);
							};
						}
					}
	
					//	set position
					_position = function _position() {
						$cfs.css(a_cfs);
					};
	
					var overFill = opts.items.visible + nI - itms.total;
	
					//	rearrange items
					_moveitems = function _moveitems() {
						if (overFill > 0) {
							$cfs.children().slice(itms.total).remove();
							i_old = $($cfs.children().slice(itms.total - (opts.items.visible - overFill)).get().concat($cfs.children().slice(0, overFill).get()));
						}
						sc_showHiddenItems(hiddenitems);
	
						if (opts.usePadding) {
							var l_itm = $cfs.children().eq(opts.items.visible + nI - 1);
							l_itm.css(opts.d['marginRight'], l_itm.data('_cfs_origCssMargin'));
						}
					};
	
					var cb_arguments = sc_mapCallbackArguments(i_old, i_skp, i_new, nI, 'prev', a_dur, w_siz);
	
					//	fire onAfter callbacks
					_onafter = function _onafter() {
						sc_afterScroll($cfs, $cf2, sO);
						crsl.isScrolling = false;
						clbk.onAfter = sc_fireCallbacks($tt0, sO, 'onAfter', cb_arguments, clbk);
						queu = sc_fireQueue($cfs, queu, conf);
	
						if (!crsl.isPaused) {
							$cfs.trigger(cf_e('play', conf));
						}
					};
	
					//	fire onBefore callback
					crsl.isScrolling = true;
					tmrs = sc_clearTimers(tmrs);
					clbk.onBefore = sc_fireCallbacks($tt0, sO, 'onBefore', cb_arguments, clbk);
	
					switch (sO.fx) {
						case 'none':
							$cfs.css(a_cfs);
							_s_wrapper();
							_s_paddingold();
							_s_paddingnew();
							_s_paddingcur();
							_position();
							_moveitems();
							_onafter();
							break;
	
						case 'fade':
							scrl.anims.push([$cfs, { 'opacity': 0 }, function () {
								_s_wrapper();
								_s_paddingold();
								_s_paddingnew();
								_s_paddingcur();
								_position();
								_moveitems();
								scrl = sc_setScroll(a_dur, sO.easing, conf);
								scrl.anims.push([$cfs, { 'opacity': 1 }, _onafter]);
								sc_startScroll(scrl, conf);
							}]);
							break;
	
						case 'crossfade':
							$cfs.css({ 'opacity': 0 });
							scrl.anims.push([$cf2, { 'opacity': 0 }]);
							scrl.anims.push([$cfs, { 'opacity': 1 }, _onafter]);
							_a_wrapper();
							_s_paddingold();
							_s_paddingnew();
							_s_paddingcur();
							_position();
							_moveitems();
							break;
	
						case 'cover':
							scrl.anims.push([$cf2, a_cfs, function () {
								_s_paddingold();
								_s_paddingnew();
								_s_paddingcur();
								_position();
								_moveitems();
								_onafter();
							}]);
							_a_wrapper();
							break;
	
						case 'cover-fade':
							scrl.anims.push([$cfs, { 'opacity': 0 }]);
							scrl.anims.push([$cf2, a_cfs, function () {
								_s_paddingold();
								_s_paddingnew();
								_s_paddingcur();
								_position();
								_moveitems();
								_onafter();
							}]);
							_a_wrapper();
							break;
	
						case 'uncover':
							scrl.anims.push([$cf2, a_wsz, _onafter]);
							_a_wrapper();
							_s_paddingold();
							_s_paddingnew();
							_s_paddingcur();
							_position();
							_moveitems();
							break;
	
						case 'uncover-fade':
							$cfs.css({ 'opacity': 0 });
							scrl.anims.push([$cfs, { 'opacity': 1 }]);
							scrl.anims.push([$cf2, a_wsz, _onafter]);
							_a_wrapper();
							_s_paddingold();
							_s_paddingnew();
							_s_paddingcur();
							_position();
							_moveitems();
							break;
	
						default:
							scrl.anims.push([$cfs, a_cfs, function () {
								_moveitems();
								_onafter();
							}]);
							_a_wrapper();
							_a_paddingold();
							_a_paddingnew();
							_a_paddingcur();
							break;
					}
	
					sc_startScroll(scrl, conf);
					cf_setCookie(opts.cookie, $cfs, conf);
	
					$cfs.trigger(cf_e('updatePageStatus', conf), [false, w_siz]);
	
					return true;
				});
	
				//	next event
				$cfs.bind(cf_e('slide_next', conf), function (e, sO, nI) {
					e.stopPropagation();
					var a_itm = $cfs.children();
	
					//	non-circular at end, scroll to start
					if (!opts.circular) {
						if (itms.first == opts.items.visible) {
							if (opts.infinite) {
								$cfs.trigger(cf_e('prev', conf), itms.total - 1);
							}
							return e.stopImmediatePropagation();
						}
					}
	
					sz_resetMargin(a_itm, opts);
	
					//	find number of items to scroll
					if (!is_number(nI)) {
						if (opts.items.filter != '*') {
							var xI = is_number(sO.items) ? sO.items : gn_getVisibleOrg($cfs, opts);
							nI = gn_getScrollItemsNextFilter(a_itm, opts, 0, xI);
						} else {
							nI = opts.items.visible;
						}
						nI = cf_getAdjust(nI, opts, sO.items, $tt0);
					}
	
					var lastItemNr = itms.first == 0 ? itms.total : itms.first;
	
					//	prevent non-circular from scrolling to far
					if (!opts.circular) {
						if (opts.items.visibleConf.variable) {
							var vI = gn_getVisibleItemsNext(a_itm, opts, nI),
							    xI = gn_getVisibleItemsPrev(a_itm, opts, lastItemNr - 1);
						} else {
							var vI = opts.items.visible,
							    xI = opts.items.visible;
						}
	
						if (nI + vI > lastItemNr) {
							nI = lastItemNr - xI;
						}
					}
	
					//	set new number of visible items
					opts.items.visibleConf.old = opts.items.visible;
					if (opts.items.visibleConf.variable) {
						var vI = cf_getItemsAdjust(gn_getVisibleItemsNextTestCircular(a_itm, opts, nI, lastItemNr), opts, opts.items.visibleConf.adjust, $tt0);
						while (opts.items.visible - nI >= vI && nI < itms.total) {
							nI++;
							vI = cf_getItemsAdjust(gn_getVisibleItemsNextTestCircular(a_itm, opts, nI, lastItemNr), opts, opts.items.visibleConf.adjust, $tt0);
						}
						opts.items.visible = vI;
					} else if (opts.items.filter != '*') {
						var vI = gn_getVisibleItemsNextFilter(a_itm, opts, nI);
						opts.items.visible = cf_getItemsAdjust(vI, opts, opts.items.visibleConf.adjust, $tt0);
					}
	
					sz_resetMargin(a_itm, opts, true);
	
					//	scroll 0, don't scroll
					if (nI == 0) {
						e.stopImmediatePropagation();
						return debug(conf, '0 items to scroll: Not scrolling.');
					}
					debug(conf, 'Scrolling ' + nI + ' items forward.');
	
					//	save new config
					itms.first -= nI;
					while (itms.first < 0) {
						itms.first += itms.total;
					}
	
					//	non-circular callback
					if (!opts.circular) {
						if (itms.first == opts.items.visible && sO.onEnd) {
							sO.onEnd.call($tt0, 'next');
						}
						if (!opts.infinite) {
							nv_enableNavi(opts, itms.first, conf);
						}
					}
	
					//	rearrange items
					if (itms.total < opts.items.visible + nI) {
						$cfs.children().slice(0, opts.items.visible + nI - itms.total).clone(true).appendTo($cfs);
					}
	
					//	the needed items
					var a_itm = $cfs.children(),
					    i_old = gi_getOldItemsNext(a_itm, opts),
					    i_new = gi_getNewItemsNext(a_itm, opts, nI),
					    i_cur_l = a_itm.eq(nI - 1),
					    i_old_l = i_old.last(),
					    i_new_l = i_new.last();
	
					sz_resetMargin(a_itm, opts);
	
					var pL = 0,
					    pR = 0;
	
					if (opts.align) {
						var p = cf_getAlignPadding(i_new, opts);
						pL = p[0];
						pR = p[1];
					}
	
					//	hide items for fx directscroll
					var hiddenitems = false,
					    i_skp = $();
					if (opts.items.visibleConf.old < nI) {
						i_skp = a_itm.slice(opts.items.visibleConf.old, nI);
						if (sO.fx == 'directscroll') {
							var orgW = opts.items[opts.d['width']];
							hiddenitems = i_skp;
							i_cur_l = i_old_l;
							sc_hideHiddenItems(hiddenitems);
							opts.items[opts.d['width']] = 'variable';
						}
					}
	
					//	save new sizes
					var $cf2 = false,
					    i_siz = ms_getTotalSize(a_itm.slice(0, nI), opts, 'width'),
					    w_siz = cf_mapWrapperSizes(ms_getSizes(i_new, opts, true), opts, !opts.usePadding),
					    i_siz_vis = 0,
					    a_cfs = {},
					    a_cfs_vis = {},
					    a_cur = {},
					    a_old = {},
					    a_lef = {},
					    a_dur = sc_getDuration(sO, opts, nI, i_siz);
	
					switch (sO.fx) {
						case 'uncover':
						case 'uncover-fade':
							i_siz_vis = ms_getTotalSize(a_itm.slice(0, opts.items.visibleConf.old), opts, 'width');
							break;
					}
	
					if (hiddenitems) {
						opts.items[opts.d['width']] = orgW;
					}
	
					if (opts.align) {
						if (opts.padding[opts.d[1]] < 0) {
							opts.padding[opts.d[1]] = 0;
						}
					}
					sz_resetMargin(a_itm, opts, true);
					sz_resetMargin(i_old_l, opts, opts.padding[opts.d[1]]);
	
					if (opts.align) {
						opts.padding[opts.d[1]] = pR;
						opts.padding[opts.d[3]] = pL;
					}
	
					a_lef[opts.d['left']] = opts.usePadding ? opts.padding[opts.d[3]] : 0;
	
					//	scrolling functions
					var _s_wrapper = function _s_wrapper() {},
					    _a_wrapper = function _a_wrapper() {},
					    _s_paddingold = function _s_paddingold() {},
					    _a_paddingold = function _a_paddingold() {},
					    _s_paddingcur = function _s_paddingcur() {},
					    _a_paddingcur = function _a_paddingcur() {},
					    _onafter = function _onafter() {},
					    _moveitems = function _moveitems() {},
					    _position = function _position() {};
	
					//	clone carousel
					switch (sO.fx) {
						case 'crossfade':
						case 'cover':
						case 'cover-fade':
						case 'uncover':
						case 'uncover-fade':
							$cf2 = $cfs.clone(true).appendTo($wrp);
							$cf2.children().slice(opts.items.visibleConf.old).remove();
							break;
					}
					switch (sO.fx) {
						case 'crossfade':
						case 'cover':
						case 'cover-fade':
							$cfs.css('zIndex', 1);
							$cf2.css('zIndex', 0);
							break;
					}
	
					//	reset all scrolls
					scrl = sc_setScroll(a_dur, sO.easing, conf);
	
					//	animate / set carousel
					a_cfs[opts.d['left']] = -i_siz;
					a_cfs_vis[opts.d['left']] = -i_siz_vis;
	
					if (pL < 0) {
						a_cfs[opts.d['left']] += pL;
					}
	
					//	animate / set wrapper
					if (opts[opts.d['width']] == 'variable' || opts[opts.d['height']] == 'variable') {
						_s_wrapper = function _s_wrapper() {
							$wrp.css(w_siz);
						};
						_a_wrapper = function _a_wrapper() {
							scrl.anims.push([$wrp, w_siz]);
						};
					}
	
					//	animate / set items
					if (opts.usePadding) {
						var i_new_l_m = i_new_l.data('_cfs_origCssMargin');
	
						if (pR >= 0) {
							i_new_l_m += opts.padding[opts.d[1]];
						}
						i_new_l.css(opts.d['marginRight'], i_new_l_m);
	
						if (i_cur_l.not(i_old_l).length) {
							a_old[opts.d['marginRight']] = i_old_l.data('_cfs_origCssMargin');
						}
						_s_paddingold = function _s_paddingold() {
							i_old_l.css(a_old);
						};
						_a_paddingold = function _a_paddingold() {
							scrl.anims.push([i_old_l, a_old]);
						};
	
						var i_cur_l_m = i_cur_l.data('_cfs_origCssMargin');
						if (pL > 0) {
							i_cur_l_m += opts.padding[opts.d[3]];
						}
	
						a_cur[opts.d['marginRight']] = i_cur_l_m;
	
						_s_paddingcur = function _s_paddingcur() {
							i_cur_l.css(a_cur);
						};
						_a_paddingcur = function _a_paddingcur() {
							scrl.anims.push([i_cur_l, a_cur]);
						};
					}
	
					//	set position
					_position = function _position() {
						$cfs.css(a_lef);
					};
	
					var overFill = opts.items.visible + nI - itms.total;
	
					//	rearrange items
					_moveitems = function _moveitems() {
						if (overFill > 0) {
							$cfs.children().slice(itms.total).remove();
						}
						var l_itm = $cfs.children().slice(0, nI).appendTo($cfs).last();
						if (overFill > 0) {
							i_new = gi_getCurrentItems(a_itm, opts);
						}
						sc_showHiddenItems(hiddenitems);
	
						if (opts.usePadding) {
							if (itms.total < opts.items.visible + nI) {
								var i_cur_l = $cfs.children().eq(opts.items.visible - 1);
								i_cur_l.css(opts.d['marginRight'], i_cur_l.data('_cfs_origCssMargin') + opts.padding[opts.d[1]]);
							}
							l_itm.css(opts.d['marginRight'], l_itm.data('_cfs_origCssMargin'));
						}
					};
	
					var cb_arguments = sc_mapCallbackArguments(i_old, i_skp, i_new, nI, 'next', a_dur, w_siz);
	
					//	fire onAfter callbacks
					_onafter = function _onafter() {
						$cfs.css('zIndex', $cfs.data('_cfs_origCssZindex'));
						sc_afterScroll($cfs, $cf2, sO);
						crsl.isScrolling = false;
						clbk.onAfter = sc_fireCallbacks($tt0, sO, 'onAfter', cb_arguments, clbk);
						queu = sc_fireQueue($cfs, queu, conf);
	
						if (!crsl.isPaused) {
							$cfs.trigger(cf_e('play', conf));
						}
					};
	
					//	fire onBefore callbacks
					crsl.isScrolling = true;
					tmrs = sc_clearTimers(tmrs);
					clbk.onBefore = sc_fireCallbacks($tt0, sO, 'onBefore', cb_arguments, clbk);
	
					switch (sO.fx) {
						case 'none':
							$cfs.css(a_cfs);
							_s_wrapper();
							_s_paddingold();
							_s_paddingcur();
							_position();
							_moveitems();
							_onafter();
							break;
	
						case 'fade':
							scrl.anims.push([$cfs, { 'opacity': 0 }, function () {
								_s_wrapper();
								_s_paddingold();
								_s_paddingcur();
								_position();
								_moveitems();
								scrl = sc_setScroll(a_dur, sO.easing, conf);
								scrl.anims.push([$cfs, { 'opacity': 1 }, _onafter]);
								sc_startScroll(scrl, conf);
							}]);
							break;
	
						case 'crossfade':
							$cfs.css({ 'opacity': 0 });
							scrl.anims.push([$cf2, { 'opacity': 0 }]);
							scrl.anims.push([$cfs, { 'opacity': 1 }, _onafter]);
							_a_wrapper();
							_s_paddingold();
							_s_paddingcur();
							_position();
							_moveitems();
							break;
	
						case 'cover':
							$cfs.css(opts.d['left'], $wrp[opts.d['width']]());
							scrl.anims.push([$cfs, a_lef, _onafter]);
							_a_wrapper();
							_s_paddingold();
							_s_paddingcur();
							_moveitems();
							break;
	
						case 'cover-fade':
							$cfs.css(opts.d['left'], $wrp[opts.d['width']]());
							scrl.anims.push([$cf2, { 'opacity': 0 }]);
							scrl.anims.push([$cfs, a_lef, _onafter]);
							_a_wrapper();
							_s_paddingold();
							_s_paddingcur();
							_moveitems();
							break;
	
						case 'uncover':
							scrl.anims.push([$cf2, a_cfs_vis, _onafter]);
							_a_wrapper();
							_s_paddingold();
							_s_paddingcur();
							_position();
							_moveitems();
							break;
	
						case 'uncover-fade':
							$cfs.css({ 'opacity': 0 });
							scrl.anims.push([$cfs, { 'opacity': 1 }]);
							scrl.anims.push([$cf2, a_cfs_vis, _onafter]);
							_a_wrapper();
							_s_paddingold();
							_s_paddingcur();
							_position();
							_moveitems();
							break;
	
						default:
							scrl.anims.push([$cfs, a_cfs, function () {
								_position();
								_moveitems();
								_onafter();
							}]);
							_a_wrapper();
							_a_paddingold();
							_a_paddingcur();
							break;
					}
	
					sc_startScroll(scrl, conf);
					cf_setCookie(opts.cookie, $cfs, conf);
	
					$cfs.trigger(cf_e('updatePageStatus', conf), [false, w_siz]);
	
					return true;
				});
	
				//	slideTo event
				$cfs.bind(cf_e('slideTo', conf), function (e, num, dev, org, obj, dir, clb) {
					e.stopPropagation();
	
					var v = [num, dev, org, obj, dir, clb],
					    t = ['string/number/object', 'number', 'boolean', 'object', 'string', 'function'],
					    a = cf_sortParams(v, t);
	
					obj = a[3];
					dir = a[4];
					clb = a[5];
	
					num = gn_getItemIndex(a[0], a[1], a[2], itms, $cfs);
	
					if (num == 0) {
						return false;
					}
					if (!is_object(obj)) {
						obj = false;
					}
	
					if (dir != 'prev' && dir != 'next') {
						if (opts.circular) {
							dir = num <= itms.total / 2 ? 'next' : 'prev';
						} else {
							dir = itms.first == 0 || itms.first > num ? 'next' : 'prev';
						}
					}
	
					if (dir == 'prev') {
						num = itms.total - num;
					}
					$cfs.trigger(cf_e(dir, conf), [obj, num, clb]);
	
					return true;
				});
	
				//	prevPage event
				$cfs.bind(cf_e('prevPage', conf), function (e, obj, clb) {
					e.stopPropagation();
					var cur = $cfs.triggerHandler(cf_e('currentPage', conf));
					return $cfs.triggerHandler(cf_e('slideToPage', conf), [cur - 1, obj, 'prev', clb]);
				});
	
				//	nextPage event
				$cfs.bind(cf_e('nextPage', conf), function (e, obj, clb) {
					e.stopPropagation();
					var cur = $cfs.triggerHandler(cf_e('currentPage', conf));
					return $cfs.triggerHandler(cf_e('slideToPage', conf), [cur + 1, obj, 'next', clb]);
				});
	
				//	slideToPage event
				$cfs.bind(cf_e('slideToPage', conf), function (e, pag, obj, dir, clb) {
					e.stopPropagation();
					if (!is_number(pag)) {
						pag = $cfs.triggerHandler(cf_e('currentPage', conf));
					}
					var ipp = opts.pagination.items || opts.items.visible,
					    max = Math.ceil(itms.total / ipp) - 1;
	
					if (pag < 0) {
						pag = max;
					}
					if (pag > max) {
						pag = 0;
					}
					return $cfs.triggerHandler(cf_e('slideTo', conf), [pag * ipp, 0, true, obj, dir, clb]);
				});
	
				//	jumpToStart event
				$cfs.bind(cf_e('jumpToStart', conf), function (e, s) {
					e.stopPropagation();
					if (s) {
						s = gn_getItemIndex(s, 0, true, itms, $cfs);
					} else {
						s = 0;
					}
	
					s += itms.first;
					if (s != 0) {
						if (itms.total > 0) {
							while (s > itms.total) {
								s -= itms.total;
							}
						}
						$cfs.prepend($cfs.children().slice(s, itms.total));
					}
					return true;
				});
	
				//	synchronise event
				$cfs.bind(cf_e('synchronise', conf), function (e, s) {
					e.stopPropagation();
					if (s) {
						s = cf_getSynchArr(s);
					} else if (opts.synchronise) {
						s = opts.synchronise;
					} else {
						return debug(conf, 'No carousel to synchronise.');
					}
	
					var n = $cfs.triggerHandler(cf_e('currentPosition', conf)),
					    x = true;
	
					for (var j = 0, l = s.length; j < l; j++) {
						if (!s[j][0].triggerHandler(cf_e('slideTo', conf), [n, s[j][3], true])) {
							x = false;
						}
					}
					return x;
				});
	
				//	queue event
				$cfs.bind(cf_e('queue', conf), function (e, dir, opt) {
					e.stopPropagation();
					if (is_function(dir)) {
						dir.call($tt0, queu);
					} else if (is_array(dir)) {
						queu = dir;
					} else if (!is_undefined(dir)) {
						queu.push([dir, opt]);
					}
					return queu;
				});
	
				//	insertItem event
				$cfs.bind(cf_e('insertItem', conf), function (e, itm, num, org, dev) {
					e.stopPropagation();
	
					var v = [itm, num, org, dev],
					    t = ['string/object', 'string/number/object', 'boolean', 'number'],
					    a = cf_sortParams(v, t);
	
					itm = a[0];
					num = a[1];
					org = a[2];
					dev = a[3];
	
					if (is_object(itm) && !is_jquery(itm)) {
						itm = $(itm);
					} else if (is_string(itm)) {
						itm = $(itm);
					}
					if (!is_jquery(itm) || itm.length == 0) {
						return debug(conf, 'Not a valid object.');
					}
	
					if (is_undefined(num)) {
						num = 'end';
					}
	
					sz_storeMargin(itm, opts);
					sz_storeOrigCss(itm);
	
					var orgNum = num,
					    before = 'before';
	
					if (num == 'end') {
						if (org) {
							if (itms.first == 0) {
								num = itms.total - 1;
								before = 'after';
							} else {
								num = itms.first;
								itms.first += itm.length;
							}
							if (num < 0) {
								num = 0;
							}
						} else {
							num = itms.total - 1;
							before = 'after';
						}
					} else {
						num = gn_getItemIndex(num, dev, org, itms, $cfs);
					}
	
					var $cit = $cfs.children().eq(num);
					if ($cit.length) {
						$cit[before](itm);
					} else {
						debug(conf, 'Correct insert-position not found! Appending item to the end.');
						$cfs.append(itm);
					}
	
					if (orgNum != 'end' && !org) {
						if (num < itms.first) {
							itms.first += itm.length;
						}
					}
					itms.total = $cfs.children().length;
					if (itms.first >= itms.total) {
						itms.first -= itms.total;
					}
	
					$cfs.trigger(cf_e('updateSizes', conf));
					$cfs.trigger(cf_e('linkAnchors', conf));
	
					return true;
				});
	
				//	removeItem event
				$cfs.bind(cf_e('removeItem', conf), function (e, num, org, dev) {
					e.stopPropagation();
	
					var v = [num, org, dev],
					    t = ['string/number/object', 'boolean', 'number'],
					    a = cf_sortParams(v, t);
	
					num = a[0];
					org = a[1];
					dev = a[2];
	
					var removed = false;
	
					if (num instanceof $ && num.length > 1) {
						$removed = $();
						num.each(function (i, el) {
							var $rem = $cfs.trigger(cf_e('removeItem', conf), [$(this), org, dev]);
							if ($rem) {
								$removed = $removed.add($rem);
							}
						});
						return $removed;
					}
	
					if (is_undefined(num) || num == 'end') {
						$removed = $cfs.children().last();
					} else {
						num = gn_getItemIndex(num, dev, org, itms, $cfs);
						var $removed = $cfs.children().eq(num);
						if ($removed.length) {
							if (num < itms.first) {
								itms.first -= $removed.length;
							}
						}
					}
					if ($removed && $removed.length) {
						$removed.detach();
						itms.total = $cfs.children().length;
						$cfs.trigger(cf_e('updateSizes', conf));
					}
	
					return $removed;
				});
	
				//	onBefore and onAfter event
				$cfs.bind(cf_e('onBefore', conf) + ' ' + cf_e('onAfter', conf), function (e, fn) {
					e.stopPropagation();
					var eType = e.type.slice(conf.events.prefix.length);
					if (is_array(fn)) {
						clbk[eType] = fn;
					}
					if (is_function(fn)) {
						clbk[eType].push(fn);
					}
					return clbk[eType];
				});
	
				//	currentPosition event
				$cfs.bind(cf_e('currentPosition', conf), function (e, fn) {
					e.stopPropagation();
					if (itms.first == 0) {
						var val = 0;
					} else {
						var val = itms.total - itms.first;
					}
					if (is_function(fn)) {
						fn.call($tt0, val);
					}
					return val;
				});
	
				//	currentPage event
				$cfs.bind(cf_e('currentPage', conf), function (e, fn) {
					e.stopPropagation();
					var ipp = opts.pagination.items || opts.items.visible,
					    max = Math.ceil(itms.total / ipp - 1),
					    nr;
					if (itms.first == 0) {
						nr = 0;
					} else if (itms.first < itms.total % ipp) {
						nr = 0;
					} else if (itms.first == ipp && !opts.circular) {
						nr = max;
					} else {
						nr = Math.round((itms.total - itms.first) / ipp);
					}
					if (nr < 0) {
						nr = 0;
					}
					if (nr > max) {
						nr = max;
					}
					if (is_function(fn)) {
						fn.call($tt0, nr);
					}
					return nr;
				});
	
				//	currentVisible event
				$cfs.bind(cf_e('currentVisible', conf), function (e, fn) {
					e.stopPropagation();
					var $i = gi_getCurrentItems($cfs.children(), opts);
					if (is_function(fn)) {
						fn.call($tt0, $i);
					}
					return $i;
				});
	
				//	slice event
				$cfs.bind(cf_e('slice', conf), function (e, f, l, fn) {
					e.stopPropagation();
	
					if (itms.total == 0) {
						return false;
					}
	
					var v = [f, l, fn],
					    t = ['number', 'number', 'function'],
					    a = cf_sortParams(v, t);
	
					f = is_number(a[0]) ? a[0] : 0;
					l = is_number(a[1]) ? a[1] : itms.total;
					fn = a[2];
	
					f += itms.first;
					l += itms.first;
	
					if (items.total > 0) {
						while (f > itms.total) {
							f -= itms.total;
						}
						while (l > itms.total) {
							l -= itms.total;
						}
						while (f < 0) {
							f += itms.total;
						}
						while (l < 0) {
							l += itms.total;
						}
					}
					var $iA = $cfs.children(),
					    $i;
	
					if (l > f) {
						$i = $iA.slice(f, l);
					} else {
						$i = $($iA.slice(f, itms.total).get().concat($iA.slice(0, l).get()));
					}
	
					if (is_function(fn)) {
						fn.call($tt0, $i);
					}
					return $i;
				});
	
				//	isPaused, isStopped and isScrolling events
				$cfs.bind(cf_e('isPaused', conf) + ' ' + cf_e('isStopped', conf) + ' ' + cf_e('isScrolling', conf), function (e, fn) {
					e.stopPropagation();
					var eType = e.type.slice(conf.events.prefix.length),
					    value = crsl[eType];
					if (is_function(fn)) {
						fn.call($tt0, value);
					}
					return value;
				});
	
				//	configuration event
				$cfs.bind(cf_e('configuration', conf), function (e, a, b, c) {
					e.stopPropagation();
					var reInit = false;
	
					//	return entire configuration-object
					if (is_function(a)) {
						a.call($tt0, opts);
					}
					//	set multiple options via object
					else if (is_object(a)) {
							opts_orig = $.extend(true, {}, opts_orig, a);
							if (b !== false) reInit = true;else opts = $.extend(true, {}, opts, a);
						} else if (!is_undefined(a)) {
	
							//	callback function for specific option
							if (is_function(b)) {
								var val = eval('opts.' + a);
								if (is_undefined(val)) {
									val = '';
								}
								b.call($tt0, val);
							}
							//	set individual option
							else if (!is_undefined(b)) {
									if (typeof c !== 'boolean') c = true;
									eval('opts_orig.' + a + ' = b');
									if (c !== false) reInit = true;else eval('opts.' + a + ' = b');
								}
								//	return value for specific option
								else {
										return eval('opts.' + a);
									}
						}
					if (reInit) {
						sz_resetMargin($cfs.children(), opts);
						FN._init(opts_orig);
						FN._bind_buttons();
						var sz = sz_setSizes($cfs, opts);
						$cfs.trigger(cf_e('updatePageStatus', conf), [true, sz]);
					}
					return opts;
				});
	
				//	linkAnchors event
				$cfs.bind(cf_e('linkAnchors', conf), function (e, $con, sel) {
					e.stopPropagation();
	
					if (is_undefined($con)) {
						$con = $('body');
					} else if (is_string($con)) {
						$con = $($con);
					}
					if (!is_jquery($con) || $con.length == 0) {
						return debug(conf, 'Not a valid object.');
					}
					if (!is_string(sel)) {
						sel = 'a.caroufredsel';
					}
	
					$con.find(sel).each(function () {
						var h = this.hash || '';
						if (h.length > 0 && $cfs.children().index($(h)) != -1) {
							$(this).unbind('click').click(function (e) {
								e.preventDefault();
								$cfs.trigger(cf_e('slideTo', conf), h);
							});
						}
					});
					return true;
				});
	
				//	updatePageStatus event
				$cfs.bind(cf_e('updatePageStatus', conf), function (e, build, sizes) {
					e.stopPropagation();
					if (!opts.pagination.container) {
						return;
					}
	
					var ipp = opts.pagination.items || opts.items.visible,
					    pgs = Math.ceil(itms.total / ipp);
	
					if (build) {
						if (opts.pagination.anchorBuilder) {
							opts.pagination.container.children().remove();
							opts.pagination.container.each(function () {
								for (var a = 0; a < pgs; a++) {
									var i = $cfs.children().eq(gn_getItemIndex(a * ipp, 0, true, itms, $cfs));
									$(this).append(opts.pagination.anchorBuilder.call(i[0], a + 1));
								}
							});
						}
						opts.pagination.container.each(function () {
							$(this).children().unbind(opts.pagination.event).each(function (a) {
								$(this).bind(opts.pagination.event, function (e) {
									e.preventDefault();
									$cfs.trigger(cf_e('slideTo', conf), [a * ipp, -opts.pagination.deviation, true, opts.pagination]);
								});
							});
						});
					}
	
					var selected = $cfs.triggerHandler(cf_e('currentPage', conf)) + opts.pagination.deviation;
					if (selected >= pgs) {
						selected = 0;
					}
					if (selected < 0) {
						selected = pgs - 1;
					}
					opts.pagination.container.each(function () {
						$(this).children().removeClass(cf_c('selected', conf)).eq(selected).addClass(cf_c('selected', conf));
					});
					return true;
				});
	
				//	updateSizes event
				$cfs.bind(cf_e('updateSizes', conf), function (e) {
					var vI = opts.items.visible,
					    a_itm = $cfs.children(),
					    avail_primary = ms_getParentSize($wrp, opts, 'width');
	
					itms.total = a_itm.length;
	
					if (crsl.primarySizePercentage) {
						opts.maxDimension = avail_primary;
						opts[opts.d['width']] = ms_getPercentage(avail_primary, crsl.primarySizePercentage);
					} else {
						opts.maxDimension = ms_getMaxDimension(opts, avail_primary);
					}
	
					if (opts.responsive) {
						opts.items.width = opts.items.sizesConf.width;
						opts.items.height = opts.items.sizesConf.height;
						opts = in_getResponsiveValues(opts, a_itm, avail_primary);
						vI = opts.items.visible;
						sz_setResponsiveSizes(opts, a_itm);
					} else if (opts.items.visibleConf.variable) {
						vI = gn_getVisibleItemsNext(a_itm, opts, 0);
					} else if (opts.items.filter != '*') {
						vI = gn_getVisibleItemsNextFilter(a_itm, opts, 0);
					}
	
					if (!opts.circular && itms.first != 0 && vI > itms.first) {
						if (opts.items.visibleConf.variable) {
							var nI = gn_getVisibleItemsPrev(a_itm, opts, itms.first) - itms.first;
						} else if (opts.items.filter != '*') {
							var nI = gn_getVisibleItemsPrevFilter(a_itm, opts, itms.first) - itms.first;
						} else {
							var nI = opts.items.visible - itms.first;
						}
						debug(conf, 'Preventing non-circular: sliding ' + nI + ' items backward.');
						$cfs.trigger(cf_e('prev', conf), nI);
					}
	
					opts.items.visible = cf_getItemsAdjust(vI, opts, opts.items.visibleConf.adjust, $tt0);
					opts.items.visibleConf.old = opts.items.visible;
					opts = in_getAlignPadding(opts, a_itm);
	
					var sz = sz_setSizes($cfs, opts);
					$cfs.trigger(cf_e('updatePageStatus', conf), [true, sz]);
					nv_showNavi(opts, itms.total, conf);
					nv_enableNavi(opts, itms.first, conf);
	
					return sz;
				});
	
				//	destroy event
				$cfs.bind(cf_e('destroy', conf), function (e, orgOrder) {
					e.stopPropagation();
					tmrs = sc_clearTimers(tmrs);
	
					$cfs.data('_cfs_isCarousel', false);
					$cfs.trigger(cf_e('finish', conf));
					if (orgOrder) {
						$cfs.trigger(cf_e('jumpToStart', conf));
					}
					sz_restoreOrigCss($cfs.children());
					sz_restoreOrigCss($cfs);
					FN._unbind_events();
					FN._unbind_buttons();
					if (conf.wrapper == 'parent') {
						sz_restoreOrigCss($wrp);
					} else {
						$wrp.replaceWith($cfs);
					}
	
					return true;
				});
	
				//	debug event
				$cfs.bind(cf_e('debug', conf), function (e) {
					debug(conf, 'Carousel width: ' + opts.width);
					debug(conf, 'Carousel height: ' + opts.height);
					debug(conf, 'Item widths: ' + opts.items.width);
					debug(conf, 'Item heights: ' + opts.items.height);
					debug(conf, 'Number of items visible: ' + opts.items.visible);
					if (opts.auto.play) {
						debug(conf, 'Number of items scrolled automatically: ' + opts.auto.items);
					}
					if (opts.prev.button) {
						debug(conf, 'Number of items scrolled backward: ' + opts.prev.items);
					}
					if (opts.next.button) {
						debug(conf, 'Number of items scrolled forward: ' + opts.next.items);
					}
					return conf.debug;
				});
	
				//	triggerEvent, making prefixed and namespaced events accessible from outside
				$cfs.bind('_cfs_triggerEvent', function (e, n, o) {
					e.stopPropagation();
					return $cfs.triggerHandler(cf_e(n, conf), o);
				});
			}; //	/bind_events
	
	
			FN._unbind_events = function () {
				$cfs.unbind(cf_e('', conf));
				$cfs.unbind(cf_e('', conf, false));
				$cfs.unbind('_cfs_triggerEvent');
			}; //	/unbind_events
	
	
			FN._bind_buttons = function () {
				FN._unbind_buttons();
				nv_showNavi(opts, itms.total, conf);
				nv_enableNavi(opts, itms.first, conf);
	
				if (opts.auto.pauseOnHover) {
					var pC = bt_pauseOnHoverConfig(opts.auto.pauseOnHover);
					$wrp.bind(cf_e('mouseenter', conf, false), function () {
						$cfs.trigger(cf_e('pause', conf), pC);
					}).bind(cf_e('mouseleave', conf, false), function () {
						$cfs.trigger(cf_e('resume', conf));
					});
				}
	
				//	play button
				if (opts.auto.button) {
					opts.auto.button.bind(cf_e(opts.auto.event, conf, false), function (e) {
						e.preventDefault();
						var ev = false,
						    pC = null;
	
						if (crsl.isPaused) {
							ev = 'play';
						} else if (opts.auto.pauseOnEvent) {
							ev = 'pause';
							pC = bt_pauseOnHoverConfig(opts.auto.pauseOnEvent);
						}
						if (ev) {
							$cfs.trigger(cf_e(ev, conf), pC);
						}
					});
				}
	
				//	prev button
				if (opts.prev.button) {
					opts.prev.button.bind(cf_e(opts.prev.event, conf, false), function (e) {
						e.preventDefault();
						$cfs.trigger(cf_e('prev', conf));
					});
					if (opts.prev.pauseOnHover) {
						var pC = bt_pauseOnHoverConfig(opts.prev.pauseOnHover);
						opts.prev.button.bind(cf_e('mouseenter', conf, false), function () {
							$cfs.trigger(cf_e('pause', conf), pC);
						}).bind(cf_e('mouseleave', conf, false), function () {
							$cfs.trigger(cf_e('resume', conf));
						});
					}
				}
	
				//	next butotn
				if (opts.next.button) {
					opts.next.button.bind(cf_e(opts.next.event, conf, false), function (e) {
						e.preventDefault();
						$cfs.trigger(cf_e('next', conf));
					});
					if (opts.next.pauseOnHover) {
						var pC = bt_pauseOnHoverConfig(opts.next.pauseOnHover);
						opts.next.button.bind(cf_e('mouseenter', conf, false), function () {
							$cfs.trigger(cf_e('pause', conf), pC);
						}).bind(cf_e('mouseleave', conf, false), function () {
							$cfs.trigger(cf_e('resume', conf));
						});
					}
				}
	
				//	pagination
				if (opts.pagination.container) {
					if (opts.pagination.pauseOnHover) {
						var pC = bt_pauseOnHoverConfig(opts.pagination.pauseOnHover);
						opts.pagination.container.bind(cf_e('mouseenter', conf, false), function () {
							$cfs.trigger(cf_e('pause', conf), pC);
						}).bind(cf_e('mouseleave', conf, false), function () {
							$cfs.trigger(cf_e('resume', conf));
						});
					}
				}
	
				//	prev/next keys
				if (opts.prev.key || opts.next.key) {
					$(document).bind(cf_e('keyup', conf, false, true, true), function (e) {
						var k = e.keyCode;
						if (k == opts.next.key) {
							e.preventDefault();
							$cfs.trigger(cf_e('next', conf));
						}
						if (k == opts.prev.key) {
							e.preventDefault();
							$cfs.trigger(cf_e('prev', conf));
						}
					});
				}
	
				//	pagination keys
				if (opts.pagination.keys) {
					$(document).bind(cf_e('keyup', conf, false, true, true), function (e) {
						var k = e.keyCode;
						if (k >= 49 && k < 58) {
							k = (k - 49) * opts.items.visible;
							if (k <= itms.total) {
								e.preventDefault();
								$cfs.trigger(cf_e('slideTo', conf), [k, 0, true, opts.pagination]);
							}
						}
					});
				}
	
				//	swipe
				if ($.fn.swipe) {
					var isTouch = 'ontouchstart' in window;
					if (isTouch && opts.swipe.onTouch || !isTouch && opts.swipe.onMouse) {
						var scP = $.extend(true, {}, opts.prev, opts.swipe),
						    scN = $.extend(true, {}, opts.next, opts.swipe),
						    swP = function swP() {
							$cfs.trigger(cf_e('prev', conf), [scP]);
						},
						    swN = function swN() {
							$cfs.trigger(cf_e('next', conf), [scN]);
						};
	
						switch (opts.direction) {
							case 'up':
							case 'down':
								opts.swipe.options.swipeUp = swN;
								opts.swipe.options.swipeDown = swP;
								break;
							default:
								opts.swipe.options.swipeLeft = swN;
								opts.swipe.options.swipeRight = swP;
						}
						if (crsl.swipe) {
							$cfs.swipe('destroy');
						}
						$wrp.swipe(opts.swipe.options);
						$wrp.css('cursor', 'move');
						crsl.swipe = true;
					}
				}
	
				//	mousewheel
				if ($.fn.mousewheel) {
	
					if (opts.mousewheel) {
						var mcP = $.extend(true, {}, opts.prev, opts.mousewheel),
						    mcN = $.extend(true, {}, opts.next, opts.mousewheel);
	
						if (crsl.mousewheel) {
							$wrp.unbind(cf_e('mousewheel', conf, false));
						}
						$wrp.bind(cf_e('mousewheel', conf, false), function (e, delta) {
							e.preventDefault();
							if (delta > 0) {
								$cfs.trigger(cf_e('prev', conf), [mcP]);
							} else {
								$cfs.trigger(cf_e('next', conf), [mcN]);
							}
						});
						crsl.mousewheel = true;
					}
				}
	
				if (opts.auto.play) {
					$cfs.trigger(cf_e('play', conf), opts.auto.delay);
				}
	
				if (crsl.upDateOnWindowResize) {
					var resizeFn = function resizeFn(e) {
						$cfs.trigger(cf_e('finish', conf));
						if (opts.auto.pauseOnResize && !crsl.isPaused) {
							$cfs.trigger(cf_e('play', conf));
						}
						sz_resetMargin($cfs.children(), opts);
						$cfs.trigger(cf_e('updateSizes', conf));
					};
	
					var $w = $(window),
					    onResize = null;
	
					if ($.debounce && conf.onWindowResize == 'debounce') {
						onResize = $.debounce(200, resizeFn);
					} else if ($.throttle && conf.onWindowResize == 'throttle') {
						onResize = $.throttle(300, resizeFn);
					} else {
						var _windowWidth = 0,
						    _windowHeight = 0;
	
						onResize = function onResize() {
							var nw = $w.width(),
							    nh = $w.height();
	
							if (nw != _windowWidth || nh != _windowHeight) {
								resizeFn();
								_windowWidth = nw;
								_windowHeight = nh;
							}
						};
					}
					$w.bind(cf_e('resize', conf, false, true, true), onResize);
				}
			}; //	/bind_buttons
	
	
			FN._unbind_buttons = function () {
				var ns1 = cf_e('', conf),
				    ns2 = cf_e('', conf, false),
				    ns3 = cf_e('', conf, false, true, true);
	
				$(document).unbind(ns3);
				$(window).unbind(ns3);
				$wrp.unbind(ns2);
	
				if (opts.auto.button) {
					opts.auto.button.unbind(ns2);
				}
				if (opts.prev.button) {
					opts.prev.button.unbind(ns2);
				}
				if (opts.next.button) {
					opts.next.button.unbind(ns2);
				}
				if (opts.pagination.container) {
					opts.pagination.container.unbind(ns2);
					if (opts.pagination.anchorBuilder) {
						opts.pagination.container.children().remove();
					}
				}
				if (crsl.swipe) {
					$cfs.swipe('destroy');
					$wrp.css('cursor', 'default');
					crsl.swipe = false;
				}
				if (crsl.mousewheel) {
					crsl.mousewheel = false;
				}
	
				nv_showNavi(opts, 'hide', conf);
				nv_enableNavi(opts, 'removeClass', conf);
			}; //	/unbind_buttons
	
	
			//	START
	
			if (is_boolean(configs)) {
				configs = {
					'debug': configs
				};
			}
	
			//	set vars
			var crsl = {
				'direction': 'next',
				'isPaused': true,
				'isScrolling': false,
				'isStopped': false,
				'mousewheel': false,
				'swipe': false
			},
			    itms = {
				'total': $cfs.children().length,
				'first': 0
			},
			    tmrs = {
				'auto': null,
				'progress': null,
				'startTime': getTime(),
				'timePassed': 0
			},
			    scrl = {
				'isStopped': false,
				'duration': 0,
				'startTime': 0,
				'easing': '',
				'anims': []
			},
			    clbk = {
				'onBefore': [],
				'onAfter': []
			},
			    queu = [],
			    conf = $.extend(true, {}, $.fn.carouFredSel.configs, configs),
			    opts = {},
			    opts_orig = $.extend(true, {}, options),
			    $wrp = conf.wrapper == 'parent' ? $cfs.parent() : $cfs.wrap('<' + conf.wrapper.element + ' class="' + conf.wrapper.classname + '" />').parent();
	
			conf.selector = $cfs.selector;
			conf.serialNumber = $.fn.carouFredSel.serialNumber++;
	
			conf.transition = conf.transition && $.fn.transition ? 'transition' : 'animate';
	
			//	create carousel
			FN._init(opts_orig, true, starting_position);
			FN._build();
			FN._bind_events();
			FN._bind_buttons();
	
			//	find item to start
			if (is_array(opts.items.start)) {
				var start_arr = opts.items.start;
			} else {
				var start_arr = [];
				if (opts.items.start != 0) {
					start_arr.push(opts.items.start);
				}
			}
			if (opts.cookie) {
				start_arr.unshift(parseInt(cf_getCookie(opts.cookie), 10));
			}
	
			if (start_arr.length > 0) {
				for (var a = 0, l = start_arr.length; a < l; a++) {
					var s = start_arr[a];
					if (s == 0) {
						continue;
					}
					if (s === true) {
						s = window.location.hash;
						if (s.length < 1) {
							continue;
						}
					} else if (s === 'random') {
						s = Math.floor(Math.random() * itms.total);
					}
					if ($cfs.triggerHandler(cf_e('slideTo', conf), [s, 0, true, { fx: 'none' }])) {
						break;
					}
				}
			}
			var siz = sz_setSizes($cfs, opts),
			    itm = gi_getCurrentItems($cfs.children(), opts);
	
			if (opts.onCreate) {
				opts.onCreate.call($tt0, {
					'width': siz.width,
					'height': siz.height,
					'items': itm
				});
			}
	
			$cfs.trigger(cf_e('updatePageStatus', conf), [true, siz]);
			$cfs.trigger(cf_e('linkAnchors', conf));
	
			if (conf.debug) {
				$cfs.trigger(cf_e('debug', conf));
			}
	
			return $cfs;
		};
	
		//	GLOBAL PUBLIC
	
		$.fn.carouFredSel.serialNumber = 1;
		$.fn.carouFredSel.defaults = {
			'synchronise': false,
			'infinite': true,
			'circular': true,
			'responsive': false,
			'direction': 'left',
			'items': {
				'start': 0
			},
			'scroll': {
				'easing': 'swing',
				'duration': 500,
				'pauseOnHover': false,
				'event': 'click',
				'queue': false
			}
		};
		$.fn.carouFredSel.configs = {
			'debug': false,
			'transition': false,
			'onWindowResize': 'throttle',
			'events': {
				'prefix': '',
				'namespace': 'cfs'
			},
			'wrapper': {
				'element': 'div',
				'classname': 'caroufredsel_wrapper'
			},
			'classnames': {}
		};
		$.fn.carouFredSel.pageAnchorBuilder = function (nr) {
			return '<a href="#"><span>' + nr + '</span></a>';
		};
		$.fn.carouFredSel.progressbarUpdater = function (perc) {
			$(this).css('width', perc + '%');
		};
	
		$.fn.carouFredSel.cookie = {
			get: function get(n) {
				n += '=';
				var ca = document.cookie.split(';');
				for (var a = 0, l = ca.length; a < l; a++) {
					var c = ca[a];
					while (c.charAt(0) == ' ') {
						c = c.slice(1);
					}
					if (c.indexOf(n) == 0) {
						return c.slice(n.length);
					}
				}
				return 0;
			},
			set: function set(n, v, d) {
				var e = "";
				if (d) {
					var date = new Date();
					date.setTime(date.getTime() + d * 24 * 60 * 60 * 1000);
					e = "; expires=" + date.toGMTString();
				}
				document.cookie = n + '=' + v + e + '; path=/';
			},
			remove: function remove(n) {
				$.fn.carouFredSel.cookie.set(n, "", -1);
			}
		};
	
		//	GLOBAL PRIVATE
	
		//	scrolling functions
		function sc_setScroll(d, e, c) {
			if (c.transition == 'transition') {
				if (e == 'swing') {
					e = 'ease';
				}
			}
			return {
				anims: [],
				duration: d,
				orgDuration: d,
				easing: e,
				startTime: getTime()
			};
		}
		function sc_startScroll(s, c) {
			for (var a = 0, l = s.anims.length; a < l; a++) {
				var b = s.anims[a];
				if (!b) {
					continue;
				}
				b[0][c.transition](b[1], s.duration, s.easing, b[2]);
			}
		}
		function sc_stopScroll(s, finish) {
			if (!is_boolean(finish)) {
				finish = true;
			}
			if (is_object(s.pre)) {
				sc_stopScroll(s.pre, finish);
			}
			for (var a = 0, l = s.anims.length; a < l; a++) {
				var b = s.anims[a];
				b[0].stop(true);
				if (finish) {
					b[0].css(b[1]);
					if (is_function(b[2])) {
						b[2]();
					}
				}
			}
			if (is_object(s.post)) {
				sc_stopScroll(s.post, finish);
			}
		}
		function sc_afterScroll($c, $c2, o) {
			if ($c2) {
				$c2.remove();
			}
	
			switch (o.fx) {
				case 'fade':
				case 'crossfade':
				case 'cover-fade':
				case 'uncover-fade':
					$c.css('opacity', 1);
					$c.css('filter', '');
					break;
			}
		}
		function sc_fireCallbacks($t, o, b, a, c) {
			if (o[b]) {
				o[b].call($t, a);
			}
			if (c[b].length) {
				for (var i = 0, l = c[b].length; i < l; i++) {
					c[b][i].call($t, a);
				}
			}
			return [];
		}
		function sc_fireQueue($c, q, c) {
	
			if (q.length) {
				$c.trigger(cf_e(q[0][0], c), q[0][1]);
				q.shift();
			}
			return q;
		}
		function sc_hideHiddenItems(hiddenitems) {
			hiddenitems.each(function () {
				var hi = $(this);
				hi.data('_cfs_isHidden', hi.is(':hidden')).hide();
			});
		}
		function sc_showHiddenItems(hiddenitems) {
			if (hiddenitems) {
				hiddenitems.each(function () {
					var hi = $(this);
					if (!hi.data('_cfs_isHidden')) {
						hi.show();
					}
				});
			}
		}
		function sc_clearTimers(t) {
			if (t.auto) {
				clearTimeout(t.auto);
			}
			if (t.progress) {
				clearInterval(t.progress);
			}
			return t;
		}
		function sc_mapCallbackArguments(i_old, i_skp, i_new, s_itm, s_dir, s_dur, w_siz) {
			return {
				'width': w_siz.width,
				'height': w_siz.height,
				'items': {
					'old': i_old,
					'skipped': i_skp,
					'visible': i_new
				},
				'scroll': {
					'items': s_itm,
					'direction': s_dir,
					'duration': s_dur
				}
			};
		}
		function sc_getDuration(sO, o, nI, siz) {
			var dur = sO.duration;
			if (sO.fx == 'none') {
				return 0;
			}
			if (dur == 'auto') {
				dur = o.scroll.duration / o.scroll.items * nI;
			} else if (dur < 10) {
				dur = siz / dur;
			}
			if (dur < 1) {
				return 0;
			}
			if (sO.fx == 'fade') {
				dur = dur / 2;
			}
			return Math.round(dur);
		}
	
		//	navigation functions
		function nv_showNavi(o, t, c) {
			var minimum = is_number(o.items.minimum) ? o.items.minimum : o.items.visible + 1;
			if (t == 'show' || t == 'hide') {
				var f = t;
			} else if (minimum > t) {
				debug(c, 'Not enough items (' + t + ' total, ' + minimum + ' needed): Hiding navigation.');
				var f = 'hide';
			} else {
				var f = 'show';
			}
			var s = f == 'show' ? 'removeClass' : 'addClass',
			    h = cf_c('hidden', c);
	
			if (o.auto.button) {
				o.auto.button[f]()[s](h);
			}
			if (o.prev.button) {
				o.prev.button[f]()[s](h);
			}
			if (o.next.button) {
				o.next.button[f]()[s](h);
			}
			if (o.pagination.container) {
				o.pagination.container[f]()[s](h);
			}
		}
		function nv_enableNavi(o, f, c) {
			if (o.circular || o.infinite) return;
			var fx = f == 'removeClass' || f == 'addClass' ? f : false,
			    di = cf_c('disabled', c);
	
			if (o.auto.button && fx) {
				o.auto.button[fx](di);
			}
			if (o.prev.button) {
				var fn = fx || f == 0 ? 'addClass' : 'removeClass';
				o.prev.button[fn](di);
			}
			if (o.next.button) {
				var fn = fx || f == o.items.visible ? 'addClass' : 'removeClass';
				o.next.button[fn](di);
			}
		}
	
		//	get object functions
		function go_getObject($tt, obj) {
			if (is_function(obj)) {
				obj = obj.call($tt);
			} else if (is_undefined(obj)) {
				obj = {};
			}
			return obj;
		}
		function go_getItemsObject($tt, obj) {
			obj = go_getObject($tt, obj);
			if (is_number(obj)) {
				obj = {
					'visible': obj
				};
			} else if (obj == 'variable') {
				obj = {
					'visible': obj,
					'width': obj,
					'height': obj
				};
			} else if (!is_object(obj)) {
				obj = {};
			}
			return obj;
		}
		function go_getScrollObject($tt, obj) {
			obj = go_getObject($tt, obj);
			if (is_number(obj)) {
				if (obj <= 50) {
					obj = {
						'items': obj
					};
				} else {
					obj = {
						'duration': obj
					};
				}
			} else if (is_string(obj)) {
				obj = {
					'easing': obj
				};
			} else if (!is_object(obj)) {
				obj = {};
			}
			return obj;
		}
		function go_getNaviObject($tt, obj) {
			obj = go_getObject($tt, obj);
			if (is_string(obj)) {
				var temp = cf_getKeyCode(obj);
				if (temp == -1) {
					obj = $(obj);
				} else {
					obj = temp;
				}
			}
			return obj;
		}
	
		function go_getAutoObject($tt, obj) {
			obj = go_getNaviObject($tt, obj);
			if (is_jquery(obj)) {
				obj = {
					'button': obj
				};
			} else if (is_boolean(obj)) {
				obj = {
					'play': obj
				};
			} else if (is_number(obj)) {
				obj = {
					'timeoutDuration': obj
				};
			}
			if (obj.progress) {
				if (is_string(obj.progress) || is_jquery(obj.progress)) {
					obj.progress = {
						'bar': obj.progress
					};
				}
			}
			return obj;
		}
		function go_complementAutoObject($tt, obj) {
			if (is_function(obj.button)) {
				obj.button = obj.button.call($tt);
			}
			if (is_string(obj.button)) {
				obj.button = $(obj.button);
			}
			if (!is_boolean(obj.play)) {
				obj.play = true;
			}
			if (!is_number(obj.delay)) {
				obj.delay = 0;
			}
			if (is_undefined(obj.pauseOnEvent)) {
				obj.pauseOnEvent = true;
			}
			if (!is_boolean(obj.pauseOnResize)) {
				obj.pauseOnResize = true;
			}
			if (!is_number(obj.timeoutDuration)) {
				obj.timeoutDuration = obj.duration < 10 ? 2500 : obj.duration * 5;
			}
			if (obj.progress) {
				if (is_function(obj.progress.bar)) {
					obj.progress.bar = obj.progress.bar.call($tt);
				}
				if (is_string(obj.progress.bar)) {
					obj.progress.bar = $(obj.progress.bar);
				}
				if (obj.progress.bar) {
					if (!is_function(obj.progress.updater)) {
						obj.progress.updater = $.fn.carouFredSel.progressbarUpdater;
					}
					if (!is_number(obj.progress.interval)) {
						obj.progress.interval = 50;
					}
				} else {
					obj.progress = false;
				}
			}
			return obj;
		}
	
		function go_getPrevNextObject($tt, obj) {
			obj = go_getNaviObject($tt, obj);
			if (is_jquery(obj)) {
				obj = {
					'button': obj
				};
			} else if (is_number(obj)) {
				obj = {
					'key': obj
				};
			}
			return obj;
		}
		function go_complementPrevNextObject($tt, obj) {
			if (is_function(obj.button)) {
				obj.button = obj.button.call($tt);
			}
			if (is_string(obj.button)) {
				obj.button = $(obj.button);
			}
			if (is_string(obj.key)) {
				obj.key = cf_getKeyCode(obj.key);
			}
			return obj;
		}
	
		function go_getPaginationObject($tt, obj) {
			obj = go_getNaviObject($tt, obj);
			if (is_jquery(obj)) {
				obj = {
					'container': obj
				};
			} else if (is_boolean(obj)) {
				obj = {
					'keys': obj
				};
			}
			return obj;
		}
		function go_complementPaginationObject($tt, obj) {
			if (is_function(obj.container)) {
				obj.container = obj.container.call($tt);
			}
			if (is_string(obj.container)) {
				obj.container = $(obj.container);
			}
			if (!is_number(obj.items)) {
				obj.items = false;
			}
			if (!is_boolean(obj.keys)) {
				obj.keys = false;
			}
			if (!is_function(obj.anchorBuilder) && !is_false(obj.anchorBuilder)) {
				obj.anchorBuilder = $.fn.carouFredSel.pageAnchorBuilder;
			}
			if (!is_number(obj.deviation)) {
				obj.deviation = 0;
			}
			return obj;
		}
	
		function go_getSwipeObject($tt, obj) {
			if (is_function(obj)) {
				obj = obj.call($tt);
			}
			if (is_undefined(obj)) {
				obj = {
					'onTouch': false
				};
			}
			if (is_true(obj)) {
				obj = {
					'onTouch': obj
				};
			} else if (is_number(obj)) {
				obj = {
					'items': obj
				};
			}
			return obj;
		}
		function go_complementSwipeObject($tt, obj) {
			if (!is_boolean(obj.onTouch)) {
				obj.onTouch = true;
			}
			if (!is_boolean(obj.onMouse)) {
				obj.onMouse = false;
			}
			if (!is_object(obj.options)) {
				obj.options = {};
			}
			if (!is_boolean(obj.options.triggerOnTouchEnd)) {
				obj.options.triggerOnTouchEnd = false;
			}
			return obj;
		}
		function go_getMousewheelObject($tt, obj) {
			if (is_function(obj)) {
				obj = obj.call($tt);
			}
			if (is_true(obj)) {
				obj = {};
			} else if (is_number(obj)) {
				obj = {
					'items': obj
				};
			} else if (is_undefined(obj)) {
				obj = false;
			}
			return obj;
		}
		function go_complementMousewheelObject($tt, obj) {
			return obj;
		}
	
		//	get number functions
		function gn_getItemIndex(num, dev, org, items, $cfs) {
			if (is_string(num)) {
				num = $(num, $cfs);
			}
	
			if (is_object(num)) {
				num = $(num, $cfs);
			}
			if (is_jquery(num)) {
				num = $cfs.children().index(num);
				if (!is_boolean(org)) {
					org = false;
				}
			} else {
				if (!is_boolean(org)) {
					org = true;
				}
			}
			if (!is_number(num)) {
				num = 0;
			}
			if (!is_number(dev)) {
				dev = 0;
			}
	
			if (org) {
				num += items.first;
			}
			num += dev;
			if (items.total > 0) {
				while (num >= items.total) {
					num -= items.total;
				}
				while (num < 0) {
					num += items.total;
				}
			}
			return num;
		}
	
		//	items prev
		function gn_getVisibleItemsPrev(i, o, s) {
			var t = 0,
			    x = 0;
	
			for (var a = s; a >= 0; a--) {
				var j = i.eq(a);
				t += j.is(':visible') ? j[o.d['outerWidth']](true) : 0;
				if (t > o.maxDimension) {
					return x;
				}
				if (a == 0) {
					a = i.length;
				}
				x++;
			}
		}
		function gn_getVisibleItemsPrevFilter(i, o, s) {
			return gn_getItemsPrevFilter(i, o.items.filter, o.items.visibleConf.org, s);
		}
		function gn_getScrollItemsPrevFilter(i, o, s, m) {
			return gn_getItemsPrevFilter(i, o.items.filter, m, s);
		}
		function gn_getItemsPrevFilter(i, f, m, s) {
			var t = 0,
			    x = 0;
	
			for (var a = s, l = i.length; a >= 0; a--) {
				x++;
				if (x == l) {
					return x;
				}
	
				var j = i.eq(a);
				if (j.is(f)) {
					t++;
					if (t == m) {
						return x;
					}
				}
				if (a == 0) {
					a = l;
				}
			}
		}
	
		function gn_getVisibleOrg($c, o) {
			return o.items.visibleConf.org || $c.children().slice(0, o.items.visible).filter(o.items.filter).length;
		}
	
		//	items next
		function gn_getVisibleItemsNext(i, o, s) {
			var t = 0,
			    x = 0;
	
			for (var a = s, l = i.length - 1; a <= l; a++) {
				var j = i.eq(a);
	
				t += j.is(':visible') ? j[o.d['outerWidth']](true) : 0;
				if (t > o.maxDimension) {
					return x;
				}
	
				x++;
				if (x == l + 1) {
					return x;
				}
				if (a == l) {
					a = -1;
				}
			}
		}
		function gn_getVisibleItemsNextTestCircular(i, o, s, l) {
			var v = gn_getVisibleItemsNext(i, o, s);
			if (!o.circular) {
				if (s + v > l) {
					v = l - s;
				}
			}
			return v;
		}
		function gn_getVisibleItemsNextFilter(i, o, s) {
			return gn_getItemsNextFilter(i, o.items.filter, o.items.visibleConf.org, s, o.circular);
		}
		function gn_getScrollItemsNextFilter(i, o, s, m) {
			return gn_getItemsNextFilter(i, o.items.filter, m + 1, s, o.circular) - 1;
		}
		function gn_getItemsNextFilter(i, f, m, s, c) {
			var t = 0,
			    x = 0;
	
			for (var a = s, l = i.length - 1; a <= l; a++) {
				x++;
				if (x >= l) {
					return x;
				}
	
				var j = i.eq(a);
				if (j.is(f)) {
					t++;
					if (t == m) {
						return x;
					}
				}
				if (a == l) {
					a = -1;
				}
			}
		}
	
		//	get items functions
		function gi_getCurrentItems(i, o) {
			return i.slice(0, o.items.visible);
		}
		function gi_getOldItemsPrev(i, o, n) {
			return i.slice(n, o.items.visibleConf.old + n);
		}
		function gi_getNewItemsPrev(i, o) {
			return i.slice(0, o.items.visible);
		}
		function gi_getOldItemsNext(i, o) {
			return i.slice(0, o.items.visibleConf.old);
		}
		function gi_getNewItemsNext(i, o, n) {
			return i.slice(n, o.items.visible + n);
		}
	
		//	sizes functions
		function sz_storeMargin(i, o, d) {
			if (o.usePadding) {
				if (!is_string(d)) {
					d = '_cfs_origCssMargin';
				}
				i.each(function () {
					var j = $(this),
					    m = parseInt(j.css(o.d['marginRight']), 10);
					if (!is_number(m)) {
						m = 0;
					}
					j.data(d, m);
				});
			}
		}
		function sz_resetMargin(i, o, m) {
			if (o.usePadding) {
				var x = is_boolean(m) ? m : false;
				if (!is_number(m)) {
					m = 0;
				}
				sz_storeMargin(i, o, '_cfs_tempCssMargin');
				i.each(function () {
					var j = $(this);
					j.css(o.d['marginRight'], x ? j.data('_cfs_tempCssMargin') : m + j.data('_cfs_origCssMargin'));
				});
			}
		}
		function sz_storeOrigCss(i) {
			i.each(function () {
				var j = $(this);
				j.data('_cfs_origCss', j.attr('style') || '');
			});
		}
		function sz_restoreOrigCss(i) {
			i.each(function () {
				var j = $(this);
				j.attr('style', j.data('_cfs_origCss') || '');
			});
		}
		function sz_setResponsiveSizes(o, all) {
			var visb = o.items.visible,
			    newS = o.items[o.d['width']],
			    seco = o[o.d['height']],
			    secp = is_percentage(seco);
	
			all.each(function () {
				var $t = $(this),
				    nw = newS - ms_getPaddingBorderMargin($t, o, 'Width');
	
				$t[o.d['width']](nw);
				if (secp) {
					$t[o.d['height']](ms_getPercentage(nw, seco));
				}
			});
		}
		function sz_setSizes($c, o) {
			var $w = $c.parent(),
			    $i = $c.children(),
			    $v = gi_getCurrentItems($i, o),
			    sz = cf_mapWrapperSizes(ms_getSizes($v, o, true), o, false);
	
			$w.css(sz);
	
			if (o.usePadding) {
				var p = o.padding,
				    r = p[o.d[1]];
	
				if (o.align && r < 0) {
					r = 0;
				}
				var $l = $v.last();
				$l.css(o.d['marginRight'], $l.data('_cfs_origCssMargin') + r);
				$c.css(o.d['top'], p[o.d[0]]);
				$c.css(o.d['left'], p[o.d[3]]);
			}
	
			$c.css(o.d['width'], sz[o.d['width']] + ms_getTotalSize($i, o, 'width') * 2);
			$c.css(o.d['height'], ms_getLargestSize($i, o, 'height'));
			return sz;
		}
	
		//	measuring functions
		function ms_getSizes(i, o, wrapper) {
			return [ms_getTotalSize(i, o, 'width', wrapper), ms_getLargestSize(i, o, 'height', wrapper)];
		}
		function ms_getLargestSize(i, o, dim, wrapper) {
			if (!is_boolean(wrapper)) {
				wrapper = false;
			}
			if (is_number(o[o.d[dim]]) && wrapper) {
				return o[o.d[dim]];
			}
			if (is_number(o.items[o.d[dim]])) {
				return o.items[o.d[dim]];
			}
			dim = dim.toLowerCase().indexOf('width') > -1 ? 'outerWidth' : 'outerHeight';
			return ms_getTrueLargestSize(i, o, dim);
		}
		function ms_getTrueLargestSize(i, o, dim) {
			var s = 0;
	
			for (var a = 0, l = i.length; a < l; a++) {
				var j = i.eq(a);
	
				var m = j.is(':visible') ? j[o.d[dim]](true) : 0;
				if (s < m) {
					s = m;
				}
			}
			return s;
		}
	
		function ms_getTotalSize(i, o, dim, wrapper) {
			if (!is_boolean(wrapper)) {
				wrapper = false;
			}
			if (is_number(o[o.d[dim]]) && wrapper) {
				return o[o.d[dim]];
			}
			if (is_number(o.items[o.d[dim]])) {
				return o.items[o.d[dim]] * i.length;
			}
	
			var d = dim.toLowerCase().indexOf('width') > -1 ? 'outerWidth' : 'outerHeight',
			    s = 0;
	
			for (var a = 0, l = i.length; a < l; a++) {
				var j = i.eq(a);
				s += j.is(':visible') ? j[o.d[d]](true) : 0;
			}
			return s;
		}
		function ms_getParentSize($w, o, d) {
			var isVisible = $w.is(':visible');
			if (isVisible) {
				$w.hide();
			}
			var s = $w.parent()[o.d[d]]();
			if (isVisible) {
				$w.show();
			}
			return s;
		}
		function ms_getMaxDimension(o, a) {
			return is_number(o[o.d['width']]) ? o[o.d['width']] : a;
		}
		function ms_hasVariableSizes(i, o, dim) {
			var s = false,
			    v = false;
	
			for (var a = 0, l = i.length; a < l; a++) {
				var j = i.eq(a);
	
				var c = j.is(':visible') ? j[o.d[dim]](true) : 0;
				if (s === false) {
					s = c;
				} else if (s != c) {
					v = true;
				}
				if (s == 0) {
					v = true;
				}
			}
			return v;
		}
		function ms_getPaddingBorderMargin(i, o, d) {
			return i[o.d['outer' + d]](true) - i[o.d[d.toLowerCase()]]();
		}
		function ms_getPercentage(s, o) {
			if (is_percentage(o)) {
				o = parseInt(o.slice(0, -1), 10);
				if (!is_number(o)) {
					return s;
				}
				s *= o / 100;
			}
			return s;
		}
	
		//	config functions
		function cf_e(n, c, pf, ns, rd) {
			if (!is_boolean(pf)) {
				pf = true;
			}
			if (!is_boolean(ns)) {
				ns = true;
			}
			if (!is_boolean(rd)) {
				rd = false;
			}
	
			if (pf) {
				n = c.events.prefix + n;
			}
			if (ns) {
				n = n + '.' + c.events.namespace;
			}
			if (ns && rd) {
				n += c.serialNumber;
			}
	
			return n;
		}
		function cf_c(n, c) {
			return is_string(c.classnames[n]) ? c.classnames[n] : n;
		}
		function cf_mapWrapperSizes(ws, o, p) {
			if (!is_boolean(p)) {
				p = true;
			}
			var pad = o.usePadding && p ? o.padding : [0, 0, 0, 0];
			var wra = {};
	
			wra[o.d['width']] = ws[0] + pad[1] + pad[3];
			wra[o.d['height']] = ws[1] + pad[0] + pad[2];
	
			return wra;
		}
		function cf_sortParams(vals, typs) {
			var arr = [];
			for (var a = 0, l1 = vals.length; a < l1; a++) {
				for (var b = 0, l2 = typs.length; b < l2; b++) {
					if (typs[b].indexOf(_typeof(vals[a])) > -1 && is_undefined(arr[b])) {
						arr[b] = vals[a];
						break;
					}
				}
			}
			return arr;
		}
		function cf_getPadding(p) {
			if (is_undefined(p)) {
				return [0, 0, 0, 0];
			}
			if (is_number(p)) {
				return [p, p, p, p];
			}
			if (is_string(p)) {
				p = p.split('px').join('').split('em').join('').split(' ');
			}
	
			if (!is_array(p)) {
				return [0, 0, 0, 0];
			}
			for (var i = 0; i < 4; i++) {
				p[i] = parseInt(p[i], 10);
			}
			switch (p.length) {
				case 0:
					return [0, 0, 0, 0];
				case 1:
					return [p[0], p[0], p[0], p[0]];
				case 2:
					return [p[0], p[1], p[0], p[1]];
				case 3:
					return [p[0], p[1], p[2], p[1]];
				default:
					return [p[0], p[1], p[2], p[3]];
			}
		}
		function cf_getAlignPadding(itm, o) {
			var x = is_number(o[o.d['width']]) ? Math.ceil(o[o.d['width']] - ms_getTotalSize(itm, o, 'width')) : 0;
			switch (o.align) {
				case 'left':
					return [0, x];
				case 'right':
					return [x, 0];
				case 'center':
				default:
					return [Math.ceil(x / 2), Math.floor(x / 2)];
			}
		}
		function cf_getDimensions(o) {
			var dm = [['width', 'innerWidth', 'outerWidth', 'height', 'innerHeight', 'outerHeight', 'left', 'top', 'marginRight', 0, 1, 2, 3], ['height', 'innerHeight', 'outerHeight', 'width', 'innerWidth', 'outerWidth', 'top', 'left', 'marginBottom', 3, 2, 1, 0]];
	
			var dl = dm[0].length,
			    dx = o.direction == 'right' || o.direction == 'left' ? 0 : 1;
	
			var dimensions = {};
			for (var d = 0; d < dl; d++) {
				dimensions[dm[0][d]] = dm[dx][d];
			}
			return dimensions;
		}
		function cf_getAdjust(x, o, a, $t) {
			var v = x;
			if (is_function(a)) {
				v = a.call($t, v);
			} else if (is_string(a)) {
				var p = a.split('+'),
				    m = a.split('-');
	
				if (m.length > p.length) {
					var neg = true,
					    sta = m[0],
					    adj = m[1];
				} else {
					var neg = false,
					    sta = p[0],
					    adj = p[1];
				}
	
				switch (sta) {
					case 'even':
						v = x % 2 == 1 ? x - 1 : x;
						break;
					case 'odd':
						v = x % 2 == 0 ? x - 1 : x;
						break;
					default:
						v = x;
						break;
				}
				adj = parseInt(adj, 10);
				if (is_number(adj)) {
					if (neg) {
						adj = -adj;
					}
					v += adj;
				}
			}
			if (!is_number(v) || v < 1) {
				v = 1;
			}
			return v;
		}
		function cf_getItemsAdjust(x, o, a, $t) {
			return cf_getItemAdjustMinMax(cf_getAdjust(x, o, a, $t), o.items.visibleConf);
		}
		function cf_getItemAdjustMinMax(v, i) {
			if (is_number(i.min) && v < i.min) {
				v = i.min;
			}
			if (is_number(i.max) && v > i.max) {
				v = i.max;
			}
			if (v < 1) {
				v = 1;
			}
			return v;
		}
		function cf_getSynchArr(s) {
			if (!is_array(s)) {
				s = [[s]];
			}
			if (!is_array(s[0])) {
				s = [s];
			}
			for (var j = 0, l = s.length; j < l; j++) {
				if (is_string(s[j][0])) {
					s[j][0] = $(s[j][0]);
				}
				if (!is_boolean(s[j][1])) {
					s[j][1] = true;
				}
				if (!is_boolean(s[j][2])) {
					s[j][2] = true;
				}
				if (!is_number(s[j][3])) {
					s[j][3] = 0;
				}
			}
			return s;
		}
		function cf_getKeyCode(k) {
			if (k == 'right') {
				return 39;
			}
			if (k == 'left') {
				return 37;
			}
			if (k == 'up') {
				return 38;
			}
			if (k == 'down') {
				return 40;
			}
			return -1;
		}
		function cf_setCookie(n, $c, c) {
			if (n) {
				var v = $c.triggerHandler(cf_e('currentPosition', c));
				$.fn.carouFredSel.cookie.set(n, v);
			}
		}
		function cf_getCookie(n) {
			var c = $.fn.carouFredSel.cookie.get(n);
			return c == '' ? 0 : c;
		}
	
		//	init function
		function in_mapCss($elem, props) {
			var css = {};
			for (var p = 0, l = props.length; p < l; p++) {
				css[props[p]] = $elem.css(props[p]);
			}
			return css;
		}
		function in_complementItems(obj, opt, itm, sta) {
			if (!is_object(obj.visibleConf)) {
				obj.visibleConf = {};
			}
			if (!is_object(obj.sizesConf)) {
				obj.sizesConf = {};
			}
	
			if (obj.start == 0 && is_number(sta)) {
				obj.start = sta;
			}
	
			//	visible items
			if (is_object(obj.visible)) {
				obj.visibleConf.min = obj.visible.min;
				obj.visibleConf.max = obj.visible.max;
				obj.visible = false;
			} else if (is_string(obj.visible)) {
				//	variable visible items
				if (obj.visible == 'variable') {
					obj.visibleConf.variable = true;
				}
				//	adjust string visible items
				else {
						obj.visibleConf.adjust = obj.visible;
					}
				obj.visible = false;
			} else if (is_function(obj.visible)) {
				obj.visibleConf.adjust = obj.visible;
				obj.visible = false;
			}
	
			//	set items filter
			if (!is_string(obj.filter)) {
				obj.filter = itm.filter(':hidden').length > 0 ? ':visible' : '*';
			}
	
			//	primary item-size not set
			if (!obj[opt.d['width']]) {
				//	responsive carousel -> set to largest
				if (opt.responsive) {
					debug(true, 'Set a ' + opt.d['width'] + ' for the items!');
					obj[opt.d['width']] = ms_getTrueLargestSize(itm, opt, 'outerWidth');
				}
				//	 non-responsive -> measure it or set to "variable"
				else {
						obj[opt.d['width']] = ms_hasVariableSizes(itm, opt, 'outerWidth') ? 'variable' : itm[opt.d['outerWidth']](true);
					}
			}
	
			//	secondary item-size not set -> measure it or set to "variable"
			if (!obj[opt.d['height']]) {
				obj[opt.d['height']] = ms_hasVariableSizes(itm, opt, 'outerHeight') ? 'variable' : itm[opt.d['outerHeight']](true);
			}
	
			obj.sizesConf.width = obj.width;
			obj.sizesConf.height = obj.height;
			return obj;
		}
		function in_complementVisibleItems(opt, avl) {
			//	primary item-size variable -> set visible items variable
			if (opt.items[opt.d['width']] == 'variable') {
				opt.items.visibleConf.variable = true;
			}
			if (!opt.items.visibleConf.variable) {
				//	primary size is number -> calculate visible-items
				if (is_number(opt[opt.d['width']])) {
					opt.items.visible = Math.floor(opt[opt.d['width']] / opt.items[opt.d['width']]);
				}
				//	measure and calculate primary size and visible-items
				else {
						opt.items.visible = Math.floor(avl / opt.items[opt.d['width']]);
						opt[opt.d['width']] = opt.items.visible * opt.items[opt.d['width']];
						if (!opt.items.visibleConf.adjust) {
							opt.align = false;
						}
					}
				if (opt.items.visible == 'Infinity' || opt.items.visible < 1) {
					debug(true, 'Not a valid number of visible items: Set to "variable".');
					opt.items.visibleConf.variable = true;
				}
			}
			return opt;
		}
		function in_complementPrimarySize(obj, opt, all) {
			//	primary size set to auto -> measure largest item-size and set it
			if (obj == 'auto') {
				obj = ms_getTrueLargestSize(all, opt, 'outerWidth');
			}
			return obj;
		}
		function in_complementSecondarySize(obj, opt, all) {
			//	secondary size set to auto -> measure largest item-size and set it
			if (obj == 'auto') {
				obj = ms_getTrueLargestSize(all, opt, 'outerHeight');
			}
			//	secondary size not set -> set to secondary item-size
			if (!obj) {
				obj = opt.items[opt.d['height']];
			}
			return obj;
		}
		function in_getAlignPadding(o, all) {
			var p = cf_getAlignPadding(gi_getCurrentItems(all, o), o);
			o.padding[o.d[1]] = p[1];
			o.padding[o.d[3]] = p[0];
			return o;
		}
		function in_getResponsiveValues(o, all, avl) {
	
			var visb = cf_getItemAdjustMinMax(Math.ceil(o[o.d['width']] / o.items[o.d['width']]), o.items.visibleConf);
			if (visb > all.length) {
				visb = all.length;
			}
	
			var newS = Math.floor(o[o.d['width']] / visb);
	
			o.items.visible = visb;
			o.items[o.d['width']] = newS;
			o[o.d['width']] = visb * newS;
			return o;
		}
	
		//	buttons functions
		function bt_pauseOnHoverConfig(p) {
			if (is_string(p)) {
				var i = p.indexOf('immediate') > -1 ? true : false,
				    r = p.indexOf('resume') > -1 ? true : false;
			} else {
				var i = r = false;
			}
			return [i, r];
		}
		function bt_mousesheelNumber(mw) {
			return is_number(mw) ? mw : null;
		}
	
		//	helper functions
		function is_null(a) {
			return a === null;
		}
		function is_undefined(a) {
			return is_null(a) || typeof a == 'undefined' || a === '' || a === 'undefined';
		}
		function is_array(a) {
			return a instanceof Array;
		}
		function is_jquery(a) {
			return a instanceof jQuery;
		}
		function is_object(a) {
			return (a instanceof Object || (typeof a === 'undefined' ? 'undefined' : _typeof(a)) == 'object') && !is_null(a) && !is_jquery(a) && !is_array(a) && !is_function(a);
		}
		function is_number(a) {
			return (a instanceof Number || typeof a == 'number') && !isNaN(a);
		}
		function is_string(a) {
			return (a instanceof String || typeof a == 'string') && !is_undefined(a) && !is_true(a) && !is_false(a);
		}
		function is_function(a) {
			return a instanceof Function || typeof a == 'function';
		}
		function is_boolean(a) {
			return a instanceof Boolean || typeof a == 'boolean' || is_true(a) || is_false(a);
		}
		function is_true(a) {
			return a === true || a === 'true';
		}
		function is_false(a) {
			return a === false || a === 'false';
		}
		function is_percentage(x) {
			return is_string(x) && x.slice(-1) == '%';
		}
	
		function getTime() {
			return new Date().getTime();
		}
	
		function deprecated(o, n) {
			debug(true, o + ' is DEPRECATED, support for it will be removed. Use ' + n + ' instead.');
		}
		function debug(d, m) {
			if (!is_undefined(window.console) && !is_undefined(window.console.log)) {
				if (is_object(d)) {
					var s = ' (' + d.selector + ')';
					d = d.debug;
				} else {
					var s = '';
				}
				if (!d) {
					return false;
				}
	
				if (is_string(m)) {
					m = 'carouFredSel' + s + ': ' + m;
				} else {
					m = ['carouFredSel' + s + ':', m];
				}
				window.console.log(m);
			}
			return false;
		}
	
		//	EASING FUNCTIONS
		$.extend($.easing, {
			'quadratic': function quadratic(t) {
				var t2 = t * t;
				return t * (-t2 * t + 4 * t2 - 6 * t + 4);
			},
			'cubic': function cubic(t) {
				return t * (4 * t * t - 9 * t + 6);
			},
			'elastic': function elastic(t) {
				var t2 = t * t;
				return t * (33 * t2 * t2 - 106 * t2 * t + 126 * t2 - 67 * t + 15);
			}
		});
	})(jQuery);

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * @fileOverview TouchSwipe - jQuery Plugin
	 * @version 1.6.18
	 *
	 * @author Matt Bryson http://www.github.com/mattbryson
	 * @see https://github.com/mattbryson/TouchSwipe-Jquery-Plugin
	 * @see http://labs.rampinteractive.co.uk/touchSwipe/
	 * @see http://plugins.jquery.com/project/touchSwipe
	 * @license
	 * Copyright (c) 2010-2015 Matt Bryson
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 *
	 */
	
	/*
	 *
	 * Changelog
	 * $Date: 2010-12-12 (Wed, 12 Dec 2010) $
	 * $version: 1.0.0
	 * $version: 1.0.1 - removed multibyte comments
	 *
	 * $Date: 2011-21-02 (Mon, 21 Feb 2011) $
	 * $version: 1.1.0 	- added allowPageScroll property to allow swiping and scrolling of page
	 *					- changed handler signatures so one handler can be used for multiple events
	 * $Date: 2011-23-02 (Wed, 23 Feb 2011) $
	 * $version: 1.2.0 	- added click handler. This is fired if the user simply clicks and does not swipe. The event object and click target are passed to handler.
	 *					- If you use the http://code.google.com/p/jquery-ui-for-ipad-and-iphone/ plugin, you can also assign jQuery mouse events to children of a touchSwipe object.
	 * $version: 1.2.1 	- removed console log!
	 *
	 * $version: 1.2.2 	- Fixed bug where scope was not preserved in callback methods.
	 *
	 * $Date: 2011-28-04 (Thurs, 28 April 2011) $
	 * $version: 1.2.4 	- Changed licence terms to be MIT or GPL inline with jQuery. Added check for support of touch events to stop non compatible browsers erroring.
	 *
	 * $Date: 2011-27-09 (Tues, 27 September 2011) $
	 * $version: 1.2.5 	- Added support for testing swipes with mouse on desktop browser (thanks to https://github.com/joelhy)
	 *
	 * $Date: 2012-14-05 (Mon, 14 May 2012) $
	 * $version: 1.2.6 	- Added timeThreshold between start and end touch, so user can ignore slow swipes (thanks to Mark Chase). Default is null, all swipes are detected
	 *
	 * $Date: 2012-05-06 (Tues, 05 June 2012) $
	 * $version: 1.2.7 	- Changed time threshold to have null default for backwards compatibility. Added duration param passed back in events, and refactored how time is handled.
	 *
	 * $Date: 2012-05-06 (Tues, 05 June 2012) $
	 * $version: 1.2.8 	- Added the possibility to return a value like null or false in the trigger callback. In that way we can control when the touch start/move should take effect or not (simply by returning in some cases return null; or return false;) This effects the ontouchstart/ontouchmove event.
	 *
	 * $Date: 2012-06-06 (Wed, 06 June 2012) $
	 * $version: 1.3.0 	- Refactored whole plugin to allow for methods to be executed, as well as exposed defaults for user override. Added 'enable', 'disable', and 'destroy' methods
	 *
	 * $Date: 2012-05-06 (Fri, 05 June 2012) $
	 * $version: 1.3.1 	- Bug fixes  - bind() with false as last argument is no longer supported in jQuery 1.6, also, if you just click, the duration is now returned correctly.
	 *
	 * $Date: 2012-29-07 (Sun, 29 July 2012) $
	 * $version: 1.3.2	- Added fallbackToMouseEvents option to NOT capture mouse events on non touch devices.
	 * 			- Added "all" fingers value to the fingers property, so any combination of fingers triggers the swipe, allowing event handlers to check the finger count
	 *
	 * $Date: 2012-09-08 (Thurs, 9 Aug 2012) $
	 * $version: 1.3.3	- Code tidy prep for minefied version
	 *
	 * $Date: 2012-04-10 (wed, 4 Oct 2012) $
	 * $version: 1.4.0	- Added pinch support, pinchIn and pinchOut
	 *
	 * $Date: 2012-11-10 (Thurs, 11 Oct 2012) $
	 * $version: 1.5.0	- Added excludedElements, a jquery selector that specifies child elements that do NOT trigger swipes. By default, this is .noSwipe
	 *
	 * $Date: 2012-22-10 (Mon, 22 Oct 2012) $
	 * $version: 1.5.1	- Fixed bug with jQuery 1.8 and trailing comma in excludedElements
	 *					- Fixed bug with IE and eventPreventDefault()
	 * $Date: 2013-01-12 (Fri, 12 Jan 2013) $
	 * $version: 1.6.0	- Fixed bugs with pinching, mainly when both pinch and swipe enabled, as well as adding time threshold for multifinger gestures, so releasing one finger beofre the other doesnt trigger as single finger gesture.
	 *					- made the demo site all static local HTML pages so they can be run locally by a developer
	 *					- added jsDoc comments and added documentation for the plugin
	 *					- code tidy
	 *					- added triggerOnTouchLeave property that will end the event when the user swipes off the element.
	 * $Date: 2013-03-23 (Sat, 23 Mar 2013) $
	 * $version: 1.6.1	- Added support for ie8 touch events
	 * $version: 1.6.2	- Added support for events binding with on / off / bind in jQ for all callback names.
	 *                   - Deprecated the 'click' handler in favour of tap.
	 *                   - added cancelThreshold property
	 *                   - added option method to update init options at runtime
	 * $version 1.6.3    - added doubletap, longtap events and longTapThreshold, doubleTapThreshold property
	 *
	 * $Date: 2013-04-04 (Thurs, 04 April 2013) $
	 * $version 1.6.4    - Fixed bug with cancelThreshold introduced in 1.6.3, where swipe status no longer fired start event, and stopped once swiping back.
	 *
	 * $Date: 2013-08-24 (Sat, 24 Aug 2013) $
	 * $version 1.6.5    - Merged a few pull requests fixing various bugs, added AMD support.
	 *
	 * $Date: 2014-06-04 (Wed, 04 June 2014) $
	 * $version 1.6.6 	- Merge of pull requests.
	 *    				- IE10 touch support
	 *    				- Only prevent default event handling on valid swipe
	 *    				- Separate license/changelog comment
	 *    				- Detect if the swipe is valid at the end of the touch event.
	 *    				- Pass fingerdata to event handlers.
	 *    				- Add 'hold' gesture
	 *    				- Be more tolerant about the tap distance
	 *    				- Typos and minor fixes
	 *
	 * $Date: 2015-22-01 (Thurs, 22 Jan 2015) $
	 * $version 1.6.7    - Added patch from https://github.com/mattbryson/TouchSwipe-Jquery-Plugin/issues/206 to fix memory leak
	 *
	 * $Date: 2015-2-2 (Mon, 2 Feb 2015) $
	 * $version 1.6.8    - Added preventDefaultEvents option to proxy events regardless.
	 *					- Fixed issue with swipe and pinch not triggering at the same time
	 *
	 * $Date: 2015-9-6 (Tues, 9 June 2015) $
	 * $version 1.6.9    - Added PR from jdalton/hybrid to fix pointer events
	 *					- Added scrolling demo
	 *					- Added version property to plugin
	 *
	 * $Date: 2015-1-10 (Wed, 1 October 2015) $
	 * $version 1.6.10    - Added PR from beatspace to fix tap events
	 * $version 1.6.11    - Added PRs from indri-indri ( Doc tidyup), kkirsche ( Bower tidy up ), UziTech (preventDefaultEvents fixes )
	 *					 - Allowed setting multiple options via .swipe("options", options_hash) and more simply .swipe(options_hash) or exisitng instances
	 * $version 1.6.12    - Fixed bug with multi finger releases above 2 not triggering events
	 *
	 * $Date: 2015-12-18 (Fri, 18 December 2015) $
	 * $version 1.6.13    - Added PRs
	 *                    - Fixed #267 allowPageScroll not working correctly
	 * $version 1.6.14    - Fixed #220 / #248 doubletap not firing with swipes, #223 commonJS compatible
	 * $version 1.6.15    - More bug fixes
	 *
	 * $Date: 2016-04-29 (Fri, 29 April 2016) $
	 * $version 1.6.16    - Swipes with 0 distance now allow default events to trigger.  So tapping any form elements or A tags will allow default interaction, but swiping will trigger a swipe.
	                        Removed the a, input, select etc from the excluded Children list as the 0 distance tap solves that issue.
	* $Date: 2016-05-19  (Fri, 29 April 2016) $
	* $version 1.6.17     - Fixed context issue when calling instance methods via $("selector").swipe("method");
	* $version 1.6.18     - now honors fallbackToMouseEvents=false for MS Pointer events when a Mouse is used.
	
	 */
	
	/**
	 * See (http://jquery.com/).
	 * @name $
	 * @class
	 * See the jQuery Library  (http://jquery.com/) for full details.  This just
	 * documents the function and classes that are added to jQuery by this plug-in.
	 */
	
	/**
	 * See (http://jquery.com/)
	 * @name fn
	 * @class
	 * See the jQuery Library  (http://jquery.com/) for full details.  This just
	 * documents the function and classes that are added to jQuery by this plug-in.
	 * @memberOf $
	 */
	
	(function (factory) {
	  if ("function" === 'function' && __webpack_require__(20) && __webpack_require__(20).jQuery) {
	    // AMD. Register as anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module.exports) {
	    // CommonJS Module
	    factory(__webpack_require__(1));
	  } else {
	    // Browser globals.
	    factory(jQuery);
	  }
	})(function ($) {
	  "use strict";
	
	  //Constants
	
	  var VERSION = "1.6.18",
	      LEFT = "left",
	      RIGHT = "right",
	      UP = "up",
	      DOWN = "down",
	      IN = "in",
	      OUT = "out",
	      NONE = "none",
	      AUTO = "auto",
	      SWIPE = "swipe",
	      PINCH = "pinch",
	      TAP = "tap",
	      DOUBLE_TAP = "doubletap",
	      LONG_TAP = "longtap",
	      HOLD = "hold",
	      HORIZONTAL = "horizontal",
	      VERTICAL = "vertical",
	      ALL_FINGERS = "all",
	      DOUBLE_TAP_THRESHOLD = 10,
	      PHASE_START = "start",
	      PHASE_MOVE = "move",
	      PHASE_END = "end",
	      PHASE_CANCEL = "cancel",
	      SUPPORTS_TOUCH = 'ontouchstart' in window,
	      SUPPORTS_POINTER_IE10 = window.navigator.msPointerEnabled && !window.navigator.pointerEnabled && !SUPPORTS_TOUCH,
	      SUPPORTS_POINTER = (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && !SUPPORTS_TOUCH,
	      PLUGIN_NS = 'TouchSwipe';
	
	  /**
	  * The default configuration, and available options to configure touch swipe with.
	  * You can set the default values by updating any of the properties prior to instantiation.
	  * @name $.fn.swipe.defaults
	  * @namespace
	  * @property {int} [fingers=1] The number of fingers to detect in a swipe. Any swipes that do not meet this requirement will NOT trigger swipe handlers.
	  * @property {int} [threshold=75] The number of pixels that the user must move their finger by before it is considered a swipe.
	  * @property {int} [cancelThreshold=null] The number of pixels that the user must move their finger back from the original swipe direction to cancel the gesture.
	  * @property {int} [pinchThreshold=20] The number of pixels that the user must pinch their finger by before it is considered a pinch.
	  * @property {int} [maxTimeThreshold=null] Time, in milliseconds, between touchStart and touchEnd must NOT exceed in order to be considered a swipe.
	  * @property {int} [fingerReleaseThreshold=250] Time in milliseconds between releasing multiple fingers.  If 2 fingers are down, and are released one after the other, if they are within this threshold, it counts as a simultaneous release.
	  * @property {int} [longTapThreshold=500] Time in milliseconds between tap and release for a long tap
	  * @property {int} [doubleTapThreshold=200] Time in milliseconds between 2 taps to count as a double tap
	  * @property {function} [swipe=null] A handler to catch all swipes. See {@link $.fn.swipe#event:swipe}
	  * @property {function} [swipeLeft=null] A handler that is triggered for "left" swipes. See {@link $.fn.swipe#event:swipeLeft}
	  * @property {function} [swipeRight=null] A handler that is triggered for "right" swipes. See {@link $.fn.swipe#event:swipeRight}
	  * @property {function} [swipeUp=null] A handler that is triggered for "up" swipes. See {@link $.fn.swipe#event:swipeUp}
	  * @property {function} [swipeDown=null] A handler that is triggered for "down" swipes. See {@link $.fn.swipe#event:swipeDown}
	  * @property {function} [swipeStatus=null] A handler triggered for every phase of the swipe. See {@link $.fn.swipe#event:swipeStatus}
	  * @property {function} [pinchIn=null] A handler triggered for pinch in events. See {@link $.fn.swipe#event:pinchIn}
	  * @property {function} [pinchOut=null] A handler triggered for pinch out events. See {@link $.fn.swipe#event:pinchOut}
	  * @property {function} [pinchStatus=null] A handler triggered for every phase of a pinch. See {@link $.fn.swipe#event:pinchStatus}
	  * @property {function} [tap=null] A handler triggered when a user just taps on the item, rather than swipes it. If they do not move, tap is triggered, if they do move, it is not.
	  * @property {function} [doubleTap=null] A handler triggered when a user double taps on the item. The delay between taps can be set with the doubleTapThreshold property. See {@link $.fn.swipe.defaults#doubleTapThreshold}
	  * @property {function} [longTap=null] A handler triggered when a user long taps on the item. The delay between start and end can be set with the longTapThreshold property. See {@link $.fn.swipe.defaults#longTapThreshold}
	  * @property (function) [hold=null] A handler triggered when a user reaches longTapThreshold on the item. See {@link $.fn.swipe.defaults#longTapThreshold}
	  * @property {boolean} [triggerOnTouchEnd=true] If true, the swipe events are triggered when the touch end event is received (user releases finger).  If false, it will be triggered on reaching the threshold, and then cancel the touch event automatically.
	  * @property {boolean} [triggerOnTouchLeave=false] If true, then when the user leaves the swipe object, the swipe will end and trigger appropriate handlers.
	  * @property {string|undefined} [allowPageScroll='auto'] How the browser handles page scrolls when the user is swiping on a touchSwipe object. See {@link $.fn.swipe.pageScroll}.  <br/><br/>
	  									<code>"auto"</code> : all undefined swipes will cause the page to scroll in that direction. <br/>
	  									<code>"none"</code> : the page will not scroll when user swipes. <br/>
	  									<code>"horizontal"</code> : will force page to scroll on horizontal swipes. <br/>
	  									<code>"vertical"</code> : will force page to scroll on vertical swipes. <br/>
	  * @property {boolean} [fallbackToMouseEvents=true] If true mouse events are used when run on a non touch device, false will stop swipes being triggered by mouse events on non tocuh devices.
	  * @property {string} [excludedElements=".noSwipe"] A jquery selector that specifies child elements that do NOT trigger swipes. By default this excludes elements with the class .noSwipe .
	  * @property {boolean} [preventDefaultEvents=true] by default default events are cancelled, so the page doesn't move.  You can dissable this so both native events fire as well as your handlers.
	    */
	  var defaults = {
	    fingers: 1,
	    threshold: 75,
	    cancelThreshold: null,
	    pinchThreshold: 20,
	    maxTimeThreshold: null,
	    fingerReleaseThreshold: 250,
	    longTapThreshold: 500,
	    doubleTapThreshold: 200,
	    swipe: null,
	    swipeLeft: null,
	    swipeRight: null,
	    swipeUp: null,
	    swipeDown: null,
	    swipeStatus: null,
	    pinchIn: null,
	    pinchOut: null,
	    pinchStatus: null,
	    click: null, //Deprecated since 1.6.2
	    tap: null,
	    doubleTap: null,
	    longTap: null,
	    hold: null,
	    triggerOnTouchEnd: true,
	    triggerOnTouchLeave: false,
	    allowPageScroll: "auto",
	    fallbackToMouseEvents: true,
	    excludedElements: ".noSwipe",
	    preventDefaultEvents: true
	  };
	
	  /**
	   * Applies TouchSwipe behaviour to one or more jQuery objects.
	   * The TouchSwipe plugin can be instantiated via this method, or methods within
	   * TouchSwipe can be executed via this method as per jQuery plugin architecture.
	   * An existing plugin can have its options changed simply by re calling .swipe(options)
	   * @see TouchSwipe
	   * @class
	   * @param {Mixed} method If the current DOMNode is a TouchSwipe object, and <code>method</code> is a TouchSwipe method, then
	   * the <code>method</code> is executed, and any following arguments are passed to the TouchSwipe method.
	   * If <code>method</code> is an object, then the TouchSwipe class is instantiated on the current DOMNode, passing the
	   * configuration properties defined in the object. See TouchSwipe
	   *
	   */
	  $.fn.swipe = function (method) {
	    var $this = $(this),
	        plugin = $this.data(PLUGIN_NS);
	
	    //Check if we are already instantiated and trying to execute a method
	    if (plugin && typeof method === 'string') {
	      if (plugin[method]) {
	        return plugin[method].apply(plugin, Array.prototype.slice.call(arguments, 1));
	      } else {
	        $.error('Method ' + method + ' does not exist on jQuery.swipe');
	      }
	    }
	
	    //Else update existing plugin with new options hash
	    else if (plugin && (typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object') {
	        plugin['option'].apply(plugin, arguments);
	      }
	
	      //Else not instantiated and trying to pass init object (or nothing)
	      else if (!plugin && ((typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object' || !method)) {
	          return init.apply(this, arguments);
	        }
	
	    return $this;
	  };
	
	  /**
	   * The version of the plugin
	   * @readonly
	   */
	  $.fn.swipe.version = VERSION;
	
	  //Expose our defaults so a user could override the plugin defaults
	  $.fn.swipe.defaults = defaults;
	
	  /**
	   * The phases that a touch event goes through.  The <code>phase</code> is passed to the event handlers.
	   * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
	   * @namespace
	   * @readonly
	   * @property {string} PHASE_START Constant indicating the start phase of the touch event. Value is <code>"start"</code>.
	   * @property {string} PHASE_MOVE Constant indicating the move phase of the touch event. Value is <code>"move"</code>.
	   * @property {string} PHASE_END Constant indicating the end phase of the touch event. Value is <code>"end"</code>.
	   * @property {string} PHASE_CANCEL Constant indicating the cancel phase of the touch event. Value is <code>"cancel"</code>.
	   */
	  $.fn.swipe.phases = {
	    PHASE_START: PHASE_START,
	    PHASE_MOVE: PHASE_MOVE,
	    PHASE_END: PHASE_END,
	    PHASE_CANCEL: PHASE_CANCEL
	  };
	
	  /**
	   * The direction constants that are passed to the event handlers.
	   * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
	   * @namespace
	   * @readonly
	   * @property {string} LEFT Constant indicating the left direction. Value is <code>"left"</code>.
	   * @property {string} RIGHT Constant indicating the right direction. Value is <code>"right"</code>.
	   * @property {string} UP Constant indicating the up direction. Value is <code>"up"</code>.
	   * @property {string} DOWN Constant indicating the down direction. Value is <code>"cancel"</code>.
	   * @property {string} IN Constant indicating the in direction. Value is <code>"in"</code>.
	   * @property {string} OUT Constant indicating the out direction. Value is <code>"out"</code>.
	   */
	  $.fn.swipe.directions = {
	    LEFT: LEFT,
	    RIGHT: RIGHT,
	    UP: UP,
	    DOWN: DOWN,
	    IN: IN,
	    OUT: OUT
	  };
	
	  /**
	   * The page scroll constants that can be used to set the value of <code>allowPageScroll</code> option
	   * These properties are read only
	   * @namespace
	   * @readonly
	   * @see $.fn.swipe.defaults#allowPageScroll
	   * @property {string} NONE Constant indicating no page scrolling is allowed. Value is <code>"none"</code>.
	   * @property {string} HORIZONTAL Constant indicating horizontal page scrolling is allowed. Value is <code>"horizontal"</code>.
	   * @property {string} VERTICAL Constant indicating vertical page scrolling is allowed. Value is <code>"vertical"</code>.
	   * @property {string} AUTO Constant indicating either horizontal or vertical will be allowed, depending on the swipe handlers registered. Value is <code>"auto"</code>.
	   */
	  $.fn.swipe.pageScroll = {
	    NONE: NONE,
	    HORIZONTAL: HORIZONTAL,
	    VERTICAL: VERTICAL,
	    AUTO: AUTO
	  };
	
	  /**
	   * Constants representing the number of fingers used in a swipe.  These are used to set both the value of <code>fingers</code> in the
	   * options object, as well as the value of the <code>fingers</code> event property.
	   * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
	   * @namespace
	   * @readonly
	   * @see $.fn.swipe.defaults#fingers
	   * @property {string} ONE Constant indicating 1 finger is to be detected / was detected. Value is <code>1</code>.
	   * @property {string} TWO Constant indicating 2 fingers are to be detected / were detected. Value is <code>2</code>.
	   * @property {string} THREE Constant indicating 3 finger are to be detected / were detected. Value is <code>3</code>.
	   * @property {string} FOUR Constant indicating 4 finger are to be detected / were detected. Not all devices support this. Value is <code>4</code>.
	   * @property {string} FIVE Constant indicating 5 finger are to be detected / were detected. Not all devices support this. Value is <code>5</code>.
	   * @property {string} ALL Constant indicating any combination of finger are to be detected.  Value is <code>"all"</code>.
	   */
	  $.fn.swipe.fingers = {
	    ONE: 1,
	    TWO: 2,
	    THREE: 3,
	    FOUR: 4,
	    FIVE: 5,
	    ALL: ALL_FINGERS
	  };
	
	  /**
	   * Initialise the plugin for each DOM element matched
	   * This creates a new instance of the main TouchSwipe class for each DOM element, and then
	   * saves a reference to that instance in the elements data property.
	   * @internal
	   */
	  function init(options) {
	    //Prep and extend the options
	    if (options && options.allowPageScroll === undefined && (options.swipe !== undefined || options.swipeStatus !== undefined)) {
	      options.allowPageScroll = NONE;
	    }
	
	    //Check for deprecated options
	    //Ensure that any old click handlers are assigned to the new tap, unless we have a tap
	    if (options.click !== undefined && options.tap === undefined) {
	      options.tap = options.click;
	    }
	
	    if (!options) {
	      options = {};
	    }
	
	    //pass empty object so we dont modify the defaults
	    options = $.extend({}, $.fn.swipe.defaults, options);
	
	    //For each element instantiate the plugin
	    return this.each(function () {
	      var $this = $(this);
	
	      //Check we havent already initialised the plugin
	      var plugin = $this.data(PLUGIN_NS);
	
	      if (!plugin) {
	        plugin = new TouchSwipe(this, options);
	        $this.data(PLUGIN_NS, plugin);
	      }
	    });
	  }
	
	  /**
	   * Main TouchSwipe Plugin Class.
	   * Do not use this to construct your TouchSwipe object, use the jQuery plugin method $.fn.swipe(); {@link $.fn.swipe}
	   * @private
	   * @name TouchSwipe
	   * @param {DOMNode} element The HTML DOM object to apply to plugin to
	   * @param {Object} options The options to configure the plugin with.  @link {$.fn.swipe.defaults}
	   * @see $.fh.swipe.defaults
	   * @see $.fh.swipe
	   * @class
	   */
	  function TouchSwipe(element, options) {
	
	    //take a local/instacne level copy of the options - should make it this.options really...
	    var options = $.extend({}, options);
	
	    var useTouchEvents = SUPPORTS_TOUCH || SUPPORTS_POINTER || !options.fallbackToMouseEvents,
	        START_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? 'MSPointerDown' : 'pointerdown' : 'touchstart' : 'mousedown',
	        MOVE_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? 'MSPointerMove' : 'pointermove' : 'touchmove' : 'mousemove',
	        END_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? 'MSPointerUp' : 'pointerup' : 'touchend' : 'mouseup',
	        LEAVE_EV = useTouchEvents ? SUPPORTS_POINTER ? 'mouseleave' : null : 'mouseleave',
	        //we manually detect leave on touch devices, so null event here
	    CANCEL_EV = SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? 'MSPointerCancel' : 'pointercancel' : 'touchcancel';
	
	    //touch properties
	    var distance = 0,
	        direction = null,
	        currentDirection = null,
	        duration = 0,
	        startTouchesDistance = 0,
	        endTouchesDistance = 0,
	        pinchZoom = 1,
	        pinchDistance = 0,
	        pinchDirection = 0,
	        maximumsMap = null;
	
	    //jQuery wrapped element for this instance
	    var $element = $(element);
	
	    //Current phase of th touch cycle
	    var phase = "start";
	
	    // the current number of fingers being used.
	    var fingerCount = 0;
	
	    //track mouse points / delta
	    var fingerData = {};
	
	    //track times
	    var startTime = 0,
	        endTime = 0,
	        previousTouchEndTime = 0,
	        fingerCountAtRelease = 0,
	        doubleTapStartTime = 0;
	
	    //Timeouts
	    var singleTapTimeout = null,
	        holdTimeout = null;
	
	    // Add gestures to all swipable areas if supported
	    try {
	      $element.bind(START_EV, touchStart);
	      $element.bind(CANCEL_EV, touchCancel);
	    } catch (e) {
	      $.error('events not supported ' + START_EV + ',' + CANCEL_EV + ' on jQuery.swipe');
	    }
	
	    //
	    //Public methods
	    //
	
	    /**
	     * re-enables the swipe plugin with the previous configuration
	     * @function
	     * @name $.fn.swipe#enable
	     * @return {DOMNode} The Dom element that was registered with TouchSwipe
	     * @example $("#element").swipe("enable");
	     */
	    this.enable = function () {
	      //Incase we are already enabled, clean up...
	      this.disable();
	      $element.bind(START_EV, touchStart);
	      $element.bind(CANCEL_EV, touchCancel);
	      return $element;
	    };
	
	    /**
	     * disables the swipe plugin
	     * @function
	     * @name $.fn.swipe#disable
	     * @return {DOMNode} The Dom element that is now registered with TouchSwipe
	     * @example $("#element").swipe("disable");
	     */
	    this.disable = function () {
	      removeListeners();
	      return $element;
	    };
	
	    /**
	     * Destroy the swipe plugin completely. To use any swipe methods, you must re initialise the plugin.
	     * @function
	     * @name $.fn.swipe#destroy
	     * @example $("#element").swipe("destroy");
	     */
	    this.destroy = function () {
	      removeListeners();
	      $element.data(PLUGIN_NS, null);
	      $element = null;
	    };
	
	    /**
	     * Allows run time updating of the swipe configuration options.
	     * @function
	     * @name $.fn.swipe#option
	     * @param {String} property The option property to get or set, or a has of multiple options to set
	     * @param {Object} [value] The value to set the property to
	     * @return {Object} If only a property name is passed, then that property value is returned. If nothing is passed the current options hash is returned.
	     * @example $("#element").swipe("option", "threshold"); // return the threshold
	     * @example $("#element").swipe("option", "threshold", 100); // set the threshold after init
	     * @example $("#element").swipe("option", {threshold:100, fingers:3} ); // set multiple properties after init
	     * @example $("#element").swipe({threshold:100, fingers:3} ); // set multiple properties after init - the "option" method is optional!
	     * @example $("#element").swipe("option"); // Return the current options hash
	     * @see $.fn.swipe.defaults
	     *
	     */
	    this.option = function (property, value) {
	
	      if ((typeof property === 'undefined' ? 'undefined' : _typeof(property)) === 'object') {
	        options = $.extend(options, property);
	      } else if (options[property] !== undefined) {
	        if (value === undefined) {
	          return options[property];
	        } else {
	          options[property] = value;
	        }
	      } else if (!property) {
	        return options;
	      } else {
	        $.error('Option ' + property + ' does not exist on jQuery.swipe.options');
	      }
	
	      return null;
	    };
	
	    //
	    // Private methods
	    //
	
	    //
	    // EVENTS
	    //
	    /**
	     * Event handler for a touch start event.
	     * Stops the default click event from triggering and stores where we touched
	     * @inner
	     * @param {object} jqEvent The normalised jQuery event object.
	     */
	    function touchStart(jqEvent) {
	
	      //If we already in a touch event (a finger already in use) then ignore subsequent ones..
	      if (getTouchInProgress()) {
	        return;
	      }
	
	      //Check if this element matches any in the excluded elements selectors,  or its parent is excluded, if so, DON'T swipe
	      if ($(jqEvent.target).closest(options.excludedElements, $element).length > 0) {
	        return;
	      }
	
	      //As we use Jquery bind for events, we need to target the original event object
	      //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
	      var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
	
	      //If we have a pointer event, whoes type is 'mouse' and we have said NO mouse events, then dont do anything.
	      if (event.pointerType && event.pointerType == "mouse" && options.fallbackToMouseEvents == false) {
	        return;
	      };
	
	      var ret,
	          touches = event.touches,
	          evt = touches ? touches[0] : event;
	
	      phase = PHASE_START;
	
	      //If we support touches, get the finger count
	      if (touches) {
	        // get the total number of fingers touching the screen
	        fingerCount = touches.length;
	      }
	      //Else this is the desktop, so stop the browser from dragging content
	      else if (options.preventDefaultEvents !== false) {
	          jqEvent.preventDefault(); //call this on jq event so we are cross browser
	        }
	
	      //clear vars..
	      distance = 0;
	      direction = null;
	      currentDirection = null;
	      pinchDirection = null;
	      duration = 0;
	      startTouchesDistance = 0;
	      endTouchesDistance = 0;
	      pinchZoom = 1;
	      pinchDistance = 0;
	      maximumsMap = createMaximumsData();
	      cancelMultiFingerRelease();
	
	      //Create the default finger data
	      createFingerData(0, evt);
	
	      // check the number of fingers is what we are looking for, or we are capturing pinches
	      if (!touches || fingerCount === options.fingers || options.fingers === ALL_FINGERS || hasPinches()) {
	        // get the coordinates of the touch
	        startTime = getTimeStamp();
	
	        if (fingerCount == 2) {
	          //Keep track of the initial pinch distance, so we can calculate the diff later
	          //Store second finger data as start
	          createFingerData(1, touches[1]);
	          startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
	        }
	
	        if (options.swipeStatus || options.pinchStatus) {
	          ret = triggerHandler(event, phase);
	        }
	      } else {
	        //A touch with more or less than the fingers we are looking for, so cancel
	        ret = false;
	      }
	
	      //If we have a return value from the users handler, then return and cancel
	      if (ret === false) {
	        phase = PHASE_CANCEL;
	        triggerHandler(event, phase);
	        return ret;
	      } else {
	        if (options.hold) {
	          holdTimeout = setTimeout($.proxy(function () {
	            //Trigger the event
	            $element.trigger('hold', [event.target]);
	            //Fire the callback
	            if (options.hold) {
	              ret = options.hold.call($element, event, event.target);
	            }
	          }, this), options.longTapThreshold);
	        }
	
	        setTouchInProgress(true);
	      }
	
	      return null;
	    };
	
	    /**
	     * Event handler for a touch move event.
	     * If we change fingers during move, then cancel the event
	     * @inner
	     * @param {object} jqEvent The normalised jQuery event object.
	     */
	    function touchMove(jqEvent) {
	
	      //As we use Jquery bind for events, we need to target the original event object
	      //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
	      var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
	
	      //If we are ending, cancelling, or within the threshold of 2 fingers being released, don't track anything..
	      if (phase === PHASE_END || phase === PHASE_CANCEL || inMultiFingerRelease()) return;
	
	      var ret,
	          touches = event.touches,
	          evt = touches ? touches[0] : event;
	
	      //Update the  finger data
	      var currentFinger = updateFingerData(evt);
	      endTime = getTimeStamp();
	
	      if (touches) {
	        fingerCount = touches.length;
	      }
	
	      if (options.hold) {
	        clearTimeout(holdTimeout);
	      }
	
	      phase = PHASE_MOVE;
	
	      //If we have 2 fingers get Touches distance as well
	      if (fingerCount == 2) {
	
	        //Keep track of the initial pinch distance, so we can calculate the diff later
	        //We do this here as well as the start event, in case they start with 1 finger, and the press 2 fingers
	        if (startTouchesDistance == 0) {
	          //Create second finger if this is the first time...
	          createFingerData(1, touches[1]);
	
	          startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
	        } else {
	          //Else just update the second finger
	          updateFingerData(touches[1]);
	
	          endTouchesDistance = calculateTouchesDistance(fingerData[0].end, fingerData[1].end);
	          pinchDirection = calculatePinchDirection(fingerData[0].end, fingerData[1].end);
	        }
	
	        pinchZoom = calculatePinchZoom(startTouchesDistance, endTouchesDistance);
	        pinchDistance = Math.abs(startTouchesDistance - endTouchesDistance);
	      }
	
	      if (fingerCount === options.fingers || options.fingers === ALL_FINGERS || !touches || hasPinches()) {
	
	        //The overall direction of the swipe. From start to now.
	        direction = calculateDirection(currentFinger.start, currentFinger.end);
	
	        //The immediate direction of the swipe, direction between the last movement and this one.
	        currentDirection = calculateDirection(currentFinger.last, currentFinger.end);
	
	        //Check if we need to prevent default event (page scroll / pinch zoom) or not
	        validateDefaultEvent(jqEvent, currentDirection);
	
	        //Distance and duration are all off the main finger
	        distance = calculateDistance(currentFinger.start, currentFinger.end);
	        duration = calculateDuration();
	
	        //Cache the maximum distance we made in this direction
	        setMaxDistance(direction, distance);
	
	        //Trigger status handler
	        ret = triggerHandler(event, phase);
	
	        //If we trigger end events when threshold are met, or trigger events when touch leaves element
	        if (!options.triggerOnTouchEnd || options.triggerOnTouchLeave) {
	
	          var inBounds = true;
	
	          //If checking if we leave the element, run the bounds check (we can use touchleave as its not supported on webkit)
	          if (options.triggerOnTouchLeave) {
	            var bounds = getbounds(this);
	            inBounds = isInBounds(currentFinger.end, bounds);
	          }
	
	          //Trigger end handles as we swipe if thresholds met or if we have left the element if the user has asked to check these..
	          if (!options.triggerOnTouchEnd && inBounds) {
	            phase = getNextPhase(PHASE_MOVE);
	          }
	          //We end if out of bounds here, so set current phase to END, and check if its modified
	          else if (options.triggerOnTouchLeave && !inBounds) {
	              phase = getNextPhase(PHASE_END);
	            }
	
	          if (phase == PHASE_CANCEL || phase == PHASE_END) {
	            triggerHandler(event, phase);
	          }
	        }
	      } else {
	        phase = PHASE_CANCEL;
	        triggerHandler(event, phase);
	      }
	
	      if (ret === false) {
	        phase = PHASE_CANCEL;
	        triggerHandler(event, phase);
	      }
	    }
	
	    /**
	     * Event handler for a touch end event.
	     * Calculate the direction and trigger events
	     * @inner
	     * @param {object} jqEvent The normalised jQuery event object.
	     */
	    function touchEnd(jqEvent) {
	      //As we use Jquery bind for events, we need to target the original event object
	      //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
	      var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent,
	          touches = event.touches;
	
	      //If we are still in a touch with the device wait a fraction and see if the other finger comes up
	      //if it does within the threshold, then we treat it as a multi release, not a single release and end the touch / swipe
	      if (touches) {
	        if (touches.length && !inMultiFingerRelease()) {
	          startMultiFingerRelease(event);
	          return true;
	        } else if (touches.length && inMultiFingerRelease()) {
	          return true;
	        }
	      }
	
	      //If a previous finger has been released, check how long ago, if within the threshold, then assume it was a multifinger release.
	      //This is used to allow 2 fingers to release fractionally after each other, whilst maintaining the event as containing 2 fingers, not 1
	      if (inMultiFingerRelease()) {
	        fingerCount = fingerCountAtRelease;
	      }
	
	      //Set end of swipe
	      endTime = getTimeStamp();
	
	      //Get duration incase move was never fired
	      duration = calculateDuration();
	
	      //If we trigger handlers at end of swipe OR, we trigger during, but they didnt trigger and we are still in the move phase
	      if (didSwipeBackToCancel() || !validateSwipeDistance()) {
	        phase = PHASE_CANCEL;
	        triggerHandler(event, phase);
	      } else if (options.triggerOnTouchEnd || options.triggerOnTouchEnd === false && phase === PHASE_MOVE) {
	        //call this on jq event so we are cross browser
	        if (options.preventDefaultEvents !== false) {
	          jqEvent.preventDefault();
	        }
	        phase = PHASE_END;
	        triggerHandler(event, phase);
	      }
	      //Special cases - A tap should always fire on touch end regardless,
	      //So here we manually trigger the tap end handler by itself
	      //We dont run trigger handler as it will re-trigger events that may have fired already
	      else if (!options.triggerOnTouchEnd && hasTap()) {
	          //Trigger the pinch events...
	          phase = PHASE_END;
	          triggerHandlerForGesture(event, phase, TAP);
	        } else if (phase === PHASE_MOVE) {
	          phase = PHASE_CANCEL;
	          triggerHandler(event, phase);
	        }
	
	      setTouchInProgress(false);
	
	      return null;
	    }
	
	    /**
	     * Event handler for a touch cancel event.
	     * Clears current vars
	     * @inner
	     */
	    function touchCancel() {
	      // reset the variables back to default values
	      fingerCount = 0;
	      endTime = 0;
	      startTime = 0;
	      startTouchesDistance = 0;
	      endTouchesDistance = 0;
	      pinchZoom = 1;
	
	      //If we were in progress of tracking a possible multi touch end, then re set it.
	      cancelMultiFingerRelease();
	
	      setTouchInProgress(false);
	    }
	
	    /**
	     * Event handler for a touch leave event.
	     * This is only triggered on desktops, in touch we work this out manually
	     * as the touchleave event is not supported in webkit
	     * @inner
	     */
	    function touchLeave(jqEvent) {
	      //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
	      var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
	
	      //If we have the trigger on leave property set....
	      if (options.triggerOnTouchLeave) {
	        phase = getNextPhase(PHASE_END);
	        triggerHandler(event, phase);
	      }
	    }
	
	    /**
	     * Removes all listeners that were associated with the plugin
	     * @inner
	     */
	    function removeListeners() {
	      $element.unbind(START_EV, touchStart);
	      $element.unbind(CANCEL_EV, touchCancel);
	      $element.unbind(MOVE_EV, touchMove);
	      $element.unbind(END_EV, touchEnd);
	
	      //we only have leave events on desktop, we manually calculate leave on touch as its not supported in webkit
	      if (LEAVE_EV) {
	        $element.unbind(LEAVE_EV, touchLeave);
	      }
	
	      setTouchInProgress(false);
	    }
	
	    /**
	     * Checks if the time and distance thresholds have been met, and if so then the appropriate handlers are fired.
	     */
	    function getNextPhase(currentPhase) {
	
	      var nextPhase = currentPhase;
	
	      // Ensure we have valid swipe (under time and over distance  and check if we are out of bound...)
	      var validTime = validateSwipeTime();
	      var validDistance = validateSwipeDistance();
	      var didCancel = didSwipeBackToCancel();
	
	      //If we have exceeded our time, then cancel
	      if (!validTime || didCancel) {
	        nextPhase = PHASE_CANCEL;
	      }
	      //Else if we are moving, and have reached distance then end
	      else if (validDistance && currentPhase == PHASE_MOVE && (!options.triggerOnTouchEnd || options.triggerOnTouchLeave)) {
	          nextPhase = PHASE_END;
	        }
	        //Else if we have ended by leaving and didn't reach distance, then cancel
	        else if (!validDistance && currentPhase == PHASE_END && options.triggerOnTouchLeave) {
	            nextPhase = PHASE_CANCEL;
	          }
	
	      return nextPhase;
	    }
	
	    /**
	     * Trigger the relevant event handler
	     * The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
	     * @param {object} event the original event object
	     * @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
	     * @inner
	     */
	    function triggerHandler(event, phase) {
	
	      var ret,
	          touches = event.touches;
	
	      // SWIPE GESTURES
	      if (didSwipe() || hasSwipes()) {
	        ret = triggerHandlerForGesture(event, phase, SWIPE);
	      }
	
	      // PINCH GESTURES (if the above didn't cancel)
	      if ((didPinch() || hasPinches()) && ret !== false) {
	        ret = triggerHandlerForGesture(event, phase, PINCH);
	      }
	
	      // CLICK / TAP (if the above didn't cancel)
	      if (didDoubleTap() && ret !== false) {
	        //Trigger the tap events...
	        ret = triggerHandlerForGesture(event, phase, DOUBLE_TAP);
	      }
	
	      // CLICK / TAP (if the above didn't cancel)
	      else if (didLongTap() && ret !== false) {
	          //Trigger the tap events...
	          ret = triggerHandlerForGesture(event, phase, LONG_TAP);
	        }
	
	        // CLICK / TAP (if the above didn't cancel)
	        else if (didTap() && ret !== false) {
	            //Trigger the tap event..
	            ret = triggerHandlerForGesture(event, phase, TAP);
	          }
	
	      // If we are cancelling the gesture, then manually trigger the reset handler
	      if (phase === PHASE_CANCEL) {
	
	        touchCancel(event);
	      }
	
	      // If we are ending the gesture, then manually trigger the reset handler IF all fingers are off
	      if (phase === PHASE_END) {
	        //If we support touch, then check that all fingers are off before we cancel
	        if (touches) {
	          if (!touches.length) {
	            touchCancel(event);
	          }
	        } else {
	          touchCancel(event);
	        }
	      }
	
	      return ret;
	    }
	
	    /**
	     * Trigger the relevant event handler
	     * The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
	     * @param {object} event the original event object
	     * @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
	     * @param {string} gesture the gesture to trigger a handler for : PINCH or SWIPE {@link $.fn.swipe.gestures}
	     * @return Boolean False, to indicate that the event should stop propagation, or void.
	     * @inner
	     */
	    function triggerHandlerForGesture(event, phase, gesture) {
	
	      var ret;
	
	      //SWIPES....
	      if (gesture == SWIPE) {
	        //Trigger status every time..
	        $element.trigger('swipeStatus', [phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection]);
	
	        if (options.swipeStatus) {
	          ret = options.swipeStatus.call($element, event, phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection);
	          //If the status cancels, then dont run the subsequent event handlers..
	          if (ret === false) return false;
	        }
	
	        if (phase == PHASE_END && validateSwipe()) {
	
	          //Cancel any taps that were in progress...
	          clearTimeout(singleTapTimeout);
	          clearTimeout(holdTimeout);
	
	          $element.trigger('swipe', [direction, distance, duration, fingerCount, fingerData, currentDirection]);
	
	          if (options.swipe) {
	            ret = options.swipe.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
	            //If the status cancels, then dont run the subsequent event handlers..
	            if (ret === false) return false;
	          }
	
	          //trigger direction specific event handlers
	          switch (direction) {
	            case LEFT:
	              $element.trigger('swipeLeft', [direction, distance, duration, fingerCount, fingerData, currentDirection]);
	
	              if (options.swipeLeft) {
	                ret = options.swipeLeft.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
	              }
	              break;
	
	            case RIGHT:
	              $element.trigger('swipeRight', [direction, distance, duration, fingerCount, fingerData, currentDirection]);
	
	              if (options.swipeRight) {
	                ret = options.swipeRight.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
	              }
	              break;
	
	            case UP:
	              $element.trigger('swipeUp', [direction, distance, duration, fingerCount, fingerData, currentDirection]);
	
	              if (options.swipeUp) {
	                ret = options.swipeUp.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
	              }
	              break;
	
	            case DOWN:
	              $element.trigger('swipeDown', [direction, distance, duration, fingerCount, fingerData, currentDirection]);
	
	              if (options.swipeDown) {
	                ret = options.swipeDown.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
	              }
	              break;
	          }
	        }
	      }
	
	      //PINCHES....
	      if (gesture == PINCH) {
	        $element.trigger('pinchStatus', [phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);
	
	        if (options.pinchStatus) {
	          ret = options.pinchStatus.call($element, event, phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
	          //If the status cancels, then dont run the subsequent event handlers..
	          if (ret === false) return false;
	        }
	
	        if (phase == PHASE_END && validatePinch()) {
	
	          switch (pinchDirection) {
	            case IN:
	              $element.trigger('pinchIn', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);
	
	              if (options.pinchIn) {
	                ret = options.pinchIn.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
	              }
	              break;
	
	            case OUT:
	              $element.trigger('pinchOut', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);
	
	              if (options.pinchOut) {
	                ret = options.pinchOut.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
	              }
	              break;
	          }
	        }
	      }
	
	      if (gesture == TAP) {
	        if (phase === PHASE_CANCEL || phase === PHASE_END) {
	
	          clearTimeout(singleTapTimeout);
	          clearTimeout(holdTimeout);
	
	          //If we are also looking for doubelTaps, wait incase this is one...
	          if (hasDoubleTap() && !inDoubleTap()) {
	            doubleTapStartTime = getTimeStamp();
	
	            //Now wait for the double tap timeout, and trigger this single tap
	            //if its not cancelled by a double tap
	            singleTapTimeout = setTimeout($.proxy(function () {
	              doubleTapStartTime = null;
	              $element.trigger('tap', [event.target]);
	
	              if (options.tap) {
	                ret = options.tap.call($element, event, event.target);
	              }
	            }, this), options.doubleTapThreshold);
	          } else {
	            doubleTapStartTime = null;
	            $element.trigger('tap', [event.target]);
	            if (options.tap) {
	              ret = options.tap.call($element, event, event.target);
	            }
	          }
	        }
	      } else if (gesture == DOUBLE_TAP) {
	        if (phase === PHASE_CANCEL || phase === PHASE_END) {
	          clearTimeout(singleTapTimeout);
	          clearTimeout(holdTimeout);
	          doubleTapStartTime = null;
	          $element.trigger('doubletap', [event.target]);
	
	          if (options.doubleTap) {
	            ret = options.doubleTap.call($element, event, event.target);
	          }
	        }
	      } else if (gesture == LONG_TAP) {
	        if (phase === PHASE_CANCEL || phase === PHASE_END) {
	          clearTimeout(singleTapTimeout);
	          doubleTapStartTime = null;
	
	          $element.trigger('longtap', [event.target]);
	          if (options.longTap) {
	            ret = options.longTap.call($element, event, event.target);
	          }
	        }
	      }
	
	      return ret;
	    }
	
	    //
	    // GESTURE VALIDATION
	    //
	
	    /**
	     * Checks the user has swipe far enough
	     * @return Boolean if <code>threshold</code> has been set, return true if the threshold was met, else false.
	     * If no threshold was set, then we return true.
	     * @inner
	     */
	    function validateSwipeDistance() {
	      var valid = true;
	      //If we made it past the min swipe distance..
	      if (options.threshold !== null) {
	        valid = distance >= options.threshold;
	      }
	
	      return valid;
	    }
	
	    /**
	     * Checks the user has swiped back to cancel.
	     * @return Boolean if <code>cancelThreshold</code> has been set, return true if the cancelThreshold was met, else false.
	     * If no cancelThreshold was set, then we return true.
	     * @inner
	     */
	    function didSwipeBackToCancel() {
	      var cancelled = false;
	      if (options.cancelThreshold !== null && direction !== null) {
	        cancelled = getMaxDistance(direction) - distance >= options.cancelThreshold;
	      }
	
	      return cancelled;
	    }
	
	    /**
	     * Checks the user has pinched far enough
	     * @return Boolean if <code>pinchThreshold</code> has been set, return true if the threshold was met, else false.
	     * If no threshold was set, then we return true.
	     * @inner
	     */
	    function validatePinchDistance() {
	      if (options.pinchThreshold !== null) {
	        return pinchDistance >= options.pinchThreshold;
	      }
	      return true;
	    }
	
	    /**
	     * Checks that the time taken to swipe meets the minimum / maximum requirements
	     * @return Boolean
	     * @inner
	     */
	    function validateSwipeTime() {
	      var result;
	      //If no time set, then return true
	      if (options.maxTimeThreshold) {
	        if (duration >= options.maxTimeThreshold) {
	          result = false;
	        } else {
	          result = true;
	        }
	      } else {
	        result = true;
	      }
	
	      return result;
	    }
	
	    /**
	     * Checks direction of the swipe and the value allowPageScroll to see if we should allow or prevent the default behaviour from occurring.
	     * This will essentially allow page scrolling or not when the user is swiping on a touchSwipe object.
	     * @param {object} jqEvent The normalised jQuery representation of the event object.
	     * @param {string} direction The direction of the event. See {@link $.fn.swipe.directions}
	     * @see $.fn.swipe.directions
	     * @inner
	     */
	    function validateDefaultEvent(jqEvent, direction) {
	
	      //If the option is set, allways allow the event to bubble up (let user handle weirdness)
	      if (options.preventDefaultEvents === false) {
	        return;
	      }
	
	      if (options.allowPageScroll === NONE) {
	        jqEvent.preventDefault();
	      } else {
	        var auto = options.allowPageScroll === AUTO;
	
	        switch (direction) {
	          case LEFT:
	            if (options.swipeLeft && auto || !auto && options.allowPageScroll != HORIZONTAL) {
	              jqEvent.preventDefault();
	            }
	            break;
	
	          case RIGHT:
	            if (options.swipeRight && auto || !auto && options.allowPageScroll != HORIZONTAL) {
	              jqEvent.preventDefault();
	            }
	            break;
	
	          case UP:
	            if (options.swipeUp && auto || !auto && options.allowPageScroll != VERTICAL) {
	              jqEvent.preventDefault();
	            }
	            break;
	
	          case DOWN:
	            if (options.swipeDown && auto || !auto && options.allowPageScroll != VERTICAL) {
	              jqEvent.preventDefault();
	            }
	            break;
	
	          case NONE:
	
	            break;
	        }
	      }
	    }
	
	    // PINCHES
	    /**
	     * Returns true of the current pinch meets the thresholds
	     * @return Boolean
	     * @inner
	     */
	    function validatePinch() {
	      var hasCorrectFingerCount = validateFingers();
	      var hasEndPoint = validateEndPoint();
	      var hasCorrectDistance = validatePinchDistance();
	      return hasCorrectFingerCount && hasEndPoint && hasCorrectDistance;
	    }
	
	    /**
	     * Returns true if any Pinch events have been registered
	     * @return Boolean
	     * @inner
	     */
	    function hasPinches() {
	      //Enure we dont return 0 or null for false values
	      return !!(options.pinchStatus || options.pinchIn || options.pinchOut);
	    }
	
	    /**
	     * Returns true if we are detecting pinches, and have one
	     * @return Boolean
	     * @inner
	     */
	    function didPinch() {
	      //Enure we dont return 0 or null for false values
	      return !!(validatePinch() && hasPinches());
	    }
	
	    // SWIPES
	    /**
	     * Returns true if the current swipe meets the thresholds
	     * @return Boolean
	     * @inner
	     */
	    function validateSwipe() {
	      //Check validity of swipe
	      var hasValidTime = validateSwipeTime();
	      var hasValidDistance = validateSwipeDistance();
	      var hasCorrectFingerCount = validateFingers();
	      var hasEndPoint = validateEndPoint();
	      var didCancel = didSwipeBackToCancel();
	
	      // if the user swiped more than the minimum length, perform the appropriate action
	      // hasValidDistance is null when no distance is set
	      var valid = !didCancel && hasEndPoint && hasCorrectFingerCount && hasValidDistance && hasValidTime;
	
	      return valid;
	    }
	
	    /**
	     * Returns true if any Swipe events have been registered
	     * @return Boolean
	     * @inner
	     */
	    function hasSwipes() {
	      //Enure we dont return 0 or null for false values
	      return !!(options.swipe || options.swipeStatus || options.swipeLeft || options.swipeRight || options.swipeUp || options.swipeDown);
	    }
	
	    /**
	     * Returns true if we are detecting swipes and have one
	     * @return Boolean
	     * @inner
	     */
	    function didSwipe() {
	      //Enure we dont return 0 or null for false values
	      return !!(validateSwipe() && hasSwipes());
	    }
	
	    /**
	     * Returns true if we have matched the number of fingers we are looking for
	     * @return Boolean
	     * @inner
	     */
	    function validateFingers() {
	      //The number of fingers we want were matched, or on desktop we ignore
	      return fingerCount === options.fingers || options.fingers === ALL_FINGERS || !SUPPORTS_TOUCH;
	    }
	
	    /**
	     * Returns true if we have an end point for the swipe
	     * @return Boolean
	     * @inner
	     */
	    function validateEndPoint() {
	      //We have an end value for the finger
	      return fingerData[0].end.x !== 0;
	    }
	
	    // TAP / CLICK
	    /**
	     * Returns true if a click / tap events have been registered
	     * @return Boolean
	     * @inner
	     */
	    function hasTap() {
	      //Enure we dont return 0 or null for false values
	      return !!options.tap;
	    }
	
	    /**
	     * Returns true if a double tap events have been registered
	     * @return Boolean
	     * @inner
	     */
	    function hasDoubleTap() {
	      //Enure we dont return 0 or null for false values
	      return !!options.doubleTap;
	    }
	
	    /**
	     * Returns true if any long tap events have been registered
	     * @return Boolean
	     * @inner
	     */
	    function hasLongTap() {
	      //Enure we dont return 0 or null for false values
	      return !!options.longTap;
	    }
	
	    /**
	     * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
	     * @return Boolean
	     * @inner
	     */
	    function validateDoubleTap() {
	      if (doubleTapStartTime == null) {
	        return false;
	      }
	      var now = getTimeStamp();
	      return hasDoubleTap() && now - doubleTapStartTime <= options.doubleTapThreshold;
	    }
	
	    /**
	     * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
	     * @return Boolean
	     * @inner
	     */
	    function inDoubleTap() {
	      return validateDoubleTap();
	    }
	
	    /**
	     * Returns true if we have a valid tap
	     * @return Boolean
	     * @inner
	     */
	    function validateTap() {
	      return (fingerCount === 1 || !SUPPORTS_TOUCH) && (isNaN(distance) || distance < options.threshold);
	    }
	
	    /**
	     * Returns true if we have a valid long tap
	     * @return Boolean
	     * @inner
	     */
	    function validateLongTap() {
	      //slight threshold on moving finger
	      return duration > options.longTapThreshold && distance < DOUBLE_TAP_THRESHOLD;
	    }
	
	    /**
	     * Returns true if we are detecting taps and have one
	     * @return Boolean
	     * @inner
	     */
	    function didTap() {
	      //Enure we dont return 0 or null for false values
	      return !!(validateTap() && hasTap());
	    }
	
	    /**
	     * Returns true if we are detecting double taps and have one
	     * @return Boolean
	     * @inner
	     */
	    function didDoubleTap() {
	      //Enure we dont return 0 or null for false values
	      return !!(validateDoubleTap() && hasDoubleTap());
	    }
	
	    /**
	     * Returns true if we are detecting long taps and have one
	     * @return Boolean
	     * @inner
	     */
	    function didLongTap() {
	      //Enure we dont return 0 or null for false values
	      return !!(validateLongTap() && hasLongTap());
	    }
	
	    // MULTI FINGER TOUCH
	    /**
	     * Starts tracking the time between 2 finger releases, and keeps track of how many fingers we initially had up
	     * @inner
	     */
	    function startMultiFingerRelease(event) {
	      previousTouchEndTime = getTimeStamp();
	      fingerCountAtRelease = event.touches.length + 1;
	    }
	
	    /**
	     * Cancels the tracking of time between 2 finger releases, and resets counters
	     * @inner
	     */
	    function cancelMultiFingerRelease() {
	      previousTouchEndTime = 0;
	      fingerCountAtRelease = 0;
	    }
	
	    /**
	     * Checks if we are in the threshold between 2 fingers being released
	     * @return Boolean
	     * @inner
	     */
	    function inMultiFingerRelease() {
	
	      var withinThreshold = false;
	
	      if (previousTouchEndTime) {
	        var diff = getTimeStamp() - previousTouchEndTime;
	        if (diff <= options.fingerReleaseThreshold) {
	          withinThreshold = true;
	        }
	      }
	
	      return withinThreshold;
	    }
	
	    /**
	     * gets a data flag to indicate that a touch is in progress
	     * @return Boolean
	     * @inner
	     */
	    function getTouchInProgress() {
	      //strict equality to ensure only true and false are returned
	      return !!($element.data(PLUGIN_NS + '_intouch') === true);
	    }
	
	    /**
	     * Sets a data flag to indicate that a touch is in progress
	     * @param {boolean} val The value to set the property to
	     * @inner
	     */
	    function setTouchInProgress(val) {
	
	      //If destroy is called in an event handler, we have no el, and we have already cleaned up, so return.
	      if (!$element) {
	        return;
	      }
	
	      //Add or remove event listeners depending on touch status
	      if (val === true) {
	        $element.bind(MOVE_EV, touchMove);
	        $element.bind(END_EV, touchEnd);
	
	        //we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
	        if (LEAVE_EV) {
	          $element.bind(LEAVE_EV, touchLeave);
	        }
	      } else {
	
	        $element.unbind(MOVE_EV, touchMove, false);
	        $element.unbind(END_EV, touchEnd, false);
	
	        //we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
	        if (LEAVE_EV) {
	          $element.unbind(LEAVE_EV, touchLeave, false);
	        }
	      }
	
	      //strict equality to ensure only true and false can update the value
	      $element.data(PLUGIN_NS + '_intouch', val === true);
	    }
	
	    /**
	     * Creates the finger data for the touch/finger in the event object.
	     * @param {int} id The id to store the finger data under (usually the order the fingers were pressed)
	     * @param {object} evt The event object containing finger data
	     * @return finger data object
	     * @inner
	     */
	    function createFingerData(id, evt) {
	      var f = {
	        start: {
	          x: 0,
	          y: 0
	        },
	        last: {
	          x: 0,
	          y: 0
	        },
	        end: {
	          x: 0,
	          y: 0
	        }
	      };
	      f.start.x = f.last.x = f.end.x = evt.pageX || evt.clientX;
	      f.start.y = f.last.y = f.end.y = evt.pageY || evt.clientY;
	      fingerData[id] = f;
	      return f;
	    }
	
	    /**
	     * Updates the finger data for a particular event object
	     * @param {object} evt The event object containing the touch/finger data to upadte
	     * @return a finger data object.
	     * @inner
	     */
	    function updateFingerData(evt) {
	      var id = evt.identifier !== undefined ? evt.identifier : 0;
	      var f = getFingerData(id);
	
	      if (f === null) {
	        f = createFingerData(id, evt);
	      }
	
	      f.last.x = f.end.x;
	      f.last.y = f.end.y;
	
	      f.end.x = evt.pageX || evt.clientX;
	      f.end.y = evt.pageY || evt.clientY;
	
	      return f;
	    }
	
	    /**
	     * Returns a finger data object by its event ID.
	     * Each touch event has an identifier property, which is used
	     * to track repeat touches
	     * @param {int} id The unique id of the finger in the sequence of touch events.
	     * @return a finger data object.
	     * @inner
	     */
	    function getFingerData(id) {
	      return fingerData[id] || null;
	    }
	
	    /**
	     * Sets the maximum distance swiped in the given direction.
	     * If the new value is lower than the current value, the max value is not changed.
	     * @param {string}  direction The direction of the swipe
	     * @param {int}  distance The distance of the swipe
	     * @inner
	     */
	    function setMaxDistance(direction, distance) {
	      if (direction == NONE) return;
	      distance = Math.max(distance, getMaxDistance(direction));
	      maximumsMap[direction].distance = distance;
	    }
	
	    /**
	     * gets the maximum distance swiped in the given direction.
	     * @param {string}  direction The direction of the swipe
	     * @return int  The distance of the swipe
	     * @inner
	     */
	    function getMaxDistance(direction) {
	      if (maximumsMap[direction]) return maximumsMap[direction].distance;
	      return undefined;
	    }
	
	    /**
	     * Creats a map of directions to maximum swiped values.
	     * @return Object A dictionary of maximum values, indexed by direction.
	     * @inner
	     */
	    function createMaximumsData() {
	      var maxData = {};
	      maxData[LEFT] = createMaximumVO(LEFT);
	      maxData[RIGHT] = createMaximumVO(RIGHT);
	      maxData[UP] = createMaximumVO(UP);
	      maxData[DOWN] = createMaximumVO(DOWN);
	
	      return maxData;
	    }
	
	    /**
	     * Creates a map maximum swiped values for a given swipe direction
	     * @param {string} The direction that these values will be associated with
	     * @return Object Maximum values
	     * @inner
	     */
	    function createMaximumVO(dir) {
	      return {
	        direction: dir,
	        distance: 0
	      };
	    }
	
	    //
	    // MATHS / UTILS
	    //
	
	    /**
	     * Calculate the duration of the swipe
	     * @return int
	     * @inner
	     */
	    function calculateDuration() {
	      return endTime - startTime;
	    }
	
	    /**
	     * Calculate the distance between 2 touches (pinch)
	     * @param {point} startPoint A point object containing x and y co-ordinates
	     * @param {point} endPoint A point object containing x and y co-ordinates
	     * @return int;
	     * @inner
	     */
	    function calculateTouchesDistance(startPoint, endPoint) {
	      var diffX = Math.abs(startPoint.x - endPoint.x);
	      var diffY = Math.abs(startPoint.y - endPoint.y);
	
	      return Math.round(Math.sqrt(diffX * diffX + diffY * diffY));
	    }
	
	    /**
	     * Calculate the zoom factor between the start and end distances
	     * @param {int} startDistance Distance (between 2 fingers) the user started pinching at
	     * @param {int} endDistance Distance (between 2 fingers) the user ended pinching at
	     * @return float The zoom value from 0 to 1.
	     * @inner
	     */
	    function calculatePinchZoom(startDistance, endDistance) {
	      var percent = endDistance / startDistance * 1;
	      return percent.toFixed(2);
	    }
	
	    /**
	     * Returns the pinch direction, either IN or OUT for the given points
	     * @return string Either {@link $.fn.swipe.directions.IN} or {@link $.fn.swipe.directions.OUT}
	     * @see $.fn.swipe.directions
	     * @inner
	     */
	    function calculatePinchDirection() {
	      if (pinchZoom < 1) {
	        return OUT;
	      } else {
	        return IN;
	      }
	    }
	
	    /**
	     * Calculate the length / distance of the swipe
	     * @param {point} startPoint A point object containing x and y co-ordinates
	     * @param {point} endPoint A point object containing x and y co-ordinates
	     * @return int
	     * @inner
	     */
	    function calculateDistance(startPoint, endPoint) {
	      return Math.round(Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2)));
	    }
	
	    /**
	     * Calculate the angle of the swipe
	     * @param {point} startPoint A point object containing x and y co-ordinates
	     * @param {point} endPoint A point object containing x and y co-ordinates
	     * @return int
	     * @inner
	     */
	    function calculateAngle(startPoint, endPoint) {
	      var x = startPoint.x - endPoint.x;
	      var y = endPoint.y - startPoint.y;
	      var r = Math.atan2(y, x); //radians
	      var angle = Math.round(r * 180 / Math.PI); //degrees
	
	      //ensure value is positive
	      if (angle < 0) {
	        angle = 360 - Math.abs(angle);
	      }
	
	      return angle;
	    }
	
	    /**
	     * Calculate the direction of the swipe
	     * This will also call calculateAngle to get the latest angle of swipe
	     * @param {point} startPoint A point object containing x and y co-ordinates
	     * @param {point} endPoint A point object containing x and y co-ordinates
	     * @return string Either {@link $.fn.swipe.directions.LEFT} / {@link $.fn.swipe.directions.RIGHT} / {@link $.fn.swipe.directions.DOWN} / {@link $.fn.swipe.directions.UP}
	     * @see $.fn.swipe.directions
	     * @inner
	     */
	    function calculateDirection(startPoint, endPoint) {
	
	      if (comparePoints(startPoint, endPoint)) {
	        return NONE;
	      }
	
	      var angle = calculateAngle(startPoint, endPoint);
	
	      if (angle <= 45 && angle >= 0) {
	        return LEFT;
	      } else if (angle <= 360 && angle >= 315) {
	        return LEFT;
	      } else if (angle >= 135 && angle <= 225) {
	        return RIGHT;
	      } else if (angle > 45 && angle < 135) {
	        return DOWN;
	      } else {
	        return UP;
	      }
	    }
	
	    /**
	     * Returns a MS time stamp of the current time
	     * @return int
	     * @inner
	     */
	    function getTimeStamp() {
	      var now = new Date();
	      return now.getTime();
	    }
	
	    /**
	     * Returns a bounds object with left, right, top and bottom properties for the element specified.
	     * @param {DomNode} The DOM node to get the bounds for.
	     */
	    function getbounds(el) {
	      el = $(el);
	      var offset = el.offset();
	
	      var bounds = {
	        left: offset.left,
	        right: offset.left + el.outerWidth(),
	        top: offset.top,
	        bottom: offset.top + el.outerHeight()
	      };
	
	      return bounds;
	    }
	
	    /**
	     * Checks if the point object is in the bounds object.
	     * @param {object} point A point object.
	     * @param {int} point.x The x value of the point.
	     * @param {int} point.y The x value of the point.
	     * @param {object} bounds The bounds object to test
	     * @param {int} bounds.left The leftmost value
	     * @param {int} bounds.right The righttmost value
	     * @param {int} bounds.top The topmost value
	     * @param {int} bounds.bottom The bottommost value
	     */
	    function isInBounds(point, bounds) {
	      return point.x > bounds.left && point.x < bounds.right && point.y > bounds.top && point.y < bounds.bottom;
	    };
	
	    /**
	     * Checks if the two points are equal
	     * @param {object} point A point object.
	     * @param {object} point B point object.
	     * @return true of the points match
	     */
	    function comparePoints(pointA, pointB) {
	      return pointA.x == pointB.x && pointA.y == pointB.y;
	    }
	  }
	
	  /**
	   * A catch all handler that is triggered for all swipe directions.
	   * @name $.fn.swipe#swipe
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
	   * @param {int} distance The distance the user swiped
	   * @param {int} duration The duration of the swipe in milliseconds
	   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
	   * @param {object} fingerData The coordinates of fingers in event
	   * @param {string} currentDirection The current direction the user is swiping.
	   */
	
	  /**
	   * A handler that is triggered for "left" swipes.
	   * @name $.fn.swipe#swipeLeft
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
	   * @param {int} distance The distance the user swiped
	   * @param {int} duration The duration of the swipe in milliseconds
	   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
	   * @param {object} fingerData The coordinates of fingers in event
	   * @param {string} currentDirection The current direction the user is swiping.
	   */
	
	  /**
	   * A handler that is triggered for "right" swipes.
	   * @name $.fn.swipe#swipeRight
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
	   * @param {int} distance The distance the user swiped
	   * @param {int} duration The duration of the swipe in milliseconds
	   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
	   * @param {object} fingerData The coordinates of fingers in event
	   * @param {string} currentDirection The current direction the user is swiping.
	   */
	
	  /**
	   * A handler that is triggered for "up" swipes.
	   * @name $.fn.swipe#swipeUp
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
	   * @param {int} distance The distance the user swiped
	   * @param {int} duration The duration of the swipe in milliseconds
	   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
	   * @param {object} fingerData The coordinates of fingers in event
	   * @param {string} currentDirection The current direction the user is swiping.
	   */
	
	  /**
	   * A handler that is triggered for "down" swipes.
	   * @name $.fn.swipe#swipeDown
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
	   * @param {int} distance The distance the user swiped
	   * @param {int} duration The duration of the swipe in milliseconds
	   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
	   * @param {object} fingerData The coordinates of fingers in event
	   * @param {string} currentDirection The current direction the user is swiping.
	   */
	
	  /**
	   * A handler triggered for every phase of the swipe. This handler is constantly fired for the duration of the pinch.
	   * This is triggered regardless of swipe thresholds.
	   * @name $.fn.swipe#swipeStatus
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {string} phase The phase of the swipe event. See {@link $.fn.swipe.phases}
	   * @param {string} direction The direction the user swiped in. This is null if the user has yet to move. See {@link $.fn.swipe.directions}
	   * @param {int} distance The distance the user swiped. This is 0 if the user has yet to move.
	   * @param {int} duration The duration of the swipe in milliseconds
	   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
	   * @param {object} fingerData The coordinates of fingers in event
	   * @param {string} currentDirection The current direction the user is swiping.
	   */
	
	  /**
	   * A handler triggered for pinch in events.
	   * @name $.fn.swipe#pinchIn
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {int} direction The direction the user pinched in. See {@link $.fn.swipe.directions}
	   * @param {int} distance The distance the user pinched
	   * @param {int} duration The duration of the swipe in milliseconds
	   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
	   * @param {int} zoom The zoom/scale level the user pinched too, 0-1.
	   * @param {object} fingerData The coordinates of fingers in event
	   */
	
	  /**
	   * A handler triggered for pinch out events.
	   * @name $.fn.swipe#pinchOut
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {int} direction The direction the user pinched in. See {@link $.fn.swipe.directions}
	   * @param {int} distance The distance the user pinched
	   * @param {int} duration The duration of the swipe in milliseconds
	   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
	   * @param {int} zoom The zoom/scale level the user pinched too, 0-1.
	   * @param {object} fingerData The coordinates of fingers in event
	   */
	
	  /**
	   * A handler triggered for all pinch events. This handler is constantly fired for the duration of the pinch. This is triggered regardless of thresholds.
	   * @name $.fn.swipe#pinchStatus
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {int} direction The direction the user pinched in. See {@link $.fn.swipe.directions}
	   * @param {int} distance The distance the user pinched
	   * @param {int} duration The duration of the swipe in milliseconds
	   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
	   * @param {int} zoom The zoom/scale level the user pinched too, 0-1.
	   * @param {object} fingerData The coordinates of fingers in event
	   */
	
	  /**
	   * A click handler triggered when a user simply clicks, rather than swipes on an element.
	   * This is deprecated since version 1.6.2, any assignment to click will be assigned to the tap handler.
	   * You cannot use <code>on</code> to bind to this event as the default jQ <code>click</code> event will be triggered.
	   * Use the <code>tap</code> event instead.
	   * @name $.fn.swipe#click
	   * @event
	   * @deprecated since version 1.6.2, please use {@link $.fn.swipe#tap} instead
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {DomObject} target The element clicked on.
	   */
	
	  /**
	   * A click / tap handler triggered when a user simply clicks or taps, rather than swipes on an element.
	   * @name $.fn.swipe#tap
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {DomObject} target The element clicked on.
	   */
	
	  /**
	   * A double tap handler triggered when a user double clicks or taps on an element.
	   * You can set the time delay for a double tap with the {@link $.fn.swipe.defaults#doubleTapThreshold} property.
	   * Note: If you set both <code>doubleTap</code> and <code>tap</code> handlers, the <code>tap</code> event will be delayed by the <code>doubleTapThreshold</code>
	   * as the script needs to check if its a double tap.
	   * @name $.fn.swipe#doubleTap
	   * @see  $.fn.swipe.defaults#doubleTapThreshold
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {DomObject} target The element clicked on.
	   */
	
	  /**
	   * A long tap handler triggered once a tap has been release if the tap was longer than the longTapThreshold.
	   * You can set the time delay for a long tap with the {@link $.fn.swipe.defaults#longTapThreshold} property.
	   * @name $.fn.swipe#longTap
	   * @see  $.fn.swipe.defaults#longTapThreshold
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {DomObject} target The element clicked on.
	   */
	
	  /**
	   * A hold tap handler triggered as soon as the longTapThreshold is reached
	   * You can set the time delay for a long tap with the {@link $.fn.swipe.defaults#longTapThreshold} property.
	   * @name $.fn.swipe#hold
	   * @see  $.fn.swipe.defaults#longTapThreshold
	   * @event
	   * @default null
	   * @param {EventObject} event The original event object
	   * @param {DomObject} target The element clicked on.
	   */
	});

/***/ },
/* 20 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 21 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 22 */,
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	__webpack_require__(25);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Handel404 = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        errorcode: 404,
	        goto: '/',
	        delay: 5
	    }
	}), _dec(_class = function () {
	    function Handel404() {
	        _classCallCheck(this, Handel404);
	    }
	
	    Handel404.prototype.onInit = function onInit() {
	        var _this = this;
	
	        if (this.options.errorcode !== 404) {
	            return;
	        }
	        if (this.options.goto !== 'none') {
	            setTimeout(function () {
	                window.localtion = _this.options.goto;
	            }, this.options.delay * 1000);
	        }
	    };
	
	    return Handel404;
	}()) || _class);
	exports.default = Handel404;

/***/ },
/* 25 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 26 */,
/* 27 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 28 */,
/* 29 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	__webpack_require__(32);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Map = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        width: 'auto',
	        height: 'auto',
	        sw: 121.557634,
	        ne: 38.884033,
	        zoom: 17,
	        mark: ''
	    }
	}), _dec(_class = function () {
	    function Map() {
	        _classCallCheck(this, Map);
	    }
	
	    Map.prototype.onInit = function onInit() {
	        var _this = this;
	
	        var ComplexCustomOverlay = function ComplexCustomOverlay(point, text, mouseoverText) {
	            _this._point = point;
	            _this._text = text;
	            _this._overText = mouseoverText;
	        };
	        ComplexCustomOverlay.prototype = new BMap.Overlay();
	        ComplexCustomOverlay.prototype.initialize = function (map) {
	            _this._map = map;
	            _this._div = document.createElement('div');
	            var div = _this._div;
	            div.style.position = 'absolute';
	            div.style.zIndex = BMap.Overlay.getZIndex(_this._point.lat);
	            div.style.backgroundColor = '#EE5D5B';
	            div.style.border = '1px solid #bc3b3a';
	            div.style.color = 'white';
	            div.style.height = '18px';
	            div.style.padding = '2px';
	            div.style.boxSizing = 'content-box';
	            div.style.lineHeight = '18px';
	            div.style.whiteSpace = 'nowrap';
	            div.style.MozUserSelect = 'none';
	            div.style.fontSize = '12px';
	            _this._span = document.createElement('span');
	            var span = _this._span;
	            div.appendChild(span);
	            span.appendChild(document.createTextNode(_this._text));
	            _this._arrow = document.createElement('div');
	            var arrow = _this._arrow;
	            arrow.style.background = 'url(http://map.baidu.com/fwmap/upload/r/map/fwmap/static/house/images/label.png) no-repeat';
	            arrow.style.position = 'absolute';
	            arrow.style.width = '11px';
	            arrow.style.height = '10px';
	            arrow.style.top = '22px';
	            arrow.style.left = '10px';
	            arrow.style.overflow = 'hidden';
	            div.appendChild(arrow);
	            div.onmouseover = function () {
	                _this.style.backgroundColor = '#6BADCA';
	                _this.style.borderColor = '#5188a5';
	                arrow.style.backgroundPosition = '0px -20px';
	            };
	            div.onmouseout = function () {
	                _this.style.backgroundColor = '#EE5D5B';
	                _this.style.borderColor = '#bc3b3a';
	                arrow.style.backgroundPosition = '0px 0px';
	            };
	            map.getPanes().labelPane.appendChild(div);
	            return div;
	        };
	        ComplexCustomOverlay.prototype.draw = function () {
	            var map = _this._map;
	            var pixel = map.pointToOverlayPixel(_this._point);
	            _this._div.style.left = pixel.x - parseInt(_this._arrow.style.left) + 'px';
	            _this._div.style.top = pixel.y - 30 + 'px';
	        };
	        var id = 'map' + Math.ceil(Math.random() * 100000);
	        (0, _jquery2.default)(this.dom).css({
	            position: 'relative'
	        });
	        (0, _jquery2.default)('<div class="mapspacer"></div><div class="mapwrapper"></div>').appendTo(this.dom);
	        (0, _jquery2.default)('.mapwrapper', this.dom).attr('id', id).css({
	            height: '100%',
	            width: '100%',
	            top: 0,
	            position: 'absolute'
	        });
	        (0, _jquery2.default)('.mapspacer', this.dom).css({
	            height: 0,
	            'padding-bottom': this.options.height * 100 / this.options.width + '%'
	        });
	
	        var map = new BMap.Map(id);
	        map.centerAndZoom(new BMap.Point(this.options.sw, this.options.ne), this.options.zoom);
	        map.enableScrollWheelZoom(true);
	        if (this.options.mark) {
	            var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(this.options.sw, this.options.ne), this.options.mark);
	            map.addOverlay(myCompOverlay);
	            map.panTo(new BMap.Point(this.options.sw, this.options.ne));
	        }
	    };
	
	    return Map;
	}()) || _class);
	exports.default = Map;

/***/ },
/* 32 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 33 */,
/* 34 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 35 */,
/* 36 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 37 */,
/* 38 */,
/* 39 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 40 */,
/* 41 */,
/* 42 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 43 */,
/* 44 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 45 */,
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	__webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Header = (_dec = _Sloth2.default.component({}), _dec(_class = function () {
	    function Header() {
	        _classCallCheck(this, Header);
	    }
	
	    Header.prototype.onInit = function onInit() {
	        if (!_Sloth2.default.isMobile()) return;
	
	        var dom = this.dom;
	        (0, _jquery2.default)('.Nav-container', dom).prepend((0, _jquery2.default)('.Header-right', dom));
	    };
	
	    return Header;
	}()) || _class);
	exports.default = Header;

/***/ },
/* 47 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	__webpack_require__(55);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Nav = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        phoneicon: '.Nav-icon' // 手机端点击出菜单的按钮
	    }
	}), _dec(_class = function () {
	    function Nav() {
	        _classCallCheck(this, Nav);
	    }
	
	    Nav.prototype.onInit = function onInit() {
	        if (!_Sloth2.default.isMobile()) return;
	
	        var obj = this.dom;
	        var options = this.options;
	        var phoneicon = (0, _jquery2.default)(options.phoneicon);
	
	        phoneicon.on('click', function () {
	            (0, _jquery2.default)('.Nav-container').toggleClass('open');
	            (0, _jquery2.default)(document.body).toggleClass('overflow');
	        });
	
	        (0, _jquery2.default)('.Nav-item_more > a', this.dom).on('click', function (evt) {
	            evt.preventDefault();
	            (0, _jquery2.default)('.Nav-subNav', (0, _jquery2.default)(this).parent()).toggle();
	        });
	
	        (0, _jquery2.default)(document).on('click', function (evt) {
	            if ((0, _jquery2.default)(evt.target).is(phoneicon)) return;
	            if ((0, _jquery2.default)(evt.target).parents('.Nav-container').length !== 0) return;
	            (0, _jquery2.default)('.Nav-container').removeClass('open');
	            (0, _jquery2.default)(document.body).removeClass('overflow');
	        });
	    };
	
	    return Nav;
	}()) || _class);
	exports.default = Nav;

/***/ },
/* 55 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 60 */,
/* 61 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 62 */,
/* 63 */,
/* 64 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 65 */,
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class; /**
	                      * Created by menghao on 2016/4/27.
	                  */
	
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(67);
	var $ = __webpack_require__(1);
	
	var Tab = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        current: 0
	    }
	}), _dec(_class = function () {
	    function Tab() {
	        _classCallCheck(this, Tab);
	    }
	
	    Tab.prototype.onInit = function onInit() {
	        var obj = this.dom;
	        var options = this.options;
	        var current = options.current;
	
	        $(".Tab-item", obj).eq(current).addClass("Tab-item_current");
	        $(".Tab-content", obj).eq(current).addClass("Tab-content_current");
	
	        $(".Tab-item", obj).click(function () {
	            var num = $(this).siblings().andSelf().index(this);
	            $(this).addClass("Tab-item_current").siblings().removeClass("Tab-item_current");
	
	            $(".Tab-content", obj).eq(num).addClass("Tab-content_current").siblings().removeClass("Tab-content_current");
	        });
	    };
	
	    return Tab;
	}()) || _class);
	
	// module.exports = function (obj, options) {
	//     var current = $(options.current);
	//
	//     $(".Tab-item", obj).eq(current).addClass("Tab-item_current");
	//     $(".Tab-content", obj).eq(current).addClass("Tab-content_current");
	//
	//     $(".Tab-item", obj).click(function () {
	//         var num = $(this).siblings().andSelf().index(this);
	//         $(this).addClass("Tab-item_current")
	//             .siblings().removeClass("Tab-item_current");
	//
	//         $(".Tab-content", obj).eq(num).addClass("Tab-content_current")
	//             .siblings().removeClass("Tab-content_current");
	//     })
	// }
	//
	// module.exports.moduleDefault = {
	//     current : 0
	// }
	
	exports.default = Tab;

/***/ },
/* 67 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 68 */,
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(70);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Affix = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        t: 0
	    }
	}), _dec(_class = function () {
	    function Affix() {
	        _classCallCheck(this, Affix);
	    }
	
	    Affix.prototype.onInit = function onInit() {
	        alert('dd');
	    };
	
	    return Affix;
	}()) || _class);
	exports.default = Affix;

/***/ },
/* 70 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 71 */,
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class; /* eslint-disable */
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _jwplayerFlash = __webpack_require__(73);
	
	var _jwplayerFlash2 = _interopRequireDefault(_jwplayerFlash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Video = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        primary: 'flash',
	        width: '100%',
	        height: '200',
	        aspectratio: '16:9'
	    }
	}), _dec(_class = function () {
	    function Video() {
	        _classCallCheck(this, Video);
	    }
	
	    Video.prototype.onInit = function onInit() {
	        var dom = this.dom;
	        var options = this.options;
	
	        __webpack_require__.e/* nsure */(1, function () {
	            var jwplayer = __webpack_require__(74);
	            jwplayer = __webpack_require__(75);
	
	            var id = 'video' + Math.floor(Math.random() * 100000);
	            (0, _jquery2.default)(dom).attr('id', id);
	
	            jwplayer(id).setup({
	                flashplayer: _jwplayerFlash2.default,
	                primary: options.primary,
	                image: options.image,
	                file: options.file,
	                width: options.width,
	                height: options.height,
	                aspectratio: options.aspectratio
	            });
	        });
	    };
	
	    return Video;
	}()) || _class);
	exports.default = Video;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "front/img/127d03fc.swf";

/***/ },
/* 74 */,
/* 75 */,
/* 76 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 82 */,
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(84);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Modal = (_dec = _Sloth2.default.component({
	    defaultOptions: {}
	}), _dec(_class = function () {
	    function Modal() {
	        _classCallCheck(this, Modal);
	    }
	
	    Modal.prototype.onInit = function onInit() {
	        var _this = this;
	
	        var dom = this.dom;
	        var self = this;
	        if ((0, _jquery2.default)('.Modal-wrapper', dom).length === 0) (0, _jquery2.default)('<div class="Modal-wrapper"><h1 class="Modal-title"></h1><div class="Modal-body"></div></div>').appendTo(dom);
	        (0, _jquery2.default)('<button class=\'Modal-close\'></button>').appendTo('.Modal-wrapper', dom);
	
	        (0, _jquery2.default)(dom).on('click', '.Modal-close', function () {
	            self.hide();
	        });
	
	        // 点遮罩关闭
	        (0, _jquery2.default)(dom).on('click', function (evt) {
	            if (!(0, _jquery2.default)(evt.target).is('.Modal')) return;
	            _this.hide();
	        });
	    };
	
	    Modal.prototype.setTitle = function setTitle(title) {
	        (0, _jquery2.default)('.Modal-title', this.dom).text(title);
	    };
	
	    Modal.prototype.setBody = function setBody(body) {
	        // eslint-disable-next-line no-console
	        console.log(this.dom);
	        (0, _jquery2.default)('.Modal-body', this.dom).html(body);
	    };
	
	    Modal.prototype.show = function show(options) {
	        var _ref = options || {},
	            title = _ref.title,
	            body = _ref.body;
	
	        if (title) this.setTitle(title);
	        if (body) this.setBody(body);
	
	        (0, _jquery2.default)(this.dom).show();
	    };
	
	    Modal.prototype.hide = function hide() {
	        (0, _jquery2.default)(this.dom).hide();
	        (0, _jquery2.default)(".Modal-body", this.dom).html("");
	    };
	
	    return Modal;
	}()) || _class);
	exports.default = Modal;

/***/ },
/* 84 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 85 */,
/* 86 */,
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	__webpack_require__(88);
	
	__webpack_require__(89);
	
	__webpack_require__(91);
	
	__webpack_require__(98);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Slick = (_dec = _Sloth2.default.component({
	    defaultOptions: {}
	}), _dec(_class = function () {
	    function Slick() {
	        _classCallCheck(this, Slick);
	    }
	
	    Slick.prototype.onInit = function onInit() {
	        var dom = this.dom;
	
	        $(dom).slick({
	            dots: false,
	            adaptiveHeight: true,
	            infinite: true,
	            slidesToShow: 3,
	            slidesToScroll: 1
	        }).on("afterChange", function (evt, slick, index) {
	            $(".slick-slide", dom).eq(index).addClass("current");
	        });
	
	        $(dom).on("click", "video", function () {
	
	            if ($(this).parents(".slick-active").length === 0) return;
	
	            if ($(this).parent().hasClass("active")) {
	                $(this).parent().removeClass("active");
	                this.pause();
	            } else {
	                $(this).parent().addClass("active");
	                this.play();
	            }
	        });
	
	        $(dom).on("play", "video", function () {
	            console.log(111);
	        });
	    };
	
	    return Slick;
	}()) || _class);
	exports.default = Slick;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	     _ _      _       _
	 ___| (_) ___| | __  (_)___
	/ __| | |/ __| |/ /  | / __|
	\__ \ | | (__|   < _ | \__ \
	|___/_|_|\___|_|\_(_)/ |___/
	                   |__/
	
	 Version: 1.8.1
	  Author: Ken Wheeler
	 Website: http://kenwheeler.github.io
	    Docs: http://kenwheeler.github.io/slick
	    Repo: http://github.com/kenwheeler/slick
	  Issues: http://github.com/kenwheeler/slick/issues
	
	 */
	/* global window, document, define, jQuery, setInterval, clearInterval */
	;(function (factory) {
	    'use strict';
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	})(function ($) {
	    'use strict';
	
	    var Slick = window.Slick || {};
	
	    Slick = function () {
	
	        var instanceUid = 0;
	
	        function Slick(element, settings) {
	
	            var _ = this,
	                dataSettings;
	
	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
	                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function customPaging(slider, i) {
	                    return $('<button type="button" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                focusOnChange: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };
	
	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                scrolling: false,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                swiping: false,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };
	
	            $.extend(_, _.initials);
	
	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;
	
	            dataSettings = $(element).data('slick') || {};
	
	            _.options = $.extend({}, _.defaults, settings, dataSettings);
	
	            _.currentSlide = _.options.initialSlide;
	
	            _.originalSettings = _.options;
	
	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }
	
	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);
	
	            _.instanceUid = instanceUid++;
	
	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
	
	            _.registerBreakpoints();
	            _.init(true);
	        }
	
	        return Slick;
	    }();
	
	    Slick.prototype.activateADA = function () {
	        var _ = this;
	
	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });
	    };
	
	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {
	
	        var _ = this;
	
	        if (typeof index === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || index >= _.slideCount) {
	            return false;
	        }
	
	        _.unload();
	
	        if (typeof index === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slides.each(function (index, element) {
	            $(element).attr('data-slick-index', index);
	        });
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	    };
	
	    Slick.prototype.animateHeight = function () {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };
	
	    Slick.prototype.animateSlide = function (targetLeft, callback) {
	
	        var animProps = {},
	            _ = this;
	
	        _.animateHeight();
	
	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }
	        } else {
	
	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -_.currentLeft;
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function step(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' + now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' + now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function complete() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });
	            } else {
	
	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);
	
	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);
	
	                if (callback) {
	                    setTimeout(function () {
	
	                        _.disableTransition();
	
	                        callback.call();
	                    }, _.options.speed);
	                }
	            }
	        }
	    };
	
	    Slick.prototype.getNavTarget = function () {
	
	        var _ = this,
	            asNavFor = _.options.asNavFor;
	
	        if (asNavFor && asNavFor !== null) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }
	
	        return asNavFor;
	    };
	
	    Slick.prototype.asNavFor = function (index) {
	
	        var _ = this,
	            asNavFor = _.getNavTarget();
	
	        if (asNavFor !== null && (typeof asNavFor === 'undefined' ? 'undefined' : _typeof(asNavFor)) === 'object') {
	            asNavFor.each(function () {
	                var target = $(this).slick('getSlick');
	                if (!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }
	    };
	
	    Slick.prototype.applyTransition = function (slide) {
	
	        var _ = this,
	            transition = {};
	
	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	    };
	
	    Slick.prototype.autoPlay = function () {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        if (_.slideCount > _.options.slidesToShow) {
	            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
	        }
	    };
	
	    Slick.prototype.autoPlayClear = function () {
	
	        var _ = this;
	
	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }
	    };
	
	    Slick.prototype.autoPlayIterator = function () {
	
	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;
	
	        if (!_.paused && !_.interrupted && !_.focussed) {
	
	            if (_.options.infinite === false) {
	
	                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
	                    _.direction = 0;
	                } else if (_.direction === 0) {
	
	                    slideTo = _.currentSlide - _.options.slidesToScroll;
	
	                    if (_.currentSlide - 1 === 0) {
	                        _.direction = 1;
	                    }
	                }
	            }
	
	            _.slideHandler(slideTo);
	        }
	    };
	
	    Slick.prototype.buildArrows = function () {
	
	        var _ = this;
	
	        if (_.options.arrows === true) {
	
	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
	
	            if (_.slideCount > _.options.slidesToShow) {
	
	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	
	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }
	
	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }
	
	                if (_.options.infinite !== true) {
	                    _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                }
	            } else {
	
	                _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
	                    'aria-disabled': 'true',
	                    'tabindex': '-1'
	                });
	            }
	        }
	    };
	
	    Slick.prototype.buildDots = function () {
	
	        var _ = this,
	            i,
	            dot;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$slider.addClass('slick-dotted');
	
	            dot = $('<ul />').addClass(_.options.dotsClass);
	
	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }
	
	            _.$dots = dot.appendTo(_.options.appendDots);
	
	            _.$dots.find('li').first().addClass('slick-active');
	        }
	    };
	
	    Slick.prototype.buildOut = function () {
	
	        var _ = this;
	
	        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        _.$slides.each(function (index, element) {
	            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
	        });
	
	        _.$slider.addClass('slick-slider');
	
	        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
	
	        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);
	
	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }
	
	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
	
	        _.setupInfinite();
	
	        _.buildArrows();
	
	        _.buildDots();
	
	        _.updateDots();
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }
	    };
	
	    Slick.prototype.buildRows = function () {
	
	        var _ = this,
	            a,
	            b,
	            c,
	            newSlides,
	            numOfSlides,
	            originalSlides,
	            slidesPerSection;
	
	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();
	
	        if (_.options.rows > 0) {
	
	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
	
	            for (a = 0; a < numOfSlides; a++) {
	                var slide = document.createElement('div');
	                for (b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for (c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }
	
	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children().css({
	                'width': 100 / _.options.slidesPerRow + '%',
	                'display': 'inline-block'
	            });
	        }
	    };
	
	    Slick.prototype.checkResponsive = function (initial, forceUpdate) {
	
	        var _ = this,
	            breakpoint,
	            targetBreakpoint,
	            respondToWidth,
	            triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();
	
	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }
	
	        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
	
	            targetBreakpoint = null;
	
	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }
	
	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint = targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }
	
	            // only trigger breakpoints during an actual break. not on initialize.
	            if (!initial && triggerBreakpoint !== false) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }
	    };
	
	    Slick.prototype.changeSlide = function (event, dontAnimate) {
	
	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset,
	            slideOffset,
	            unevenOffset;
	
	        // If target is a link, prevent default action.
	        if ($target.is('a')) {
	            event.preventDefault();
	        }
	
	        // If target is not the <li> element (ie: a child), find the <li>.
	        if (!$target.is('li')) {
	            $target = $target.closest('li');
	        }
	
	        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
	
	        switch (event.data.message) {
	
	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'index':
	                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
	
	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;
	
	            default:
	                return;
	        }
	    };
	
	    Slick.prototype.checkNavigable = function (index) {
	
	        var _ = this,
	            navigables,
	            prevNavigable;
	
	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }
	
	        return index;
	    };
	
	    Slick.prototype.cleanUpEvents = function () {
	
	        var _ = this;
	
	        if (_.options.dots && _.$dots !== null) {
	
	            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	            if (_.options.accessibility === true) {
	                _.$dots.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$slider.off('focus.slick blur.slick');
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
	                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
	
	        _.$list.off('click.slick', _.clickHandler);
	
	        $(document).off(_.visibilityChange, _.visibility);
	
	        _.cleanUpSlideEvents();
	
	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }
	
	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
	
	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
	
	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
	
	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
	    };
	
	    Slick.prototype.cleanUpSlideEvents = function () {
	
	        var _ = this;
	
	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	    };
	
	    Slick.prototype.cleanUpRows = function () {
	
	        var _ = this,
	            originalSlides;
	
	        if (_.options.rows > 0) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }
	    };
	
	    Slick.prototype.clickHandler = function (event) {
	
	        var _ = this;
	
	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }
	    };
	
	    Slick.prototype.destroy = function (refresh) {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        _.touchObject = {};
	
	        _.cleanUpEvents();
	
	        $('.slick-cloned', _.$slider).detach();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if (_.$prevArrow && _.$prevArrow.length) {
	
	            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
	
	            if (_.htmlExpr.test(_.options.prevArrow)) {
	                _.$prevArrow.remove();
	            }
	        }
	
	        if (_.$nextArrow && _.$nextArrow.length) {
	
	            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
	
	            if (_.htmlExpr.test(_.options.nextArrow)) {
	                _.$nextArrow.remove();
	            }
	        }
	
	        if (_.$slides) {
	
	            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
	                $(this).attr('style', $(this).data('originalStyling'));
	            });
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slideTrack.detach();
	
	            _.$list.detach();
	
	            _.$slider.append(_.$slides);
	        }
	
	        _.cleanUpRows();
	
	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');
	
	        _.unslicked = true;
	
	        if (!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }
	    };
	
	    Slick.prototype.disableTransition = function (slide) {
	
	        var _ = this,
	            transition = {};
	
	        transition[_.transitionType] = '';
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	    };
	
	    Slick.prototype.fadeSlide = function (slideIndex, callback) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });
	
	            if (callback) {
	                setTimeout(function () {
	
	                    _.disableTransition(slideIndex);
	
	                    callback.call();
	                }, _.options.speed);
	            }
	        }
	    };
	
	    Slick.prototype.fadeSlideOut = function (slideIndex) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });
	        }
	    };
	
	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {
	
	        var _ = this;
	
	        if (filter !== null) {
	
	            _.$slidesCache = _.$slides;
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
	
	            _.reinit();
	        }
	    };
	
	    Slick.prototype.focusHandler = function () {
	
	        var _ = this;
	
	        // If any child element receives focus within the slider we need to pause the autoplay
	        _.$slider.off('focus.slick blur.slick').on('focus.slick', '*', function (event) {
	            var $sf = $(this);
	
	            setTimeout(function () {
	                if (_.options.pauseOnFocus) {
	                    if ($sf.is(':focus')) {
	                        _.focussed = true;
	                        _.autoPlay();
	                    }
	                }
	            }, 0);
	        }).on('blur.slick', '*', function (event) {
	            var $sf = $(this);
	
	            // When a blur occurs on any elements within the slider we become unfocused
	            if (_.options.pauseOnFocus) {
	                _.focussed = false;
	                _.autoPlay();
	            }
	        });
	    };
	
	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
	
	        var _ = this;
	        return _.currentSlide;
	    };
	
	    Slick.prototype.getDotCount = function () {
	
	        var _ = this;
	
	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;
	
	        if (_.options.infinite === true) {
	            if (_.slideCount <= _.options.slidesToShow) {
	                ++pagerQty;
	            } else {
	                while (breakPoint < _.slideCount) {
	                    ++pagerQty;
	                    breakPoint = counter + _.options.slidesToScroll;
	                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	                }
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if (!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        } else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }
	
	        return pagerQty - 1;
	    };
	
	    Slick.prototype.getLeft = function (slideIndex) {
	
	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide,
	            coef;
	
	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);
	
	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
	                coef = -1;
	
	                if (_.options.vertical === true && _.options.centerMode === true) {
	                    if (_.options.slidesToShow === 2) {
	                        coef = -1.5;
	                    } else if (_.options.slidesToShow === 1) {
	                        coef = -2;
	                    }
	                }
	                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
	                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
	                    } else {
	                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
	                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
	                verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
	            }
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }
	
	        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
	        } else if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }
	
	        if (_.options.vertical === false) {
	            targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
	        } else {
	            targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
	        }
	
	        if (_.options.variableWidth === true) {
	
	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }
	
	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft = 0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }
	
	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }
	
	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft = 0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }
	
	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }
	
	        return targetLeft;
	    };
	
	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {
	
	        var _ = this;
	
	        return _.options[option];
	    };
	
	    Slick.prototype.getNavigableIndexes = function () {
	
	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;
	
	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }
	
	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }
	
	        return indexes;
	    };
	
	    Slick.prototype.getSlick = function () {
	
	        return this;
	    };
	
	    Slick.prototype.getSlideCount = function () {
	
	        var _ = this,
	            slidesTraversed,
	            swipedSlide,
	            swipeTarget,
	            centerOffset;
	
	        centerOffset = _.options.centerMode === true ? Math.floor(_.$list.width() / 2) : 0;
	        swipeTarget = _.swipeLeft * -1 + centerOffset;
	
	        if (_.options.swipeToSlide === true) {
	
	            _.$slideTrack.find('.slick-slide').each(function (index, slide) {
	
	                var slideOuterWidth, slideOffset, slideRightBoundary;
	                slideOuterWidth = $(slide).outerWidth();
	                slideOffset = slide.offsetLeft;
	                if (_.options.centerMode !== true) {
	                    slideOffset += slideOuterWidth / 2;
	                }
	
	                slideRightBoundary = slideOffset + slideOuterWidth;
	
	                if (swipeTarget < slideRightBoundary) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });
	
	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
	
	            return slidesTraversed;
	        } else {
	            return _.options.slidesToScroll;
	        }
	    };
	
	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);
	    };
	
	    Slick.prototype.init = function (creation) {
	
	        var _ = this;
	
	        if (!$(_.$slider).hasClass('slick-initialized')) {
	
	            $(_.$slider).addClass('slick-initialized');
	
	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();
	        }
	
	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }
	
	        if (_.options.accessibility === true) {
	            _.initADA();
	        }
	
	        if (_.options.autoplay) {
	
	            _.paused = false;
	            _.autoPlay();
	        }
	    };
	
	    Slick.prototype.initADA = function () {
	        var _ = this,
	            numDotGroups = Math.ceil(_.slideCount / _.options.slidesToScroll),
	            tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
	            return val >= 0 && val < _.slideCount;
	        });
	
	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });
	
	        if (_.$dots !== null) {
	            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
	                var slideControlIndex = tabControlIndexes.indexOf(i);
	
	                $(this).attr({
	                    'role': 'tabpanel',
	                    'id': 'slick-slide' + _.instanceUid + i,
	                    'tabindex': -1
	                });
	
	                if (slideControlIndex !== -1) {
	                    var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
	                    if ($('#' + ariaButtonControl).length) {
	                        $(this).attr({
	                            'aria-describedby': ariaButtonControl
	                        });
	                    }
	                }
	            });
	
	            _.$dots.attr('role', 'tablist').find('li').each(function (i) {
	                var mappedSlideIndex = tabControlIndexes[i];
	
	                $(this).attr({
	                    'role': 'presentation'
	                });
	
	                $(this).find('button').first().attr({
	                    'role': 'tab',
	                    'id': 'slick-slide-control' + _.instanceUid + i,
	                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
	                    'aria-label': i + 1 + ' of ' + numDotGroups,
	                    'aria-selected': null,
	                    'tabindex': '-1'
	                });
	            }).eq(_.currentSlide).find('button').attr({
	                'aria-selected': 'true',
	                'tabindex': '0'
	            }).end();
	        }
	
	        for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
	            if (_.options.focusOnChange) {
	                _.$slides.eq(i).attr({ 'tabindex': '0' });
	            } else {
	                _.$slides.eq(i).removeAttr('tabindex');
	            }
	        }
	
	        _.activateADA();
	    };
	
	    Slick.prototype.initArrowEvents = function () {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow.off('click.slick').on('click.slick', {
	                message: 'previous'
	            }, _.changeSlide);
	            _.$nextArrow.off('click.slick').on('click.slick', {
	                message: 'next'
	            }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow.on('keydown.slick', _.keyHandler);
	                _.$nextArrow.on('keydown.slick', _.keyHandler);
	            }
	        }
	    };
	
	    Slick.prototype.initDotEvents = function () {
	
	        var _ = this;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$dots.on('keydown.slick', _.keyHandler);
	            }
	        }
	
	        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
	
	            $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	        }
	    };
	
	    Slick.prototype.initSlideEvents = function () {
	
	        var _ = this;
	
	        if (_.options.pauseOnHover) {
	
	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	        }
	    };
	
	    Slick.prototype.initializeEvents = function () {
	
	        var _ = this;
	
	        _.initArrowEvents();
	
	        _.initDotEvents();
	        _.initSlideEvents();
	
	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	
	        _.$list.on('click.slick', _.clickHandler);
	
	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
	
	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
	
	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
	
	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
	
	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(_.setPosition);
	    };
	
	    Slick.prototype.initUI = function () {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.show();
	            _.$nextArrow.show();
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.show();
	        }
	    };
	
	    Slick.prototype.keyHandler = function (event) {
	
	        var _ = this;
	        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' : 'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }
	    };
	
	    Slick.prototype.lazyLoad = function () {
	
	        var _ = this,
	            loadRange,
	            cloneRange,
	            rangeStart,
	            rangeEnd;
	
	        function loadImages(imagesScope) {
	
	            $('img[data-lazy]', imagesScope).each(function () {
	
	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageSrcSet = $(this).attr('data-srcset'),
	                    imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
	                    imageToLoad = document.createElement('img');
	
	                imageToLoad.onload = function () {
	
	                    image.animate({ opacity: 0 }, 100, function () {
	
	                        if (imageSrcSet) {
	                            image.attr('srcset', imageSrcSet);
	
	                            if (imageSizes) {
	                                image.attr('sizes', imageSizes);
	                            }
	                        }
	
	                        image.attr('src', imageSource).animate({ opacity: 1 }, 200, function () {
	                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
	                        });
	                        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                    });
	                };
	
	                imageToLoad.onerror = function () {
	
	                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
	
	                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
	                };
	
	                imageToLoad.src = imageSource;
	            });
	        }
	
	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }
	
	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
	
	        if (_.options.lazyLoad === 'anticipated') {
	            var prevSlide = rangeStart - 1,
	                nextSlide = rangeEnd,
	                $slides = _.$slider.find('.slick-slide');
	
	            for (var i = 0; i < _.options.slidesToScroll; i++) {
	                if (prevSlide < 0) prevSlide = _.slideCount - 1;
	                loadRange = loadRange.add($slides.eq(prevSlide));
	                loadRange = loadRange.add($slides.eq(nextSlide));
	                prevSlide--;
	                nextSlide++;
	            }
	        }
	
	        loadImages(loadRange);
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }
	    };
	
	    Slick.prototype.loadSlider = function () {
	
	        var _ = this;
	
	        _.setPosition();
	
	        _.$slideTrack.css({
	            opacity: 1
	        });
	
	        _.$slider.removeClass('slick-loading');
	
	        _.initUI();
	
	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }
	    };
	
	    Slick.prototype.next = Slick.prototype.slickNext = function () {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });
	    };
	
	    Slick.prototype.orientationChange = function () {
	
	        var _ = this;
	
	        _.checkResponsive();
	        _.setPosition();
	    };
	
	    Slick.prototype.pause = Slick.prototype.slickPause = function () {
	
	        var _ = this;
	
	        _.autoPlayClear();
	        _.paused = true;
	    };
	
	    Slick.prototype.play = Slick.prototype.slickPlay = function () {
	
	        var _ = this;
	
	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;
	    };
	
	    Slick.prototype.postSlide = function (index) {
	
	        var _ = this;
	
	        if (!_.unslicked) {
	
	            _.$slider.trigger('afterChange', [_, index]);
	
	            _.animating = false;
	
	            if (_.slideCount > _.options.slidesToShow) {
	                _.setPosition();
	            }
	
	            _.swipeLeft = null;
	
	            if (_.options.autoplay) {
	                _.autoPlay();
	            }
	
	            if (_.options.accessibility === true) {
	                _.initADA();
	
	                if (_.options.focusOnChange) {
	                    var $currentSlide = $(_.$slides.get(_.currentSlide));
	                    $currentSlide.attr('tabindex', 0).focus();
	                }
	            }
	        }
	    };
	
	    Slick.prototype.prev = Slick.prototype.slickPrev = function () {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });
	    };
	
	    Slick.prototype.preventDefault = function (event) {
	
	        event.preventDefault();
	    };
	
	    Slick.prototype.progressiveLazyLoad = function (tryCount) {
	
	        tryCount = tryCount || 1;
	
	        var _ = this,
	            $imgsToLoad = $('img[data-lazy]', _.$slider),
	            image,
	            imageSource,
	            imageSrcSet,
	            imageSizes,
	            imageToLoad;
	
	        if ($imgsToLoad.length) {
	
	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageSrcSet = image.attr('data-srcset');
	            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
	            imageToLoad = document.createElement('img');
	
	            imageToLoad.onload = function () {
	
	                if (imageSrcSet) {
	                    image.attr('srcset', imageSrcSet);
	
	                    if (imageSizes) {
	                        image.attr('sizes', imageSizes);
	                    }
	                }
	
	                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
	
	                if (_.options.adaptiveHeight === true) {
	                    _.setPosition();
	                }
	
	                _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                _.progressiveLazyLoad();
	            };
	
	            imageToLoad.onerror = function () {
	
	                if (tryCount < 3) {
	
	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout(function () {
	                        _.progressiveLazyLoad(tryCount + 1);
	                    }, 500);
	                } else {
	
	                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
	
	                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
	
	                    _.progressiveLazyLoad();
	                }
	            };
	
	            imageToLoad.src = imageSource;
	        } else {
	
	            _.$slider.trigger('allImagesLoaded', [_]);
	        }
	    };
	
	    Slick.prototype.refresh = function (initializing) {
	
	        var _ = this,
	            currentSlide,
	            lastVisibleIndex;
	
	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
	
	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
	            _.currentSlide = lastVisibleIndex;
	        }
	
	        // if less slides than to show, go to start.
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }
	
	        currentSlide = _.currentSlide;
	
	        _.destroy(true);
	
	        $.extend(_, _.initials, { currentSlide: currentSlide });
	
	        _.init();
	
	        if (!initializing) {
	
	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);
	        }
	    };
	
	    Slick.prototype.registerBreakpoints = function () {
	
	        var _ = this,
	            breakpoint,
	            currentBreakpoint,
	            l,
	            responsiveSettings = _.options.responsive || null;
	
	        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
	
	            _.respondTo = _.options.respondTo || 'window';
	
	            for (breakpoint in responsiveSettings) {
	
	                l = _.breakpoints.length - 1;
	
	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
	
	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while (l >= 0) {
	                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
	                            _.breakpoints.splice(l, 1);
	                        }
	                        l--;
	                    }
	
	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
	                }
	            }
	
	            _.breakpoints.sort(function (a, b) {
	                return _.options.mobileFirst ? a - b : b - a;
	            });
	        }
	    };
	
	    Slick.prototype.reinit = function () {
	
	        var _ = this;
	
	        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }
	
	        _.registerBreakpoints();
	
	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();
	
	        _.checkResponsive(false, true);
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        _.setPosition();
	        _.focusHandler();
	
	        _.paused = !_.options.autoplay;
	        _.autoPlay();
	
	        _.$slider.trigger('reInit', [_]);
	    };
	
	    Slick.prototype.resize = function () {
	
	        var _ = this;
	
	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function () {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if (!_.unslicked) {
	                    _.setPosition();
	                }
	            }, 50);
	        }
	    };
	
	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {
	
	        var _ = this;
	
	        if (typeof index === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }
	
	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }
	
	        _.unload();
	
	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	    };
	
	    Slick.prototype.setCSS = function (position) {
	
	        var _ = this,
	            positionProps = {},
	            x,
	            y;
	
	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
	
	        positionProps[_.positionProp] = position;
	
	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }
	    };
	
	    Slick.prototype.setDimensions = function () {
	
	        var _ = this;
	
	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: '0px ' + _.options.centerPadding
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: _.options.centerPadding + ' 0px'
	                });
	            }
	        }
	
	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();
	
	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
	        }
	
	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
	    };
	
	    Slick.prototype.setFade = function () {
	
	        var _ = this,
	            targetLeft;
	
	        _.$slides.each(function (index, element) {
	            targetLeft = _.slideWidth * index * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });
	
	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });
	    };
	
	    Slick.prototype.setHeight = function () {
	
	        var _ = this;
	
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }
	    };
	
	    Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {
	
	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */
	
	        var _ = this,
	            l,
	            item,
	            option,
	            value,
	            refresh = false,
	            type;
	
	        if ($.type(arguments[0]) === 'object') {
	
	            option = arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';
	        } else if ($.type(arguments[0]) === 'string') {
	
	            option = arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];
	
	            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {
	
	                type = 'responsive';
	            } else if (typeof arguments[1] !== 'undefined') {
	
	                type = 'single';
	            }
	        }
	
	        if (type === 'single') {
	
	            _.options[option] = value;
	        } else if (type === 'multiple') {
	
	            $.each(option, function (opt, val) {
	
	                _.options[opt] = val;
	            });
	        } else if (type === 'responsive') {
	
	            for (item in value) {
	
	                if ($.type(_.options.responsive) !== 'array') {
	
	                    _.options.responsive = [value[item]];
	                } else {
	
	                    l = _.options.responsive.length - 1;
	
	                    // loop through the responsive object and splice out duplicates.
	                    while (l >= 0) {
	
	                        if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
	
	                            _.options.responsive.splice(l, 1);
	                        }
	
	                        l--;
	                    }
	
	                    _.options.responsive.push(value[item]);
	                }
	            }
	        }
	
	        if (refresh) {
	
	            _.unload();
	            _.reinit();
	        }
	    };
	
	    Slick.prototype.setPosition = function () {
	
	        var _ = this;
	
	        _.setDimensions();
	
	        _.setHeight();
	
	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }
	
	        _.$slider.trigger('setPosition', [_]);
	    };
	
	    Slick.prototype.setProps = function () {
	
	        var _ = this,
	            bodyStyle = document.body.style;
	
	        _.positionProp = _.options.vertical === true ? 'top' : 'left';
	
	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }
	
	        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }
	
	        if (_.options.fade) {
	            if (typeof _.options.zIndex === 'number') {
	                if (_.options.zIndex < 3) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }
	
	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
	    };
	
	    Slick.prototype.setSlideClasses = function (index) {
	
	        var _ = this,
	            centerOffset,
	            allSlides,
	            indexOffset,
	            remainder;
	
	        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
	
	        _.$slides.eq(index).addClass('slick-current');
	
	        if (_.options.centerMode === true) {
	
	            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
	
	            centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	            if (_.options.infinite === true) {
	
	                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
	                    _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
	                } else {
	
	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
	                }
	
	                if (index === 0) {
	
	                    allSlides.eq(_.options.slidesToShow + _.slideCount + 1).addClass('slick-center');
	                } else if (index === _.slideCount - 1) {
	
	                    allSlides.eq(_.options.slidesToShow).addClass('slick-center');
	                }
	            }
	
	            _.$slides.eq(index).addClass('slick-center');
	        } else {
	
	            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
	
	                _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
	            } else if (allSlides.length <= _.options.slidesToShow) {
	
	                allSlides.addClass('slick-active').attr('aria-hidden', 'false');
	            } else {
	
	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
	
	                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
	
	                    allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
	                } else {
	
	                    allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
	                }
	            }
	        }
	
	        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
	            _.lazyLoad();
	        }
	    };
	
	    Slick.prototype.setupInfinite = function () {
	
	        var _ = this,
	            i,
	            slideIndex,
	            infiniteCount;
	
	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }
	
	        if (_.options.infinite === true && _.options.fade === false) {
	
	            slideIndex = null;
	
	            if (_.slideCount > _.options.slidesToShow) {
	
	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }
	
	                for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
	                    $(this).attr('id', '');
	                });
	            }
	        }
	    };
	
	    Slick.prototype.interrupt = function (toggle) {
	
	        var _ = this;
	
	        if (!toggle) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;
	    };
	
	    Slick.prototype.selectHandler = function (event) {
	
	        var _ = this;
	
	        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
	
	        var index = parseInt(targetElement.attr('data-slick-index'));
	
	        if (!index) index = 0;
	
	        if (_.slideCount <= _.options.slidesToShow) {
	
	            _.slideHandler(index, false, true);
	            return;
	        }
	
	        _.slideHandler(index);
	    };
	
	    Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
	
	        var targetSlide,
	            animSlide,
	            oldSlide,
	            slideLeft,
	            targetLeft = null,
	            _ = this,
	            navTarget;
	
	        sync = sync || false;
	
	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }
	
	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }
	
	        if (sync === false) {
	            _.asNavFor(index);
	        }
	
	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);
	
	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
	
	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function () {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function () {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }
	
	        if (_.options.autoplay) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }
	
	        _.animating = true;
	
	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
	
	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;
	
	        _.setSlideClasses(_.currentSlide);
	
	        if (_.options.asNavFor) {
	
	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');
	
	            if (navTarget.slideCount <= navTarget.options.slidesToShow) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }
	        }
	
	        _.updateDots();
	        _.updateArrows();
	
	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {
	
	                _.fadeSlideOut(oldSlide);
	
	                _.fadeSlide(animSlide, function () {
	                    _.postSlide(animSlide);
	                });
	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }
	
	        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	            _.animateSlide(targetLeft, function () {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }
	    };
	
	    Slick.prototype.startLoad = function () {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.hide();
	            _.$nextArrow.hide();
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.hide();
	        }
	
	        _.$slider.addClass('slick-loading');
	    };
	
	    Slick.prototype.swipeDirection = function () {
	
	        var xDist,
	            yDist,
	            r,
	            swipeAngle,
	            _ = this;
	
	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);
	
	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }
	
	        if (swipeAngle <= 45 && swipeAngle >= 0) {
	            return _.options.rtl === false ? 'left' : 'right';
	        }
	        if (swipeAngle <= 360 && swipeAngle >= 315) {
	            return _.options.rtl === false ? 'left' : 'right';
	        }
	        if (swipeAngle >= 135 && swipeAngle <= 225) {
	            return _.options.rtl === false ? 'right' : 'left';
	        }
	        if (_.options.verticalSwiping === true) {
	            if (swipeAngle >= 35 && swipeAngle <= 135) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }
	
	        return 'vertical';
	    };
	
	    Slick.prototype.swipeEnd = function (event) {
	
	        var _ = this,
	            slideCount,
	            direction;
	
	        _.dragging = false;
	        _.swiping = false;
	
	        if (_.scrolling) {
	            _.scrolling = false;
	            return false;
	        }
	
	        _.interrupted = false;
	        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
	
	        if (_.touchObject.curX === undefined) {
	            return false;
	        }
	
	        if (_.touchObject.edgeHit === true) {
	            _.$slider.trigger('edge', [_, _.swipeDirection()]);
	        }
	
	        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
	
	            direction = _.swipeDirection();
	
	            switch (direction) {
	
	                case 'left':
	                case 'down':
	
	                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
	
	                    _.currentDirection = 0;
	
	                    break;
	
	                case 'right':
	                case 'up':
	
	                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
	
	                    _.currentDirection = 1;
	
	                    break;
	
	                default:
	
	            }
	
	            if (direction != 'vertical') {
	
	                _.slideHandler(slideCount);
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction]);
	            }
	        } else {
	
	            if (_.touchObject.startX !== _.touchObject.curX) {
	
	                _.slideHandler(_.currentSlide);
	                _.touchObject = {};
	            }
	        }
	    };
	
	    Slick.prototype.swipeHandler = function (event) {
	
	        var _ = this;
	
	        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }
	
	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
	
	        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
	        }
	
	        switch (event.data.action) {
	
	            case 'start':
	                _.swipeStart(event);
	                break;
	
	            case 'move':
	                _.swipeMove(event);
	                break;
	
	            case 'end':
	                _.swipeEnd(event);
	                break;
	
	        }
	    };
	
	    Slick.prototype.swipeMove = function (event) {
	
	        var _ = this,
	            edgeWasHit = false,
	            curLeft,
	            swipeDirection,
	            swipeLength,
	            positionOffset,
	            touches,
	            verticalSwipeLength;
	
	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
	
	        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
	            return false;
	        }
	
	        curLeft = _.getLeft(_.currentSlide);
	
	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
	
	        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
	
	        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
	
	        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
	            _.scrolling = true;
	            return false;
	        }
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = verticalSwipeLength;
	        }
	
	        swipeDirection = _.swipeDirection();
	
	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            _.swiping = true;
	            event.preventDefault();
	        }
	
	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }
	
	        swipeLength = _.touchObject.swipeLength;
	
	        _.touchObject.edgeHit = false;
	
	        if (_.options.infinite === false) {
	            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }
	
	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }
	
	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }
	
	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }
	
	        _.setCSS(_.swipeLeft);
	    };
	
	    Slick.prototype.swipeStart = function (event) {
	
	        var _ = this,
	            touches;
	
	        _.interrupted = true;
	
	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }
	
	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }
	
	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
	
	        _.dragging = true;
	    };
	
	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
	
	        var _ = this;
	
	        if (_.$slidesCache !== null) {
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.appendTo(_.$slideTrack);
	
	            _.reinit();
	        }
	    };
	
	    Slick.prototype.unload = function () {
	
	        var _ = this;
	
	        $('.slick-cloned', _.$slider).remove();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }
	
	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }
	
	        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
	    };
	
	    Slick.prototype.unslick = function (fromBreakpoint) {
	
	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();
	    };
	
	    Slick.prototype.updateArrows = function () {
	
	        var _ = this,
	            centerOffset;
	
	        centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
	
	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            if (_.currentSlide === 0) {
	
	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            }
	        }
	    };
	
	    Slick.prototype.updateDots = function () {
	
	        var _ = this;
	
	        if (_.$dots !== null) {
	
	            _.$dots.find('li').removeClass('slick-active').end();
	
	            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
	        }
	    };
	
	    Slick.prototype.visibility = function () {
	
	        var _ = this;
	
	        if (_.options.autoplay) {
	
	            if (document[_.hidden]) {
	
	                _.interrupted = true;
	            } else {
	
	                _.interrupted = false;
	            }
	        }
	    };
	
	    $.fn.slick = function () {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if ((typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };
	});

/***/ },
/* 89 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 90 */,
/* 91 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 99 */,
/* 100 */,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; /* eslint-disable */
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Dropdown = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        placeholder: '请选择'
	    }
	}), _dec(_class = function () {
	    function Dropdown() {
	        _classCallCheck(this, Dropdown);
	
	        this.value = "";
	        this.label = "";
	        this.open = false;
	    }
	
	    Dropdown.prototype.onInit = function onInit() {
	        var _this = this;
	
	        var dom = this.dom;
	        var options = this.options;
	
	        (0, _jquery2.default)(dom).on("click", ".Dropdown-data", function (e) {
	            _this.value = (0, _jquery2.default)(e.target).data('value');
	            _this.label = (0, _jquery2.default)(e.target).text();
	            _this.open = false;
	            _this.render();
	            (0, _jquery2.default)(_this.dom).trigger('change', [_this.value, _this.label]);
	        });
	
	        (0, _jquery2.default)(dom).on("click", ".Dropdown-label", function (e) {
	            _this.open = !_this.open;
	            _this.render();
	        });
	
	        (0, _jquery2.default)(document).on("click", function (e) {
	            if ((0, _jquery2.default)(e.target).parents(".Dropdown").length === 0) {
	                _this.open = false;
	                _this.render();
	            }
	        });
	
	        this.render();
	    };
	
	    Dropdown.prototype.render = function render() {
	        this.inputDom.val(this.value);
	        this.labelDom.text(this.label || this.options.placeholder || "");
	
	        if (this.open) {
	            (0, _jquery2.default)(this.dom).addClass("open");
	        } else {
	            (0, _jquery2.default)(this.dom).removeClass("open");
	        }
	    };
	
	    _createClass(Dropdown, [{
	        key: 'popperDom',
	        get: function get() {
	            return (0, _jquery2.default)(".Dropdown-popper", this.dom);
	        }
	    }, {
	        key: 'labelDom',
	        get: function get() {
	            return (0, _jquery2.default)(".Dropdown-label", this.dom);
	        }
	    }, {
	        key: 'inputDom',
	        get: function get() {
	            return (0, _jquery2.default)("input:hidden", this.dom);
	        }
	    }]);
	
	    return Dropdown;
	}()) || _class);
	exports.default = Dropdown;

/***/ },
/* 102 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 103 */,
/* 104 */,
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $ = __webpack_require__(1);
	
	var Collapse = (_dec = _Sloth2.default.component({
	    defaultOptions: {}
	}), _dec(_class = function () {
	    function Collapse() {
	        _classCallCheck(this, Collapse);
	    }
	
	    Collapse.prototype.onInit = function onInit() {
	        var obj = this.dom;
	        var options = this.options;
	
	        $(obj).on("click", ".Collapse-label", function (e) {
	            $(e.delegateTarget).toggleClass("open");
	        });
	    };
	
	    return Collapse;
	}()) || _class);
	exports.default = Collapse;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(107);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Drawer = (_dec = _Sloth2.default.component({
	    defaultOptions: {}
	}), _dec(_class = function () {
	    function Drawer() {
	        _classCallCheck(this, Drawer);
	
	        this.title = undefined;
	        this.body = undefined;
	    }
	
	    Drawer.prototype.onInit = function onInit() {
	        var _this = this;
	
	        var dom = this.dom;
	        var self = this;
	        if ((0, _jquery2.default)('.Drawer-wrapper', dom).length === 0) (0, _jquery2.default)('<div class="Drawer-wrapper"><h1 class="Drawer-title"></h1><div class="Drawer-body"></div></div>').appendTo(dom);
	        (0, _jquery2.default)('<button class=\'Drawer-close\'></button>').appendTo('.Drawer-wrapper', dom);
	
	        (0, _jquery2.default)(dom).on('click', '.Drawer-close', function () {
	            self.hide();
	        });
	
	        // 点遮罩关闭
	        (0, _jquery2.default)(dom).on('click', function (evt) {
	            if (!(0, _jquery2.default)(evt.target).is('.Drawer')) return;
	            _this.hide();
	        });
	    };
	
	    Drawer.prototype.show = function show(options) {
	        var _ref = options || {},
	            title = _ref.title,
	            body = _ref.body;
	
	        if (title) this.title = title;
	        if (body) this.body = body;
	
	        this.render();
	        (0, _jquery2.default)(this.dom).show();
	    };
	
	    Drawer.prototype.render = function render() {
	        (0, _jquery2.default)('.Drawer-title', this.dom).css({ display: this.title ? "flex" : 'none' });
	        (0, _jquery2.default)('.Drawer-body', this.dom).css({ display: this.body ? "block" : 'none' });
	
	        (0, _jquery2.default)('.Drawer-title', this.dom).text(this.title);
	        (0, _jquery2.default)('.Drawer-body', this.dom).html(this.body);
	    };
	
	    Drawer.prototype.hide = function hide() {
	        (0, _jquery2.default)(this.dom).hide();
	        (0, _jquery2.default)(".Drawer-body", this.dom).html("");
	    };
	
	    return Drawer;
	}()) || _class);
	exports.default = Drawer;

/***/ },
/* 107 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 108 */,
/* 109 */,
/* 110 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 111 */,
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	__webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CourseCard = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        stars: 0
	    }
	}), _dec(_class = function () {
	    function CourseCard() {
	        _classCallCheck(this, CourseCard);
	    }
	
	    CourseCard.prototype.onInit = function onInit() {
	        var options = this.options;
	        $(this.dom).append("<div class='CourseCard-footer'></div>");
	        this.renderStars(options.stars);
	    };
	
	    CourseCard.prototype.renderStars = function renderStars(stars) {
	
	        for (var i = 0; i < stars; i++) {
	            $(".CourseCard-footer", this.dom).append("<div class='CourseCard-star'></div>");
	        }
	
	        for (var _i = 0; _i < 5 - stars; _i++) {
	            $(".CourseCard-footer", this.dom).append("<div class='CourseCard-star CourseCard-star_empty'></div>");
	        }
	    };
	
	    return CourseCard;
	}()) || _class);
	exports.default = CourseCard;

/***/ },
/* 113 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(118);

/***/ },
/* 118 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(128);

/***/ },
/* 128 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 129 */,
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(131);

/***/ },
/* 131 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(136);

/***/ },
/* 136 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 137 */,
/* 138 */,
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(140);

/***/ },
/* 140 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(147);
	
	__webpack_require__(149);
	
	__webpack_require__(152);
	
	__webpack_require__(157);
	
	__webpack_require__(160);
	
	__webpack_require__(163);
	
	__webpack_require__(164);
	
	__webpack_require__(168);
	
	__webpack_require__(171);
	
	__webpack_require__(179);

/***/ },
/* 147 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 148 */,
/* 149 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 150 */,
/* 151 */,
/* 152 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 158 */,
/* 159 */,
/* 160 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 161 */,
/* 162 */,
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 移动端不启用轮播(教学点竖向排列), 需在 Sloth.init 之前移除组件标记
	(0, _jquery2.default)(function () {
	    if (_Sloth2.default.isMobile()) {
	        (0, _jquery2.default)('.Jxd-carousel').removeAttr('component');
	    }
	});

/***/ },
/* 164 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 169 */,
/* 170 */,
/* 171 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var XueLiCourseList = (_dec = _Sloth2.default.component({
	    defaultOptions: {}
	}), _dec(_class = function () {
	    function XueLiCourseList() {
	        _classCallCheck(this, XueLiCourseList);
	
	        this.type = '';
	    }
	
	    XueLiCourseList.prototype.onInit = function onInit() {
	        var _this = this;
	
	        var self = this;
	        var dom = this.dom;
	
	        $(".XueLiCourseList-filter", this.dom).prepend("<div class='XueLiCourseList-filter-label'></div>");
	
	        $(".XueLiCourseList-filter", dom).on("click", 'button', function () {
	            self.type = $(this).data("type");
	            self.render();
	            $(".XueLiCourseList-filter", this.dom).removeClass("open");
	        });
	
	        $(this.dom).on("click", '.XueLiCourseList-filter-label', function () {
	            $(".XueLiCourseList-filter", _this.dom).toggleClass("open");
	        });
	
	        $(document.body).on("click", function (e) {
	            if ($(e.target).parents(".XueLiCourseList-filter").length === 0) {
	                $(".XueLiCourseList-filter", _this.dom).removeClass("open");
	            }
	        });
	
	        this.type = $(".XueLiCourseList-filter", this.dom).data('value');
	        self.render();
	    };
	
	    XueLiCourseList.prototype.filterList = function filterList() {
	        var dom = this.dom;
	        var type = this.type;
	
	        $(".CourseCard", dom).each(function (index, item) {
	            if (type && type !== $(item).data("type")) {
	                $(item).parent().hide();
	            } else {
	                $(item).parent().show();
	            }
	        });
	
	        $(".XueLiCourseList-filter-label", this.dom).text(this.currentData.label);
	    };
	
	    XueLiCourseList.prototype.render = function render() {
	        var _this2 = this;
	
	        $(".XueLiCourseList-filter button", this.dom).each(function (index, item) {
	            var type = $(item).data('type');
	            if (type === _this2.type) $(item).addClass("current");else $(item).removeClass("current");
	        });
	
	        $(".XueLiCourseList-filter", this.dom).data("value", this.type);
	        this.filterList();
	    };
	
	    _createClass(XueLiCourseList, [{
	        key: "typeList",
	        get: function get() {
	            var data = [];
	
	            $(".XueLiCourseList-filter button", this.dom).each(function (index, item) {
	                var value = $(item).data("type");
	                var label = $(item).text();
	                data.push({ value: value, label: label });
	            });
	            return data;
	        }
	    }, {
	        key: "currentData",
	        get: function get() {
	            var _this3 = this;
	
	            return this.typeList.find(function (item) {
	                return item.value === _this3.type;
	            });
	        }
	    }]);
	
	    return XueLiCourseList;
	}()) || _class);
	exports.default = XueLiCourseList;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(181);
	
	__webpack_require__(187);
	
	__webpack_require__(195);
	
	__webpack_require__(198);

/***/ },
/* 181 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 196 */,
/* 197 */,
/* 198 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	__webpack_require__(204);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Special = (_dec = _Sloth2.default.component({
	    defaultOptions: {}
	}), _dec(_class = function () {
	    function Special() {
	        _classCallCheck(this, Special);
	
	        this.open = false;
	    }
	
	    Special.prototype.onInit = function onInit() {
	        var _this = this;
	
	        if (window.screen.width > 720) return;
	
	        $(".Special-aside", this.dom).prepend($(".Special-aside-link.current", this.dom));
	
	        $(document.body).on("click", function (e) {
	            if ($(e.target).parents(".Special-aside").length === 0) {
	                _this.open = false;
	                _this.render();
	            }
	        });
	
	        $(this.dom).on("click", ".Special-aside-link.current", function (e) {
	            e.preventDefault();
	            _this.open = !_this.open;
	            _this.render();
	        });
	    };
	
	    Special.prototype.render = function render() {
	        if (this.open) $(".Special-aside", this.dom).addClass("open");else $(".Special-aside", this.dom).removeClass("open");
	    };
	
	    return Special;
	}()) || _class);
	exports.default = Special;

/***/ },
/* 204 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(209);

/***/ },
/* 209 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 210 */,
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(212);

/***/ },
/* 212 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 213 */,
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(215);

/***/ },
/* 215 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 216 */,
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(218);

/***/ },
/* 218 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 219 */,
/* 220 */,
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(222);

/***/ },
/* 222 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 223 */,
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class;
	
	__webpack_require__(225);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaiKe = (_dec = _Sloth2.default.component({
	    defaultOptions: {
	        stars: 0
	    }
	}), _dec(_class = function () {
	    function BaiKe() {
	        _classCallCheck(this, BaiKe);
	    }
	
	    BaiKe.prototype.onInit = function onInit() {};
	
	    return BaiKe;
	}()) || _class);
	exports.default = BaiKe;

/***/ },
/* 225 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(232);

/***/ },
/* 232 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	__webpack_require__(240);
	
	var _Sloth = __webpack_require__(3);
	
	var _Sloth2 = _interopRequireDefault(_Sloth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HeaderSearch = (_dec = _Sloth2.default.component({
	    defaultOptions: {}
	}), _dec(_class = function () {
	    function HeaderSearch() {
	        _classCallCheck(this, HeaderSearch);
	
	        this.open = false;
	    }
	
	    HeaderSearch.prototype.onInit = function onInit() {
	        var _this = this;
	
	        $(this.dom).on("click", function (e) {
	            if (_this.open && !$(e.target).is("input") && _this.inputText) return _this.submit();
	
	            _this.open = true;
	            $("input", _this.dom).focus();
	            _this.render();
	        });
	
	        $(document.body).on("click", function (e) {
	            if ($(e.target).is(".Header-search")) return;
	
	            if ($(e.target).parents(".Header-search").length === 0) {
	                _this.open = false;
	                _this.render();
	            }
	        });
	    };
	
	    HeaderSearch.prototype.submit = function submit() {
	        $(this.dom).submit();
	    };
	
	    HeaderSearch.prototype.render = function render() {
	        if (this.open) $(this.dom).addClass("open");else $(this.dom).removeClass("open");
	    };
	
	    _createClass(HeaderSearch, [{
	        key: "inputText",
	        get: function get() {
	            return $("input", this.dom).val().trim() || '';
	        }
	    }]);
	
	    return HeaderSearch;
	}()) || _class);
	exports.default = HeaderSearch;

/***/ },
/* 240 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 241 */,
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(243);

/***/ },
/* 243 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** front/js/main.js
 **/